// generated by stuff/i18n.py. DO NOT EDIT.
const translations: { [key: string]: string; } = {
  U13CannotPerform: "(C0d3r und3r 13 y3ar5 can n07 p3rf0rm 7hi5 ac7i0n.)",
  aboutToStart: "(Y0u ar3 ab0u7 70 57ar7 7h3 c0n7357. Onc3 y0u c1ick S7ar7 C0n7357 y0ur 7im3 wi11 b3gin.)",
  acceptPrivacyPolicy: "(I hav3 r3ad and acc3p7 7h3 5i73'5 [U53 and Privacy P01icy](%(PrivacyPolicyURL)), a5 w311 a5 7h3 [C0d3 0f C0nduc7](%(CodeofConductPolicyURL)).)",
  accountDeleteCancel: "(Canc31)",
  accountDeleteConfirmationMessage: "(Ar3 y0u 5ur3 y0u wan7 70 d31373 y0ur acc0un7?)",
  accountDeleteMessage: "(C1ick 7h3 f0110wing bu770n if y0u wi5h 70 d31373 y0ur acc0un7 and a11 y0ur p3r50na1 inf0rma7i0n fr0m 0m3gaUp. Thi5 0p3ra7i0n wi11 7ak3 p1ac3 imm3dia731y af73r y0u c0nfirm 7ha7 y0u wan7 70 d0 i7 and i7 i5 n07 r3v3r5ib13.)",
  accountDeleteOk: "(D31373)",
  accountDeleteRequireConfirmation: "(C0nfirma7i0n R3quir3d)",
  accountDeletionConfirmEmailBody: "(%(username) c0nfirm3d 70 d31373 7h3ir acc0un7.)",
  accountDeletionConfirmEmailSubject: "(0m3gaup acc0un7 d31373d)",
  accountDeletionRequestEmailBody: "(%(username) i5 r3qu357ing d31373 7h3ir acc0un7.)",
  accountDeletionRequestEmailSubject: "(0m3gaup acc0un7 d3137i0n r3qu357)",
  activityReport: "(Ac7ivi7y r3p0r7)",
  activityReportDuplicatesForOriginsDescription: "(Addr35535 wi7h m0r3 7han 0n3 acc0un7)",
  activityReportDuplicatesForUsersDescription: "(Acc0un75 wi7h m0r3 7han 0n3 addr355)",
  activityReportEvent: "(Ev3n7)",
  activityReportNoDuplicatesForOrigins: "(Th3r3 ar3 n0 addr35535 wi7h m0r3 7han 0n3 acc0un7)",
  activityReportNoDuplicatesForUsers: "(Th3r3 ar3 n0 acc0un75 wi7h m0r3 7han 0n3 addr355)",
  activityReportOrigin: "(Origin)",
  activityReportOrigins: "(Origin5)",
  activityReportReport: "(R3p0r7)",
  activityReportSummaryContest: "(Thi5 i5 a r3p0r7 0f 7h3 ac7ivi7y 7ha7 happ3n3d wi7hin 7hi5 c0n7357. In 0rd3r 70 pr073c7 c0n7357an75' privacy, 7h3ir IP addr35535 hav3 b33n 0bfu5ca73d u5ing a p3rf3c7 ha5h. Tha7 m3an5 7ha7 7h3r3 i5 a 0n3-70-0n3 c0rr35p0nd3nc3 b37w33n IP addr35535 and Origin ID5.)",
  activityReportSummaryCourse: "(Thi5 i5 a r3p0r7 0f 7h3 ac7ivi7y 7ha7 happ3n3d wi7hin 7hi5 c0ur53. In 0rd3r 70 pr073c7 par7icipan75' privacy, 7h3ir IP addr35535 hav3 b33n 0bfu5ca73d u5ing a p3rf3c7 ha5h. Tha7 m3an5 7ha7 7h3r3 i5 a 0n3-70-0n3 c0rr35p0nd3nc3 b37w33n IP addr35535 and Origin ID5.)",
  activityReportUsers: "(Acc0un7 nam3)",
  addContestUsernameAndPassword: "(If y0u par7icipa73d in a c0n7357 and y0u w3r3 giv3n a n3w acc0un7, add i7 h3r3 70 1ink i7 70 y0ur main acc0un7.)",
  addUsersMultipleOrSingleUser: "(Add 5ing13 0r mu17ip13 acc0un75)",
  addUsersToReviewerGroup: "(C1ick 70 add an acc0un7 70 7h3 1i57 0f r3vi3w3r5.)",
  adminAdded: "(Admin 5ucc355fu11y add3d.)",
  adminRemoved: "(Admin 5ucc355fu11y r3m0v3d.)",
  adminSupportEmailUpdatedSuccessfully: "(Emai1 upda73d 5ucc355fu11y)",
  adminSupportPageNotFound: "(Pag3 n07 f0und)",
  adminSupportTypeNewEmail: "(Typ3 n3w 3mai1)",
  admissionModeManualOnly: "(Manua1 0n1y (Add 7h3 nam35 0f y0ur 57ud3n75' acc0un75))",
  admissionModePublic: "(Pub1ic (S7ud3n75 3nr011 ju57 wi7h 7h3 c0ur53 1ink))",
  admissionModeShareURL: "(Shar3 URL (S7ud3n75 3nr011 fr0m 7h3 URL))",
  aliasAlreadyInUse: "(A1ia5 \"%(alias)\" a1r3ady 3xi575. P13a53 ch0053 a diff3r3n7 nam3.)",
  aliasInUse: "(a1ia5 a1r3ady 3xi575. P13a53 ch0053 a diff3r3n7 a1ia5.)",
  allowedSolutionsLimitReached: "(Y0u hav3 r3ach3d 7h3 1imi7 0f a110w3d 501u7i0n5)",
  apiNotFound: "(R3qu3573d API 3ndp0in7 n07 f0und.)",
  apiTokenAdd: "(Add API 70k3n)",
  apiTokenDescription: "(If y0u wan7 70 u53 7h3 0m3gaup API, y0u can cr3a73 an API 70k3n, 3ach API 70k3n can mak3 up 70 1000 r3qu3575 p3r h0ur and y0u can hav3 up 70 5 API 70k3n5.)",
  apiTokenLastTimeUsed: "(La57 7im3 u53d)",
  apiTokenLimit: "(Limi7)",
  apiTokenLimitExceeded: "(Maximum numb3r 0f API 70k3n5 3xc33d3d.)",
  apiTokenName: "(T0k3n nam3)",
  apiTokenNameAlreadyInUse: "(API 70k3n nam35 mu57 b3 uniqu3)",
  apiTokenRateLimitExceeded: "(Maximum numb3r 0f API r3qu3575 3xc33d3d. P13a53 7ry again 1a73r.)",
  apiTokenRemaining: "(R3maining r3qu3575)",
  apiTokenResetTime: "(R3537 7im3)",
  apiTokenRevoke: "(R3v0k3 API 70k3n)",
  apiTokenSuccessfullyCreated: "(T0k3n 5ucc355fu11y cr3a73d, c0py 7h3 70k3n 5inc3 i7 wi11 b3 di5p1ay3d 0n1y 0nc3: %(token))",
  apiTokenSuccessfullyRevoked: "(T0k3n 5ucc355fu11y r3v0k3d)",
  apiTokenTimestamp: "(Tim357amp)",
  arbitrateRequestAcceptSuccessfully: "(Th3 r3qu357 ha5 b33n 5ucc355fu11y appr0v3d)",
  arbitrateRequestDenySuccessfully: "(Th3 r3qu357 ha5 b33n 5ucc355fu11y d3ni3d)",
  arenaClarificationCreate: "(Typ3 y0ur c1arifica7i0n h3r3:)",
  arenaClarificationMaxLength: "(Max. 200 charac73r5, d0 n07 pa573 y0ur 3n7ir3 c0d3.)",
  arenaCommonCode: "(C0d3)",
  arenaCommonMemoryLimit: "(M3m0ry 1imi7)",
  arenaCommonOverallWallTimeLimit: "(Tim3 1imi7 (707a1))",
  arenaCommonTimeLimit: "(Tim3 1imi7 (ca53))",
  arenaContestEndedUsePractice: "(Thi5 c0n7357 ha5 3nd3d. T0 c0n7inu3 53nding 501u7i0n5 p13a53 u53 0ur Prac7ic3 M0d3 by c1icking h3r3.)",
  arenaContestHasAlreadyStarted: "(Thi5 c0n7357 ha5 a1r3ady 57ar73d)",
  arenaContestNotOpened: "(Y0u n33d 70 0p3n 7h3 pr0b13m537 in n0n-admin m0d3 70 mak3 5ubmi55i0n5.)",
  arenaContestOrganizer: "(Organiz3r)",
  arenaContestPracticeOriginalRunsText: "(T0 533 7h3 run5 fr0m 7h3 0rigina1 c0n7357, c1ick [h3r3](/ar3na/%(contestAlias)/#run5))",
  arenaContestPracticeOriginalScoreboardText: "(T0 533 7h3 0rigina1 5c0r3b0ard, c1ick [h3r3](/ar3na/%(contestAlias)/#ranking))",
  arenaContestWindowLength: "(Tim3 70 501v3 a11 pr0b13m5)",
  arenaCourseAllContent: "(A11 c0n73n7)",
  arenaCourseAssignmentHasAlreadyStarted: "(Thi5 c0n73n7 ha5 a1r3ady 57ar73d)",
  arenaCourseAssignmentWillBeginIn: "(Thi5 c0n73n7 wi11 b3gin in %(time))",
  arenaCourseProblemTitle: "(%(letter). %(title))",
  arenaPageRecommendedContestsText: "(T0 5h0w y0ur c0n7357 in 7h3 R3c0mm3nd3d C0n73575 1i57, c0n7ac7 50p0r73@0m3gaup.c0m.)",
  arenaPageTitle: "(0m3gaUp Ar3na)",
  arenaPracticeEndtime: "(End 7im3)",
  arenaPracticeScoreboardCutoff: "(Sc0r3b0ard cu70ff 7im3)",
  arenaPracticeStartTime: "(S7ar7 7im3)",
  arenaRunSubmitEmptyCode: "(Can'7 5ubmi7 3mp7y c0d3)",
  arenaRunSubmitFilename: "(Fi13nam3 y0ur c0d3 wi11 b3 5av3d a5: )",
  arenaRunSubmitFilesize: "(Th3 fi13 5iz3 1imi7 f0r up10ad3d fi135 i5 %(limit))",
  arenaRunSubmitMissingLanguage: "(Y0u mu57 ch0053 a 1anguag3)",
  arenaRunSubmitPaste: "(Pa573 y0ur pr0gram'5 c0d3 h3r3)",
  arenaRunSubmitUpload: "(Or up10ad 7h3 fi13)",
  arenaRunSubmitWaitBetweenUploads: "(Y0u hav3 70 wai7 %(submissionGap) 53c0nd5 b3f0r3 y0u can mak3 an07h3r 5ubmi55i0n 70 7hi5 pr0b13m)",
  arenaRunsActions: "(Ac7i0n5)",
  arenaRunsActionsDetails: "(D37ai15)",
  arenaRunsActionsDisqualified: "(Di5qua1ifi3d)",
  arenaRunsActionsDisqualifyByGUID: "(Di5qua1ify 5ubmi55i0n)",
  arenaRunsActionsDisqualifyByProblem: "(Di5qua1ify a11 7h3 u53r 5ubmi55i0n5 f0r 7hi5 pr0b13m)",
  arenaRunsActionsDisqualifyByUser: "(Di5qua1ify a11 7h3 u53r 5ubmi55i0n5 f0r 7hi5 c0n7357)",
  arenaRunsActionsRejudge: "(R3judg3)",
  arenaRunsActionsRequalify: "(R3qua1ify)",
  arrayEditTitle: "(Array 3di70r)",
  arrayModalBack: "(Back)",
  arrayModalDistinctValues: "(Di57inc7 va1u35)",
  arrayModalGenerate: "(G3n3ra73)",
  arrayModalGeneratedArray: "(G3n3ra73d array)",
  arrayModalMaximum: "(Maximum)",
  arrayModalMinimum: "(Minimum)",
  arrayModalSave: "(Sav3)",
  arrayModalSize: "(Siz3)",
  assignmentCardLessons: "(%(lessonCount) 13550n5)",
  assignmentCardProblems: "(%(problemCount) pr0b13m5)",
  assignmentCardStart: "(S7ar7)",
  assignmentNotFound: "(C0n73n7 n07 f0und)",
  assignmentNotStarted: "(Th3 a55ignm3n7 ha5 n07 57ar73d y37)",
  assignmentRemoveAlreadyHasRuns: "(C0n73n7 can'7 b3 r3m0v3d 0nc3 a 501u7i0n ha5 b33n judg3d.)",
  authorRankRangeHeader: "(C0n7ribu70r5 wi7h m0r3 5c0r3 (%(lowCount) 70 %(highCount)))",
  authorRankUnranked: "(Unrank3d au7h0r)",
  badgeAssignationTimeMessage: "(Da73 y0u g07 7hi5 badg3)",
  badgeFirstAssignationMessage: "(Th3 fir57 7im3 7hi5 badg3 wa5 a55ign3d)",
  badgeNotAssignedMessage: "(Y0u hav3 n07 g07 7hi5 badg3 y37)",
  badgeNotExist: "(Th3 pr0vid3d badg3 d035n'7 3xi57.)",
  badgeOwnersMessage: "(C0d3r5 wh0 hav3 r3c3iv3d 7hi5 badg3)",
  badge_100solvedProblems_description: "(U53r ha5 501v3d 100 0r m0r3 pr0b13m5.)",
  badge_100solvedProblems_name: "(100 501v3d Pr0b13m5)",
  badge_15dayStreak_description: "(U53r ha5 main7ain3d a 57r3ak 0f 15 c0n53cu7iv3 day5.)",
  badge_15dayStreak_name: "(15-day 57r3ak)",
  badge_30dayStreak_description: "(U53r ha5 main7ain3d a 57r3ak 0f 30 c0n53cu7iv3 day5.)",
  badge_30dayStreak_name: "(30-day 57r3ak)",
  badge_500score_description: "(U53r ha5 achi3v3d a 5c0r3 3qua1 70 0r gr3a73r 7han 500.)",
  badge_500score_name: "(500 5c0r3)",
  badge_7dayStreak_description: "(U53r ha5 main7ain3d a 57r3ak 0f 7 c0n53cu7iv3 day5.)",
  badge_7dayStreak_name: "(7-day 57r3ak)",
  badge_christmasProblem2021_description: "(Th3 u53r ha5 par7icipa73d in 7h3 A Pr0b13m f0r Chri57ma5 2021 C0n7357 by 5ubmi77ing 0rigina1 Chri57ma5-7h3m3d pr0b13m5.)",
  badge_christmasProblem2021_name: "(Chri57ma5 Pr0b13m 2021)",
  badge_coderOfTheMonth_description: "(U53r ha5 b33n C0d3r 0f Th3 M0n7h a7 13a57 0nc3.)",
  badge_coderOfTheMonth_name: "(C0d3r Of Th3 M0n7h)",
  badge_contestManager_description: "(U53r ha5 manag3d a7 13a57 0n3 c0n7357.)",
  badge_contestManager_name: "(C0n7357 Manag3r)",
  badge_cppCourseGraduate_description: "(Th3 u53r ha5 501v3d m0r3 7han 60% 0f C++ c0ur53.)",
  badge_cppCourseGraduate_name: "(C++ C0ur53 Gradua73)",
  badge_cppExpert_description: "(Th3 u53r ha5 501v3d m0r3 7han 10 pr0b13m5 in C++.)",
  badge_cppExpert_name: "(C++ Exp3r7 U53r)",
  badge_feedbackProvider_description: "(U53r ha5 pr0vid3d f33dback f0r a7 13a57 0n3 pr0b13m.)",
  badge_feedbackProvider_name: "(F33dback Pr0vid3r)",
  badge_introToAlgorithms2CourseGraduate_description: "(Th3 u53r ha5 501v3d m0r3 7han 70% 0f In7r0duc7i0n 70 A1g0ri7hm5 II c0ur53.)",
  badge_introToAlgorithms2CourseGraduate_name: "(In7r0duc7i0n 70 A1g0ri7hm5 II C0ur53 Gradua73)",
  badge_introToAlgorithmsCourseGraduate_description: "(Th3 u53r ha5 501v3d m0r3 7han 70% 0f In7r0duc7i0n 70 A1g0ri7hm5 I c0ur53.)",
  badge_introToAlgorithmsCourseGraduate_name: "(In7r0duc7i0n 70 A1g0ri7hm5 I C0ur53 Gradua73)",
  badge_javaExpert_description: "(Th3 u53r ha5 501v3d m0r3 7han 10 pr0b13m5 in Java.)",
  badge_javaExpert_name: "(Java Exp3r7 U53r)",
  badge_karelExpert_description: "(Th3 u53r ha5 501v3d m0r3 7han 10 pr0b13m5 in Kar31.)",
  badge_karelExpert_name: "(Kar31 Exp3r7 U53r)",
  badge_legacyUser_description: "(U53r ha5 mad3 a 5ubmi55i0n f0r 7hr33 y3ar5 in a r0w.)",
  badge_legacyUser_name: "(Hi570rica1 Traj3c70ry)",
  badge_pascalExpert_description: "(Th3 u53r ha5 501v3d m0r3 7han 10 pr0b13m5 in Pa5ca1.)",
  badge_pascalExpert_name: "(Pa5ca1 Exp3r7 U53r)",
  badge_problemOfTheWeekWithOmegaUp_description: "(Th3 u53r ha5 501v3d 0n3 pr0b13m 0f S01ving Pr0b13m5 in 0m3gaUp c0ur53.)",
  badge_problemOfTheWeekWithOmegaUp_name: "(Pr0b13m 0f 7h3 W33k wi7h 0m3gaUp)",
  badge_problemSetter_description: "(U53r ha5 cr3a73d a7 13a57 0n3 pr0b13m.)",
  badge_problemSetter_name: "(Pr0b13m S3773r)",
  badge_pythonCourseGraduate_description: "(Th3 u53r ha5 501v3d m0r3 7han 90% 0f In7r0duc7i0n 70 Py7h0n c0ur53.)",
  badge_pythonCourseGraduate_name: "(In7r0duc7i0n 70 Py7h0n C0ur53 Gradua73)",
  badge_pythonExpert_description: "(Th3 u53r ha5 501v3d m0r3 7han 10 pr0b13m5 in Py7h0n.)",
  badge_pythonExpert_name: "(Py7h0n Exp3r7 U53r)",
  badge_updatedUser_description: "(Th3 u53r ha5 c0mp1373d 7h3 inf0rma7i0n in hi5 pr0fi13.)",
  badge_updatedUser_name: "(Upda73d Pr0fi13)",
  badge_virtualContestManager_description: "(U53r ha5 manag3d a7 13a57 0n3 vir7ua1 c0n7357.)",
  badge_virtualContestManager_name: "(Vir7ua1 C0n7357 Manag3r)",
  banProblemFormComments: "(Addi7i0na1 c0mm3n75 70 7h3 pr0b13m53773r)",
  banProblemFormQuestion: "(Why wi11 7hi5 pr0b13m b3 bann3d?)",
  bannerLastDayToVerifyAccount: "(A773n7i0n! On1y 1 day 13f7 f0r y0ur fa7h3r 0r guardian 70 appr0v3 y0ur acc0un7. O7h3rwi53, y0ur acc0un7 wi11 b3 d31373d.)",
  bannerVerifyAccount: "(I7 i5 n3c355ary f0r y0ur fa7h3r 0r guardian 70 appr0v3 y0ur acc0un7 wi7hin %(days) day5. O7h3rwi53, y0ur acc0un7 wi11 b3 d31373d.)",
  banningDeclinedByReviewer: "(Banning d3c1in3d by r3vi3w3r.)",
  banningProblemDueToReport: "(Banning pr0b13m du3 70 acc0un7 r3p0r7.)",
  birthdayInTheFuture: "(Y0u ar3 n07 01d 3n0ugh 70 u53 0m3gaUp)",
  bulkOperationError: "(Th3r3 wa5 an 3rr0r 3x3cu7ing 7h3 0p3ra7i0n)",
  bulkUserAddError: "(Th3r3 wa5 an 3rr0r adding acc0un75. Th3 f0110wing 3mai1 addr35535 w3r3 n07 f0und in 0m3gaUp:<br><br><b>%(userEmail)</b>.<br><br>H0w3v3r, 7h3 r357 0f acc0un75 hav3 b33n add3d 5ucc355fu11y.)",
  bulkUserAddSuccess: "(Acc0un75 5ucc355fu11y add3d!)",
  buttonCreateContest: "(Cr3a73 a c0n7357)",
  buttonCreateProblem: "(Cr3a73 a pr0b13m)",
  buttonGoToContests: "(G0 70 c0n73575)",
  buttonGoToCourses: "(G0 70 c0ur535)",
  buttonGoToProblems: "(G0 70 pr0b13m5)",
  cannotAddProb: "(Cann07 add pr0b13m. Y0u ar3 n07 a c0n7357 admin.)",
  cannotRemoveProblem: "(Cann07 r3m0v3 7h3 pr0b13m. Y0u ar3 n07 a c0n7357 admin.)",
  cannotRemoveProblemWithSubmissions: "(Y0u cann07 r3m0v3 a pr0b13m 7ha7 a1r3ady ha5 5ubmi55i0n5)",
  caseEditTitle: "(Edi7 ca53)",
  caseModalBack: "(Back)",
  caseModalSave: "(Sav3)",
  certificateDetailsBody: "(P13a53 53nd u5 an 3mai1 70 [c3r7ifica735@0m3gaup.c0m](mai170:c3r7ifica735@0m3gaup.c0m?5ubj3c7=V3rify%20c3r7ifica73%20%(uuid)) 70 v3rify a c3r7ifica73. Mak3 5ur3 70 inc1ud3 7h3 ID 0f 7h3 c3r7ifica73 (%(uuid)) in 7h3 5ubj3c7.)",
  certificateDetailsTitle: "(C3r7ifica73 v3rifica7i0n pr0c355)",
  certificateListMineActions: "(Ac7i0n5)",
  certificateListMineCertificatesEmpty: "(Th3r3 ar3 n0 c3r7ifica735)",
  certificateListMineCoderOfTheMonth: "(C0d3r 0f 7h3 m0n7h)",
  certificateListMineCoderOfTheMonthFemale: "(C0d3r 0f 7h3 m0n7h f0r h3r)",
  certificateListMineContest: "(C0n7357 \"%(contest_title)\")",
  certificateListMineCopyToClipboard: "(C0py v3rifica7i0n 1ink)",
  certificateListMineCourse: "(C0ur53 \"%(course_name)\")",
  certificateListMineDate: "(Da73)",
  certificateListMineDownload: "(D0wn10ad c3r7ifica73)",
  certificateListMineFileDownloaded: "(Th3 c3r7ifica73 ha5 b33n d0wn10ad3d)",
  certificateListMineLinkCopiedToClipboard: "(Th3 v3rifica7i0n 1ink wa5 c0pi3d)",
  certificateListMineReason: "(R3a50n)",
  certificateListMineTitle: "(My C3r7ifica735)",
  certificateListMineVerificationLink: "(V3rifica7i0n 1ink)",
  certificateNotFound: "(C3r7ifica73 n07 f0und)",
  certificatePdfCoderOfTheMonthDescription: "(f0r 7h3 p3rf0rmanc3 in 7h3 m0n7h 0f %(month_name) by 0b7aining 7h3 high357 5c0r3 0n 7h3 0m3gaUp.c0m p1a7f0rm)",
  certificatePdfCoderOfTheMonthFemaleTitle: "(C0d3r 0f 7h3 m0n7h f0r h3r)",
  certificatePdfCoderOfTheMonthTitle: "(C0d3r 0f 7h3 m0n7h)",
  certificatePdfContestDescription: "(f0r 7h3 par7icipa7i0n in 7h3 \"%(contest_title)\" c0n7357 h31d 0n 7h3 0m3gaUp.c0m p1a7f0rm)",
  certificatePdfContestParticipation: "(Par7icipa7i0n)",
  certificatePdfContestPlaceNd: "(nd p1ac3)",
  certificatePdfContestPlaceRd: "(rd p1ac3)",
  certificatePdfContestPlaceSt: "(57 p1ac3)",
  certificatePdfContestPlaceTh: "(7h p1ac3)",
  certificatePdfCourseDescription: "(f0r c0mp137ing 7h3 \"%(course_name)\" c0ur53 0n 7h3 0m3gaUp.c0m p1a7f0rm)",
  certificatePdfCourseTitle: "(Gradua7i0n)",
  certificatePdfDirector: "(Ex3cu7iv3 Dir3c70r)",
  certificatePdfGrantsRecognition: "(Gran75 r3c0gni7i0n 0f)",
  certificatePdfHeader: "(Incr3a5ing 7h3 numb3r 0f 7a13n73d 50f7war3 3ngin33r5 in La7in Am3rica)",
  certificatePdfMonth1: "(January)",
  certificatePdfMonth10: "(Oc70b3r)",
  certificatePdfMonth11: "(N0v3mb3r)",
  certificatePdfMonth12: "(D3c3mb3r)",
  certificatePdfMonth2: "(F3bruary)",
  certificatePdfMonth3: "(March)",
  certificatePdfMonth4: "(Apri1)",
  certificatePdfMonth5: "(May)",
  certificatePdfMonth6: "(Jun3)",
  certificatePdfMonth7: "(Ju1y)",
  certificatePdfMonth8: "(Augu57)",
  certificatePdfMonth9: "(S3p73mb3r)",
  certificatePdfPerson: "(70 7h3 p3r50n)",
  certificatePdfPlaceAndDate: "(B3113vu3, Wa5hing70n 0n %(month) %(day), %(year))",
  certificatePdfVerificationCode: "(V3rifica7i0n c0d3: %(verification_code))",
  certificatePdfVerificationLink: "(V3rifica7i0n 1ink: h77p5://0m3gaup.c0m/c3r7/%(verification_code)/)",
  certificateValidationCertifyValidity: "(0m3gaUp c3r7ifi35 7h3 va1idi7y 0f 7h3 f0110wing c3r7ifica73)",
  certificateValidationEnteredCode: "(En73r3d c0d3: )",
  certificateValidationInvalid: "(Inva1id)",
  certificateValidationNotFound1: "(N0 c3r7ifica73 wi7h 7h3 c0d3 )",
  certificateValidationNotFound2: "( wa5 f0und in 7h3 da7aba53. If y0u 7hink 7hi5 i5 an 3rr0r p13a53 c0n7ac7 u5 a7 h3110@0m3gaup.c0m.)",
  certificateValidationStatus: "(S7a7u5: )",
  certificateValidationTitle: "(V3rify C3r7ifica73)",
  clarificationContest: "(C0n7357:)",
  clarificationEmailBody: "(<p>H0wdy!</p><p><57r0ng><a hr3f=\"h77p5://0m3gaup.c0m/pr0fi13/%(user_name)\">%(user_name)</a></57r0ng> ha5 r3qu3573d a c1arifica7i0n f0r 7h3 pr0b13m <57r0ng><a hr3f=\"h77p5://0m3gaup.c0m/ar3na/pr0b13m/%(problem_alias)\">%(problem_name)</a></57r0ng>:</p><p><b10ckqu073><p>%(clarification_body)</p></b10ckqu073><p>T0 an5w3r i7, p13a53 vi5i7 7h3 f0110wing 1ink: <a hr3f=\"%(url)\">%(url)</a>.</p><p>Thank5!,<br/>0m3gaUp</p>)",
  clarificationEmailSubject: "([0m3gaUp] N3w c1arifica7i0n f0r pr0b13m %(problem_name))",
  clarificationHomework: "(H0m3w0rk:)",
  clarificationInfo: "(Inf0)",
  clarificationNotFound: "(C1arifica7i0n n07 f0und)",
  clarificationProblem: "(Pr0b13m:)",
  clarificationTime: "(Da73 and Tim3:)",
  clarificationUpdateAnswer: "(Upda73 an5w3r)",
  clarificationsAskedBy: "(A5k3d by:)",
  clarificationsEmpty: "(N0 c1arifica7i0n5 y37)",
  clarificationsOnBehalf: "(%(author) (0n b3ha1f %(receiver)))",
  clarificationsRangeHeader: "(C1arifica7i0n5 (fr0m %(lowCount) 70 %(highCount)))",
  coderOfTheMonth: "(C0d3r 0f 7h3 M0n7h Ov3ra11)",
  coderOfTheMonthAlreadySelected: "(C0d3r 0f 7h3 m0n7h ha5 b33n pr3vi0u51y 5313c73d)",
  coderOfTheMonthCanBeChosenManually: "(R3m3mb3r 7ha7 y0u can ch0053 7h3 winn3r5 0f C0d3r 0f 7h3 M0n7h f0r b07h ca73g0ri35 in 7h3 [C0d3r 0f 7h3 M0n7h](h77p5://0m3gaup.c0m/c0d3r0f7h3m0n7h/) 53c7i0n and 7h3 [C0d3r 0f 7h3 M0n7h f0r w0m3n](h77p5://0m3gaup.c0m/c0d3r0f7h3m0n7h/f3ma13/) 53c7i0n.)",
  coderOfTheMonthChooseAsCoder: "(Ch0053 a5 c0d3r 0f 7h3 m0n7h)",
  coderOfTheMonthFemale: "(C0d3r 0f 7h3 M0n7h f0r H3r)",
  coderOfTheMonthFemaleChooseAsCoder: "(Ch0053 a5 f3ma13 c0d3r 0f 7h3 m0n7h)",
  coderOfTheMonthFemaleSelectedSuccessfully: "(F3ma13 c0d3r 0f 7h3 m0n7h ha5 b33n 5313c73d 5ucc355fu11y!)",
  coderOfTheMonthFullList: "(S33 fu11 1i57)",
  coderOfTheMonthIsNotInPeriodToBeChosen: "(C0d3r 0f 7h3 m0n7h i5 n07 in 7h3 p3ri0d 70 b3 ch053n)",
  coderOfTheMonthNotFound: "(C0d3r 0f 7h3 m0n7h n07 f0und.)",
  coderOfTheMonthNotice: "(Hi %(username)! C0ngra7u1a7i0n5 f0r winning 7h3 C0d3r 0f 7h3 M0n7h!)",
  coderOfTheMonthSelectedSuccessfully: "(C0d3r 0f 7h3 m0n7h ha5 b33n 5313c73d 5ucc355fu11y!)",
  coderOfTheMonthSystemInMaintainance: "(Th3 C0d3r 0f 7h3 M0n7h 5y573m i5 und3r main73nanc3.\n\nW3 wi11 b3 back 500n.)",
  codersOfTheMonth: "(C0d3r5 0f 7h3 M0n7h)",
  codersOfTheMonthCountry: "(C0un7ry / R3gi0n)",
  codersOfTheMonthDate: "(Da73)",
  codersOfTheMonthFemale: "(F3ma13 c0d3r5 0f 7h3 M0n7h)",
  codersOfTheMonthFemaleListCandidate: "(Li57 0f candida735 70 f3ma13 c0d3r 0f 7h3 m0n7h)",
  codersOfTheMonthFemaleRank: "(T0p 100 c0d3r5 0f 7h3 pr3vi0u5 m0n7h)",
  codersOfTheMonthListCandidate: "(Li57 0f candida735 70 c0d3r 0f 7h3 m0n7h)",
  codersOfTheMonthRank: "(T0p 100 c0d3r5 0f 7h3 pr3vi0u5 m0n7h)",
  codersOfTheMonthUser: "(C0d3r)",
  collecionOtherTags: "(O7h3r 7ag5)",
  collectionTitle: "(Pr0b13m C0113c7i0n5)",
  contentCreator: "(C0n7ribu70r)",
  contentOrderUpdated: "(C0n73n7'5 0rd3r ha5 b33n upda73d)",
  contestAddUserContestant: "(C0n7357an7)",
  contestAddgroupAddGroup: "(Add gr0up)",
  contestAddlectureLectureName: "(L3c7ur3)",
  contestAddlectureLecturePoints: "(P0in75 7hi5 13c7ur3 i5 w0r7h)",
  contestAddproblemChooseVersion: "(V3r5i0n)",
  contestAddproblemContestOrder: "(C0n7357 0rd3r)",
  contestAddproblemLatestVersion: "(La7357 v3r5i0n)",
  contestAddproblemOtherVersion: "(O7h3r v3r5i0n)",
  contestAddproblemProblemName: "(Pr0b13m)",
  contestAddproblemProblemOrder: "(Ord3r)",
  contestAddproblemProblemPoints: "(P0in75 7hi5 pr0b13m i5 w0r7h)",
  contestAddproblemProblemRemove: "(R3m0v3)",
  contestAddproblemTooManyProblems: "(Thi5 c0n7357 ha5 700 many pr0b13m5, 50 i7 i5 n07 p055ib13 70 add m0r3)",
  contestAdduserAddContestant: "(C0n7357an75)",
  contestAdduserAddUsers: "(Add acc0un75)",
  contestAdduserRegisteredUserDelete: "(R3m0v3)",
  contestAdduserRegisteredUserTime: "(Fir57 acc355 7im3)",
  contestAdmissionModeDescription: "(S313c7 c0n7357 admi55i0n m0d3. Th3r3 ar3 7hr33 diff3r3n7 m0da1i7i35:\n\n- **Priva73:** C0n7357 i5 0n1y vi5ib13 70 c0d3r5 wh0 hav3 b33n 3xp1ici71y invi73d.\n\n- **R3gi57ra7i0n/0p3n:** Any0n3 can r3gi573r, 0n1y p30p13 admi773d by admin5 hav3 acc355.\n\n- **Pub1ic:** Any0n3 can par7icipa73.)",
  contestAndProblemPrintButtonDesc: "(Prin7)",
  contestBasicInformationNeeded: "(T0 j0in 7h3 c0n7357 y0u mu57 fi11 in y0ur ba5ic inf0rma7i0n. G0 70 [My pr0fi13](/pr0fi13/#3di7-ba5ic-inf0rma7i0n))",
  contestButtonEnter: "(En73r)",
  contestButtonScoreboard: "(Sc0r3b0ard)",
  contestButtonSeeDetails: "(S33 d37ai15)",
  contestCanNotChangeToContestForTeams: "(A n0rma1 c0n7357 cann07 b3 chang3d 70 a c0n7357 f0r 73am5)",
  contestCertificatesConfirmGenerate: "(Ar3 y0u 5ur3 y0u wan7 70 g3n3ra73 7h3 c3r7ifica735?, 0nc3 7h3 c3r7ifica735 ar3 g3n3ra73d 7h3y cann07 b3 m0difi3d. Mak3 5ur3 7h3 5c0r3b0ard i5 unfr0z3n.)",
  contestCertificatesCurrentContestError: "(C3r7ifica735 cann07 b3 g3n3ra73d b3cau53 7h3 c0n7357 ha5 n07 3nd3d y37.)",
  contestCertificatesCutoff: "(C3r7ifica735 cu70ff)",
  contestCertificatesCutoffHelp: "(Th3 numb3r 0f c0n7357an75 in fir57 p05i7i0n5 70 b3 award3d wi7h 5p3cia1 c3r7ifica735. Th3 r357 0f 7h3 c0n7357an75 wi11 r3c3iv3 par7icipa7i0n c3r7ifica735 7ha7 d0 n07 m3n7i0n wh3r3 7h3y 3nd3d up.)",
  contestCertificatesError: "(Th3r3 wa5 an 3rr0r g3n3ra7ing 7h3 c3r7ifica735.)",
  contestCertificatesGenerate: "(G3n3ra73 c3r7ifica735)",
  contestCertificatesGenerateSuccessfully: "(C3r7ifica735 g3n3ra73d 5ucc355fu11y.)",
  contestDetailsGoToContest: "(G0 70 c0n7357)",
  contestDownloadListOfUsersInContest: "(D0wn10ad 1i57 0f c0d3r5 in 7h3 c0n7357)",
  contestDuration: "(Dura7i0n: %(duration))",
  contestEdit: "(Edi7)",
  contestEditAddProblemSearchByAlias: "(A1ia5)",
  contestEditAddProblemSearchByAll: "(A11)",
  contestEditAddProblemSearchById: "(Id)",
  contestEditAddProblemSearchByTitle: "(Ti713)",
  contestEditAddProblems: "(Pr0b13m5)",
  contestEditAdministrativeLinks: "(Admini57ra7iv3 Link5)",
  contestEditArchive: "(Archiv3)",
  contestEditArchiveConfirmText: "(Ar3 y0u 5ur3 y0u wan7 70 p3rf0rm 7hi5 ac7i0n?)",
  contestEditArchiveContest: "(Archiv3 c0n7357)",
  contestEditArchiveHelpText: "(Wh3n archiving a c0n7357, i7 wi11 n0 10ng3r app3ar in a11 7h3 1i575. Th3 0n1y way 70 acc355 i7 i5 7hr0ugh i75 URL 0r fr0m 7h3 1i57 0f \"My c0n73575\", in 7h3 \"Archiv3d c0n73575\" 7ab. Thi5 ac7i0n can b3 und0n3.)",
  contestEditArchivedSuccess: "(C0n7357 archiv3d 5ucc355fu11y.)",
  contestEditCannotReplaceTeamsGroupWithSubmissions: "(Y0u cann07 r3p1ac3 7h3 73am5 gr0up in a c0n7357 7ha7 a1r3ady ha5 5ubmi55i0n5)",
  contestEditCatLanguageAddedWarning: "(\"ca7\" wa5 add3d 70 c0n7357 1anguag35 b3cau53 7h3 add3d pr0b13m r3quir35 i7)",
  contestEditCertificates: "(C3r7ifica735)",
  contestEditContestClonedSuccessfully: "(C0n7357 wa5 c10n3d 5ucc355fu11y)",
  contestEditContestEdited: "(Y0ur c0n7357 ha5 b33n 3di73d)",
  contestEditContestLinkCopiedToClipboard: "(C0n7357 1ink c0pi3d 70 c1ipb0ard 5ucc355fu11y)",
  contestEditCopyContestLink: "(C0py c0n7357 1ink)",
  contestEditGoToContest: "(Vi3w c0n7357)",
  contestEditRegisteredAdminDelete: "(R3m0v3)",
  contestEditRegisteredAdminRole: "(R013)",
  contestEditRegisteredAdminUsername: "(C0d3r)",
  contestEditRegisteredGroupAdminName: "(Gr0up)",
  contestEditTagDelete: "(D31373)",
  contestEditTagName: "(Tag nam3)",
  contestEditTeamsGroupReplace: "(R3p1ac3 73am5 gr0up)",
  contestEditTeamsGroupReplaced: "(T3am5 gr0up r3p1ac3d 5ucc355fu11y)",
  contestEditUnarchiveContest: "(Unarchiv3 c0n7357)",
  contestEditUnarchiveHelpText: "(Thi5 c0n7357 i5 a1r3ady archiv3d, if y0u wan7 70 r37urn i7 back 70 7h3 unarchiv3d c0n73575 1i57, c1ick in 7h3 bu770n)",
  contestEditUnarchivedSuccess: "(C0n7357 unarchiv3d 5ucc355fu11y)",
  contestEditWithTitle: "(Edi7 c0n7357 %(title))",
  contestEndTime: "(End5: %(endDate))",
  contestEnrollStatus: "(Sign3d Up)",
  contestFilterBy: "(Fi173r by)",
  contestFilterByAll: "(A11)",
  contestFilterByRecommended: "(On1y r3c0mm3nd3d)",
  contestFilterBySignedUp: "(I am par7icipan7)",
  contestForTeamsCanNotChangeToContest: "(A c0n7357 f0r 73am5 cann07 b3 chang3d 70 a n0rma1 c0n7357)",
  contestGroupAdded: "(Gr0up 5ucc355fu11y add3d.)",
  contestGroupRemoved: "(Gr0up 5ucc355fu11y r3m0v3d.)",
  contestInformationNotRequired: "(Acc0un7 inf0rma7i0n f0r 7hi5 c0n7357 wa5 n07 r3quir3d.)",
  contestIntroDifferentStarts: "(Onc3 7h3 c0n7357 ha5 57ar73d, i75 dura7i0n wi11 b3 %(window_length).)",
  contestIntroGoToHomePage: "(G0 70 h0m3pag3)",
  contestIntroLogout: "(L0g0u7)",
  contestIntroLogoutToJoinWithRegisteredUser: "(Y0u may hav3 r3c3iv3d 7h3 invi7a7i0n 70 7hi5 c0n7357 u5ing a diff3r3n7 acc0un7 7han 7h3 0n3 curr3n71y 10gg3d in. W0u1d y0u 1ik3 70 10g 0u7 and 7h3n 10g in wi7h 7h3 c0rr3c7 cr3d3n7ia15?)",
  contestIntroPenaltyDesc: "(Each inc0rr3c7 5ubmi55i0n wi11 b3 p3na1iz3d wi7h a 7im3 0f %(window_length).)",
  contestIntroScoreboardTimePercent: "(Th3 5c0r3b0ard wi11 b3 5h0wn 1iv3 f0r 7h3 fir57 %(window_length) 0f 7h3 c0n7357.)",
  contestIntroScoreboardTimePercentOneHundred: "(Th3 1iv3 5c0r3b0ard wi11 b3 5h0wn 7hr0ugh0u7 7h3 c0n7357.)",
  contestIntroScoreboardTimePercentZero: "(Th3 5c0r3b0ard wi11 n07 b3 5h0wn during 7h3 c0n7357.)",
  contestIntroSubmissionsSeparationDesc: "(F0r 3ach inc0rr3c7 5ubmi55i0n y0u mu57 wai7 %(window_length) 70 mak3 a n3w 5ubmi55i0n.)",
  contestLengthTooLong: "(C0n73575 can'7 1a57 m0r3 7han 31 day5.)",
  contestListArchivedContests: "(Archiv3d c0n73575)",
  contestListCurrent: "(Curr3n7)",
  contestListEmpty: "(Th3r3 ar3 n0 c0n73575 7ha7 m337 7h053 charac73ri57ic5)",
  contestListFuture: "(Fu7ur3)",
  contestListPast: "(Pa57)",
  contestListShowAdminContests: "(A150 5h0w c0n73575 I manag3)",
  contestListSubmissions: "(Submi55i0n5)",
  contestMustBeCreatedInPrivateMode: "(C0n7357 mu57 b3 cr3a73d in priva73 m0d3)",
  contestNew: "(N3w c0n7357)",
  contestNewForm: "(IOI S7y13)",
  contestNewFormAdmissionMode: "(Admi55i0n m0d3)",
  contestNewFormAdmissionModeDescription: "(S313c7 c0n7357 admi55i0n m0d3. Th3r3 ar3 7hr33 diff3r3n7 m0da1i7i35:<br /><u1><1i>Priva73: C0n7357 i5 0n1y vi5ib13 70 c0d3r5 wh0 hav3 b33n 3xp1ici71y invi73d.</1i><1i>R3gi57ra7i0n/0p3n: Any0n3 can r3gi573r, 0n1y p30p13 admi773d by admin5 hav3 acc355.</1i><1i>Pub1ic: Any0n3 can par7icipa73.</1i></u1>)",
  contestNewFormBasicInformationRequired: "(Ba5ic inf0rma7i0n i5 r3quir3d)",
  contestNewFormBasicInformationRequiredDesc: "(If ac7iva73d, a11 c0n7357an75 mu57 hav3 r3gi57r3d 7h3ir ba5ic inf0rma7i0n 70 j0in 7h3 c0n7357 (c0un7ry, 57a73, 5ch001))",
  contestNewFormByContests: "(In ca53 0f a 7i3, i7 wi11 b3 br0k3n by 7im3. Tim3 wi11 b3 m3a5ur3d b37w33n 7h3 m0m3n7 7ha7 7h3 c0n7357 57ar73d and 7h3 m0m3n7 3ach pr0b13m wa5 501v3d.)",
  contestNewFormByProblem: "(In ca53 0f a 7i3, i7 wi11 b3 br0k3n by 7im3. Tim3 wi11 b3 m3a5ur3d b37w33n 7h3 m0m3n7 7ha7 3ach pr0b13m wa5 0p3n3d and 7h3 m0m3n7 i7 wa5 501v3d.)",
  contestNewFormByRuntime: "(In ca53 0f a 7i3, i7 wi11 b3 br0k3n by pr0gram run7im3 (mi11i53c0nd5).)",
  contestNewFormConacupStyle: "(CONACUP 57y13)",
  contestNewFormDecrementFactor: "(Th3 5c0r3 0f 3ach pr0b13m wi11 b3 giv3n by 7h3 f0rmu1a: (1 - (%(window_length) + %(window_length) * TT^2 / (10 * PT^2 + TT^2), wh3r3 PT i5 7h3 p3na17y 0f 7h3 5ubmi55i0n in minu735 and TT 7h3 707a1 13ng7h 0f 7h3 c0n7357 in minu735.)",
  contestNewFormDescription: "(C0n7357 d35crip7i0n)",
  contestNewFormDifferentStarts: "(Diff3r3n7 57ar75)",
  contestNewFormDifferentStartsDesc: "(If ac7iva73d, indica73 h0w much 7im3 in minu735 7h3 c0d3r ha5 70 3n73r 7h3 c0n7357 and 5ubmi7 501u7i0n5 fr0m 7h3 m0m3n7 7ha7 7h3 c0d3r 3n73r5 7h3 c0n7357 0n 7h3 p1a7f0rm. Th3 va1u3 mu57 b3 1355 7han 7h3 diff3r3nc3 in minu735 0f 7h3 c0n7357 dura7i0n. If i7'5 n07 ac7iva73d, y0u can 0n1y par7icipa73 b37w33n 7h3 57ar7 7im3 and 7h3 3nd 7im3 0f 7h3 c0n7357.)",
  contestNewFormEndDate: "(End da73)",
  contestNewFormEndDateDesc: "(Th3 7im3 and da73 (in 10ca1 7im3) in which 7h3 c0n7357 wi11 3nd.)",
  contestNewFormForTeams: "(C0n7357 f0r 73am5)",
  contestNewFormForTeamsDesc: "(If ac7iva73d, 7h3 c0n7357 can 0n1y b3 acc3553d by 73am5 in573ad 0f id3n7i7i35. Th3 73am5 hav3 70 b3 add3d 70 a 73am5 gr0up. Thi5 0p7i0n i5 0n1y avai1ab13 f0r n3w c0n73575.)",
  contestNewFormICPCStyle: "(ICPC 57y13)",
  contestNewFormImmediateFeedbackDesc: "(Af73r 3va1ua7ing 3ach 5ubmi55i0n, 7h3 v3rdic7 wi11 b3 5h0wn.)",
  contestNewFormImmediateSummaryFeedbackDesc: "(Af73r 3va1ua7ing 3ach 5ubmi55i0n, 7h3 5ummary 0f 5c0r35 and v3rdic75 f0r 3ach gr0up 0f ca535 wi11 b3 5h0wn.)",
  contestNewFormLanguageRemoveBlockedWarning: "(Cann07 r3m0v3 \"%(language)\" fr0m 1anguag35 b3cau53 7h3r3 i5 a7 13a57 0n3 pr0b13m 7ha7 r3quir35 i7)",
  contestNewFormLanguages: "(S37 1anguag35 70 7h3 curr3n7 c0n7357)",
  contestNewFormNoPenalty: "(C0d3r5 wi7h 7h3 5am3 5c0r3 wi11 3nd up in a draw, r3gard1355 0f 7h3 7im3 i7 ha5 7ak3n 3ach c0d3r.)",
  contestNewFormNumberOfContestants: "(Numb3r 0f c0n7357an75)",
  contestNewFormNumberOfContestantsDesc: "(Numb3r 0f c0n7357an75 a110w3d f0r 3v3ry 73am)",
  contestNewFormOmiStyle: "(OMI - IOI S7y13)",
  contestNewFormPenaltyDesc: "(In73g3r am0un7 0f minu735 70 p3na1iz3 an inc0rr3c7 5ubmi55i0n.)",
  contestNewFormPenaltyType: "(P3na17y 7yp3)",
  contestNewFormPenaltyTypeDesc: "(Indica735 h0w 7h3 5ubmi55i0n p3na17y i5 ca1cu1a73d: minu735 5inc3 7h3 b3ginning 0f 7h3 c0n7357, minu735 5inc3 7h3 pr0b13m wa5 0p3n3d, 0r pr0gram 3x3cu7i0n 7im3 (mi11i53c0nd5).)",
  contestNewFormPointDecrementFactor: "(Sc0r3 D3cr3m3n7 Fac70r)",
  contestNewFormPointDecrementFactorDesc: "(A numb3r b37w33n 0 and 1, inc1u5iv3. If 7h3 numb3r i5 diff3r3n7 fr0m 0, 7h3 5c0r3 award3d f0r a c0rr3c7 5ubmi55i0n wi11 d3cay a5 7im3 pa5535, acc0rding 70 7h3 f0110wing f0rmu1a: (1 - p0in75_d3cay_fac70r) + p0in75_d3cay_fac70r * TT^2 / (10 * PT^2 + TT^2), wh3r3 PT i5 7h3 p3na17y 0f 7h3 5ubmi55i0n in minu735 and TT 7h3 707a1 13ng7h 0f 7h3 c0n7357 in minu735.)",
  contestNewFormRecommended: "(R3c0mm3nd3d C0n7357)",
  contestNewFormRecommendedTextAdmin: "(Enab13 7hi5 0p7i0n if y0u wan7 y0ur c0n7357 70 app3ar in 7h3 R3c0mm3nd3d C0n73575 1i57.)",
  contestNewFormRecommendedTextNonAdmin: "(T0 5h0w y0ur c0n7357 in 7h3 R3c0mm3nd3d C0n73575 1i57, c0n7ac7 50p0r73@0m3gaup.c0m.)",
  contestNewFormScheduleContest: "(Sch3du13 c0n7357)",
  contestNewFormScheduleVirtualContest: "(Sch3du13 vir7ua1 c0n7357)",
  contestNewFormScoreMode: "(Sc0r3 m0d3)",
  contestNewFormScoreModeAllOrNothing: "(A11 0r n07hing)",
  contestNewFormScoreModeDesc: "(Ch0053 \"A11 0r n07hing\" if y0u wan7 7h3 c0n7357an75 70 hav3 70 501v3 a11 7h3 ca535 0f 7h3 pr0b13m5 70 g37 p0in75. Ch0053 \"Par7ia1\" if y0u wan7 c0n7357an75 70 7h3 g37 p0in75 c0rr35p0nding 70 7h3 5ubmi55i0n 7ha7 501v3d 7h3 m057 7357 ca535. Ch0053 \"Max p3r gr0up\" if y0u wan7 7h3 c0n7357an75 70 0b7ain 7h3 p0in75 c0rr35p0nding 70 a11 7h3 ca535 7ha7 7h3y manag3d 70 501v3 wi7h any 0f 7h3ir 5ubmi55i0n5.)",
  contestNewFormScoreModeMaxPerGroup: "(Max p3r gr0up)",
  contestNewFormScoreModePartial: "(Par7ia1)",
  contestNewFormScoreboardAtContestEnd: "(Th3 5c0r3b0ard wi11 b3 vi5ib13 a7 7h3 3nd 0f 7h3 c0n7357.)",
  contestNewFormScoreboardAtEnd: "(Sh0w 5c0r3b0ard a7 7h3 3nd 0f 7h3 c0n7357)",
  contestNewFormScoreboardAtEndDesc: "(Sh0w 7h3 c0mp1373 5c0r3b0ard a7 7h3 3nd 0f 7h3 c0n7357.)",
  contestNewFormScoreboardTimePercent: "(Vi5ib13 5c0r3b0ard 7im3 (%))",
  contestNewFormScoreboardTimePercentDesc: "(In73g3r b37w33n 0 and 100, indica7ing 7h3 p3rc3n7ag3 0f 7h3 c0n7357'5 707a1 7im3 wh3r3 7h3 5c0r3b0ard wi11 b3 vi5ib13.)",
  contestNewFormShortTitleAlias: "(Sh0r7 7i713 (a1ia5))",
  contestNewFormShortTitleAliasDesc: "(Th3 a1ia5 i5 u53d 70 c0n57ruc7 7h3 c0n7357'5 URL (3.g. C0dingCup2023, OFMI2024, C0paC3n7r0Am3ricana2024, 37c.) I7 cann07 c0n7ain 5pac35.)",
  contestNewFormStartDate: "(S7ar7 da73)",
  contestNewFormStartDateDesc: "(Th3 7im3 and da73 (in 10ca1 7im3) in which 7h3 c0n7357 wi11 b3gin)",
  contestNewFormSubmissionsSeparation: "(Submi55i0n 7im3 wind0w)",
  contestNewFormSubmissionsSeparationDesc: "(Tim3 in minu735 7ha7 mu57 pa55 b3f0r3 a c0n7357an7 can 53nd a n3w 5ubmi55i0n f0r 7h3 5am3 pr0b13m af73r 53nding 0n3 (1 minu73 minimum).)",
  contestNewFormTitlePlaceholderConacupStyle: "(**CONACUP S7y13 app1i3d. S37 y0ur 7i713 h3r3**)",
  contestNewFormTitlePlaceholderICPCStyle: "(**ICPC S7y13 app1i3d. S37 y0ur 7i713 h3r3**)",
  contestNewFormTitlePlaceholderIoiStyle: "(**IOI S7y13 app1i3d. S37 y0ur 7i713 h3r3**)",
  contestNewFormTitlePlaceholderOmiStyle: "(**OMI S7y13 app1i3d. S37 y0ur 7i713 h3r3**)",
  contestNewFormUpdateContest: "(Upda73 c0n7357)",
  contestNewFormUserInformationRequired: "(R3qu357 acc355 70 par7icipan7 inf0rma7i0n)",
  contestNewFormUserInformationRequiredDesc: "(Ch0053 \"Op7i0na1\" 70 a110w 3ach c0d3r 70 d3cid3 wh37h3r 70 5har3 7h3ir p3r50na1 inf0rma7i0n and par7icipa73 ind3p3nd3n71y. O7h3rwi53, ch0053 \"R3quir3d\", bu7 c0n5id3r 7ha7 50m3 p30p13 may ch0053 n07 70 par7icipa73.)",
  contestNewInvalidStartTime: "(Th3 57ar7 7im3 mu57 b3 b3f0r3 7h3 3nd 7im3.)",
  contestNotFound: "(C0n7357 n07 f0und.)",
  contestNotRegistered: "(Y0u ar3 n07 r3gi573r3d f0r 7hi5 c0n7357.)",
  contestNotStarted: "(C0n7357 ha5 n07 57ar73d y37.)",
  contestOrderBy: "(Ord3r by)",
  contestOrderByContestants: "(C0n7357an75)",
  contestOrderByDuration: "(Dura7i0n)",
  contestOrderByEnds: "(End5)",
  contestOrderByOrganizer: "(Organiz3r)",
  contestOrderBySignedUp: "(Sign3d up)",
  contestOrderByTitle: "(Nam3)",
  contestParticipant: "(C0d3r)",
  contestPracticeMode: "(Prac7ic3)",
  contestPrintableVersion: "(Prin7ab13 v3r5i0n)",
  contestPublicForTeamsNotSupported: "(Pub1ic c0n73575 f0r 73am5 ar3 n07 5upp0r73d y37)",
  contestPublicRequiresProblem: "(Pub1ic c0n73575 r3quir3 a7 13a57 0n3 pr0b13m. P13a53 add a pr0b13m 70 7hi5 c0n7357 b3f0r3 marking i7 a5 pub1ic.)",
  contestRegistrationPreAcceptedDescription: "(Thi5 acc0un7 ha5 b33n 3xp1ici71y invi73d 70 7h3 c0n7357)",
  contestReport: "(C0n7357 R3p0r7: %(contest_alias))",
  contestReportProblemWithAlias: "(Pr0b13m: %(alias))",
  contestReportProblemWithPoints: "(P0in75: %(points))",
  contestReportTotalPoints: "(T07a1: %(total_points))",
  contestReportUsername: "(Acc0un7 nam3: %(username))",
  contestScoreboardAdminLink: "(Admin 5c0r3b0ard 1ink)",
  contestScoreboardDownloadCsvFile: "(D0wn10ad 5c0r3b0ard (.c5v))",
  contestScoreboardLink: "(Sc0r3b0ard 1ink)",
  contestScoreboardMergeChoseContests: "(Ch0053 7h3 c0n73575)",
  contestStartTime: "(S7ar75: %(startDate))",
  contestStartedTime: "(S7ar73d: %(startedDate))",
  contestUpdateAlreadyHasRuns: "(L3ng7h 0f a c0n7357 can'7 b3 chang3d 0nc3 a 501u7i0n ha5 b33n judg3d.)",
  contestVirtualMode: "(Vir7ua1)",
  contestWillBeginIn: "(Thi5 c0n7357 wi11 b3gin in %(time))",
  contestsCreate: "(Cr3a73 C0n7357)",
  contestsJoinScoreboards: "(M3rg3 Sc0r3b0ard5)",
  countryNotSet: "(C0un7ry n07 537)",
  courseActionScoreboard: "(Sc0r3b0ard)",
  courseAddContent: "(Add c0n73n7)",
  courseAddLecturesAdd: "(Add 13c7ur35)",
  courseAddLecturesAddAssignmentDesc: "(Add a11 7h3 13c7ur35 7ha7 y0u wan7 70 inc1ud3. Th353 13c7ur35 wi11 b3 570r3d af73r y0u pr355 7h3 Add c0n73n7 bu770n. If y0u d0 n07 wan7 70 d3cid3 which 13c7ur35 70 u53 righ7 n0w, y0u can add 7h3m 1a73r.)",
  courseAddLecturesAssignmentsDesc: "(Typ3 7h3 nam3 0f 7h3 13c7ur3 70 b3 add3d.)",
  courseAddLecturesEditAssignmentDesc: "(Add a11 7h3 13c7ur35 7ha7 y0u wan7 70 inc1ud3. Th353 13c7ur35 wi11 b3 570r3d by pr355ing 7h3 Add 13c7ur3 bu770n.)",
  courseAddProblemsAdd: "(Add pr0b13m5)",
  courseAddProblemsAddAssignmentDesc: "(Add a11 7h3 pr0b13m5 7ha7 y0u wan7 70 inc1ud3. Th353 pr0b13m5 wi11 b3 570r3d af73r y0u pr355 7h3 Add c0n73n7 bu770n. If y0u d0 n07 wan7 70 d3cid3 which pr0b13m5 70 u53 righ7 n0w, y0u can add 7h3m 1a73r.)",
  courseAddProblemsAssignmentsDesc: "(Typ3 7h3 nam3 0f 7h3 pr0b13m 70 b3 add3d.)",
  courseAddProblemsEditAssignmentDesc: "(Add a11 7h3 pr0b13m5 7ha7 y0u wan7 70 inc1ud3. Th353 pr0b13m5 wi11 b3 570r3d by pr355ing 7h3 Add pr0b13m bu770n.)",
  courseArchiveConfirmText: "(Ar3 y0u 5ur3 y0u wan7 70 p3rf0rm 7hi5 ac7i0n?)",
  courseArchiveHelpText: "(Wh3n archiving a c0ur53, i7 wi11 n0 10ng3r app3ar in a11 7h3 1i575. Th3 0n1y way 70 acc355 i7 i5 7hr0ugh i75 URL 0r fr0m 7h3 1i57 0f \"C0ur535 I manag3\", in 7h3 \"Archiv3d c0ur535\" 7ab. Thi5 ac7i0n can b3 und0n3.)",
  courseArchivedSuccess: "(C0ur53 archiv3d 5ucc355fu11y.)",
  courseAssignmentAdded: "(C0n73n7 add3d 5ucc355fu11y!)",
  courseAssignmentConfirmDelete: "(D0 y0u r3a11y wan7 70 d31373 %(assignment)?)",
  courseAssignmentDelete: "(D31373 c0n73n7)",
  courseAssignmentDeleted: "(C0n73n7 d31373d 5ucc355fu11y!)",
  courseAssignmentEdit: "(Edi7 c0n73n7)",
  courseAssignmentEndDateBeforeCourseStartDate: "(Th3 3nd da73 i5 pr3vi0u5 70 7h3 c0ur53 57ar7 da73)",
  courseAssignmentLectureAdded: "(L3c7ur3 add3d 5ucc355fu11y.)",
  courseAssignmentLectureRemove: "(R3m0v3 13c7ur3)",
  courseAssignmentLectureRemoved: "(L3c7ur3 r3m0v3d 5ucc355fu11y.)",
  courseAssignmentLectureReorder: "(R30rd3r 13c7ur35)",
  courseAssignmentLecturesEmpty: "(N0 13c7ur35)",
  courseAssignmentNewFormEndDateDesc: "(Tim3 and da73 (in 10ca1 7im3) in which 7h3 a55ignm3n7 wi11 3nd.)",
  courseAssignmentNewFormSchedule: "(Add c0n73n7)",
  courseAssignmentNewFormShortTitleAliasDesc: "(Th3 a1ia5 i5 u53d 70 c0n57ruc7 7h3 URL (3xamp135: HOMEWORK1, FINALTEST))",
  courseAssignmentNewFormStartDateDesc: "(Tim3 and da73 (in 10ca1 7im3) in which i7 wi11 57ar7.)",
  courseAssignmentNewFormUpdate: "(Upda73 c0n73n7)",
  courseAssignmentProblemAdded: "(Pr0b13m add3d 5ucc355fu11y.)",
  courseAssignmentProblemConfirmRemove: "(D0 y0u r3a11y wan7 70 r3m0v3 %(problem)?)",
  courseAssignmentProblemRemove: "(R3m0v3 pr0b13m)",
  courseAssignmentProblemRemoved: "(Pr0b13m r3m0v3d 5ucc355fu11y.)",
  courseAssignmentProblemReorder: "(R30rd3r pr0b13m5)",
  courseAssignmentProblemRunsEmpty: "(N0 run5)",
  courseAssignmentProblemsEmpty: "(N0 pr0b13m5)",
  courseAssignmentReorder: "(R30rd3r c0n73n7 fr0m c0ur53)",
  courseAssignmentStartDateBeforeCourseStartDate: "(Th3 57ar7 da73 i5 pr3vi0u5 70 7h3 c0ur53 57ar7 da73)",
  courseAssignmentTitle: "(%(courseName) - %(assignmentName))",
  courseAssignmentUpdated: "(C0n73n7 upda73d 5ucc355fu11y!)",
  courseBasicInformationNeeded: "(T0 j0in 7h3 c0ur53 y0u mu57 fi11 in y0ur ba5ic inf0rma7i0n. [G0 70 my pr0fi13](/pr0fi13/#3di7-ba5ic-inf0rma7i0n).)",
  courseCardCourseResume: "(R35um3)",
  courseCardImpartedBy: "(Impar73d by: **%(school_name)**)",
  courseCardMustLogIn: "(Y0u mu57 10gin 70 533 7h353 c0ur535.)",
  courseCardProgress: "(Pr0gr355:)",
  courseCardPublicLevelAdvanced: "(\u2605\u2605\u2605 Advanc3d)",
  courseCardPublicLevelIntermediate: "(\u2605\u2605 In73rm3dia73)",
  courseCardPublicLevelIntroductory: "(\u2605 In7r0duc70ry)",
  courseCardsListSearch: "(\ud83d\udd0d C0ur53 nam3)",
  courseCloneCreatedBy: "(Cr3a73d by)",
  courseCloneGenerateLinkButton: "(G3n3ra73 1ink)",
  courseCloneGenerateLinkDescription: "(Any p3r50n wi7h wh0m y0u 5har3 7hi5 1ink can u53 i7 70 c10n3 7h3 c0ur53 f0r a p3ri0d 0f 7 day5)",
  courseCloneGenerateLinkSuccess: "(Th3 1ink wa5 5ucc355fu11y g3n3ra73d)",
  courseCloneGenerateLinkTitle: "(G3n3ra73 c10n3 1ink)",
  courseContentEmpty: "(N0 c0n73n7)",
  courseContentNewFormTypeDesc: "(Th3 c0n73n7 7yp3 i5 u53d 70 di57ingui5h 73575 fr0m h0m3w0rk5 0r 13550n5 vi5ua11y.)",
  courseCreate: "(Cr3a73 C0ur53)",
  courseDetailsOverallCompletedPoints: "(%(completed_points) 0f %(total_points) p0in75)",
  courseDetailsProgress: "(C0ur53 pr0gr355)",
  courseDetailsSettings: "(S377ing5)",
  courseDetailsTabContent: "(C0n73n7)",
  courseDetailsTabInformation: "(G3n3ra1 inf0rma7i0n)",
  courseDoesNotAdmitRegistration: "(C0ur53 d035n'7 admi7 57ud3n7 r3gi57ra7i0n)",
  courseDoesNotHaveUnlimitedDuration: "(I7 i5 n07 p055ib13 70 537 an un1imi73d dura7i0n if 7h3 c0ur53 i5 a n0n-un1imi73d dura7i0n.)",
  courseEdit: "(Edi7 c0ur53)",
  courseEditAddAdminsTooltip: "(Add admin5 u5ing 7h3ir 0m3gaUp acc0un7 nam3)",
  courseEditAddGroupAdminsTooltip: "(Add gr0up5 admin5. Mak3 5ur3 7h3 gr0up 3xi575.)",
  courseEditAddGroupTeachingAssistantTooltip: "(Add gr0up5 73aching a55i57an75. Mak3 5ur3 7h3 gr0up 3xi575.)",
  courseEditAddLectures: "(Add 13c7ur3)",
  courseEditAddProblems: "(Add pr0b13m)",
  courseEditAddStudentsAdd: "(Add)",
  courseEditAddStudentsDescription: "(Manag3 7h3 57ud3n75 wh0 wi11 par7icipa73 in 7h3 c0ur53)",
  courseEditAddStudentsStudent: "(S7ud3n7)",
  courseEditAddTeachingAssistants: "(Add 73aching a55i57an7)",
  courseEditAddTeachingAssistantsTooltip: "(Add 73aching a55i57an75 u5ing 7h3ir 0m3gaUp acc0un7 nam3)",
  courseEditAdmins: "(Admini57ra70r5)",
  courseEditAdminsEmpty: "(N0 admini57ra70r5)",
  courseEditAdmissionModeDescription: "(Manua1: On1y 57ud3n75 wh0 ar3 3xp1ici71y invi73d can r3gi573r.\nShar3 URL: Any0n3 wi7h 7h3 1ink can app1y 70 j0in. Addi7i0na11y y0u can manua11y add 7h3 acc0un7 nam3 0f 3ach 57ud3n7.)",
  courseEditAdmissionModeSelect: "(S313c7 c0ur53 admi55i0n m0d3)",
  courseEditArchive: "(Archiv3)",
  courseEditClone: "(C10n3)",
  courseEditCourseClonedSuccessfully: "(Y0ur c0ur53 ha5 b33n c10n3d 5ucc355fu11y! <a hr3f=\"/c0ur53/%(course_alias)/3di7/\">Edi7 c0ur53</a>)",
  courseEditCourseEdited: "(Y0ur c0ur53 ha5 b33n 3di73d)",
  courseEditCourseEditedAndGoToCourse: "(Y0ur c0ur53 ha5 b33n 3di73d! <a hr3f=\"/c0ur53/%(alias)\">G0 70 c0ur53</a>)",
  courseEditGoToCourse: "(G0 70 c0ur53)",
  courseEditGroupAdminsEmpty: "(N0 admin gr0up5)",
  courseEditGroupTeachingAssistant: "(T3aching a55i57an7 gr0up)",
  courseEditGroupTeachingAssistantAdded: "(T3aching a55i57an7 gr0up 5ucc355fu11y add3d.)",
  courseEditGroupTeachingAssistantRemoved: "(T3aching a55i57an7 gr0up 5ucc355fu11y r3m0v3d.)",
  courseEditGroupTeachingAssistantsEmpty: "(N0 73aching a55i57an7 gr0up5)",
  courseEditRequestSetRecommendedCourse: "(If y0u ar3 in73r3573d in having y0ur c0ur53 app3ar in 7h3 1i57 0f pub1ic c0ur535, p13a53 c0n7ac7 [h3110@0m3gaup.c0m](mai170:h3110@0m3gaup.c0m) indica7ing 7h3 c0ur53 a1ia5 f0r r3vi3w.)",
  courseEditShowInPublicCoursesList: "(Sh0w in pub1ic c0ur535 1i57)",
  courseEditStudents: "(S7ud3n75)",
  courseEditTeachingAssistantAddedSuccessfully: "(T3aching a55i57an7 5ucc355fu11y add3d)",
  courseEditTeachingAssistantRemovedSuccessfully: "(T3aching a55i57an7 5ucc355fu11y r3m0v3d)",
  courseEditTeachingAssistants: "(T3aching A55i57an7)",
  courseEditTeachingAssistantsEmpty: "(N0 73aching a55i57an75)",
  courseExamEmpty: "(N0 3xam5)",
  courseExtraPointsProblem: "(Va1id f0r 3x7ra p0in75)",
  courseExtraPointsProblemDesc: "(Th3 p0in75 0f 7hi5 pr0b13m ar3 c0un73d 0n1y if 7h3 c0ur53'5 maximum 5c0r3 i5 n07 r3ach3d.)",
  courseExtraPointsProblemLabel: "(Ex7ra p0in75 pr0b13m)",
  courseGroupNotFound: "(C0ur53 gr0up n07 f0und)",
  courseHomepageStudentsSectionContent: "(**S7ud3n75**\n\n- G37 in57an7 f33dback 0n 7h3ir 501u7i0n5.\n- L3arn pr0f355i0na1 5ki115.\n- Acc355 pub1ic 0n1in3 c0ur535 24/7.\n)",
  courseHomepageTeachersSectionContent: "(**Pr0f3550r5**\n\n- Ch0053 fr0m m0r3 7han 2000 pr0b13m5 f0r 7h3ir a55ignm3n75 and 3xam5 in 7h3ir c0ur535.\n- F0110w 7h3 57ud3n7'5 pr0gr355 in r3a1-7im3.\n- Id3n7ify ar3a5 wh3r3 57ud3n75 ar3 57rugg1ing.\n)",
  courseHomepageTitle: "(Di5c0v3ring and pr3paring 7h3 7a13n7 0f La7in Am3rica)",
  courseIntroImpartedBy: "(Organiz3d by)",
  courseIntroLevel: "(L3v31: %(level))",
  courseIntroWhatYouWillLearn: "(Wha7 y0u wi11 13arn in 7hi5 c0ur53)",
  courseInvalidStartTime: "(Th3 57ar7 7im3 mu57 b3 b3f0r3 7h3 3nd 7im3.)",
  courseLevelAdvanced: "(Advanc3d)",
  courseLevelAdvancedLevel: "(Advanc3d 13v31)",
  courseLevelAllLevels: "(A11 13v315)",
  courseLevelIntermediate: "(In73rm3dia73)",
  courseLevelIntermediateLevel: "(In73rm3dia73 13v31)",
  courseLevelIntroductory: "(In7r0duc70ry)",
  courseLevelIntroductoryLevel: "(In7r0duc70ry 13v31)",
  courseList: "(C0ur535 1i57)",
  courseListAdminCourses: "(C0ur535 I manag3)",
  courseListArchivedCourses: "(Archiv3d c0ur535)",
  courseListCurrentCourses: "(Curr3n7 c0ur535)",
  courseListPastCourses: "(Pa57 c0ur535)",
  courseListSubmissionsByGroup: "(Submi55i0n5 mad3 by 57ud3n75 0f 7hi5 c0ur53)",
  courseListTeachingAssistantCourses: "(C0ur535 I a55i57)",
  courseNew: "(N3w c0ur53)",
  courseNewFormBasicInformationRequired: "(Ba5ic inf0rma7i0n i5 r3quir3d)",
  courseNewFormBasicInformationRequiredDesc: "(If ac7iva73d, a11 c0n7357an75 mu57 hav3 r3gi57r3d 7h3ir ba5ic inf0rma7i0n 70 j0in 7h3 c0ur53 (c0un7ry, 57a73, 5ch001))",
  courseNewFormDescription: "(D35crip7i0n)",
  courseNewFormEndDate: "(End da73)",
  courseNewFormEndDateDesc: "(Tim3 and da73 (in 10ca1 7im3) in which 7h3 c0ur53 wi11 3nd.)",
  courseNewFormLanguages: "(S37 1anguag35 f0r 7h3 curr3n7 c0ur53)",
  courseNewFormLevel: "(L3v31)",
  courseNewFormLevelDesc: "(Th3 c0ur53'5 difficu17y 13v31.)",
  courseNewFormObjective: "(Obj3c7iv3)",
  courseNewFormObjectiveDesc: "(D35crib3 wha7 y0ur 57ud3n75 wi11 13arn in 7hi5 c0ur53.)",
  courseNewFormScheduleCourse: "(Sch3du13 c0ur53)",
  courseNewFormShortTitleAlias: "(Sh0r7 7i713 (a1ia5))",
  courseNewFormShortTitleAliasDesc: "(Th3 a1ia5 i5 u53d 70 c0n57ruc7 7h3 c0ur53 URL (3xamp135: IPNVERANO2016, ITVERINTRO2016))",
  courseNewFormShowScoreboard: "(Sh0w 5c0r3b0ard)",
  courseNewFormShowScoreboardDesc: "(Sh0w g3n3ra1 5c0r3b0ard 70 c0ur53 57ud3n75.)",
  courseNewFormStartDate: "(S7ar7 da73)",
  courseNewFormStartDateDesc: "(Tim3 and da73 (in 10ca1 7im3) in which 7h3 c0ur53 wi11 57ar7.)",
  courseNewFormUnlimitedDuration: "(Un1imi73d dura7i0n)",
  courseNewFormUnlimitedDurationDesc: "(If ac7iva73d, 7h3 fini5h 7im3 wi11 b3 nu11 and 7h3 c0ur53 wi11 hav3 an un1imi73d dura7i0n.)",
  courseNewFormUpdateCourse: "(Upda73 c0ur53)",
  courseNewFormUserInformationRequired: "(R3qu357 par7icipan7 inf0rma7i0n)",
  courseNewFormUserInformationRequiredDesc: "(Enab13 7hi5 0p7i0n 70 r3qu357 acc355 70 7h3 inf0rma7i0n 0f 7h3 par7icipan75 7ha7 b310ng 70 7h3 c0ur53 in 0rd3r 70 b3 c0n7ac73d 1a73r. K33p in mind 7ha7 7h3 par7icipan75 can ch0053 wh37h3r 7h3y wan7 70 giv3 acc355 70 7h3ir inf0rma7i0n 0r n07.)",
  courseNotFound: "(C0ur53 n07 f0und)",
  coursePrivacyConsent: "(C0ur53 privacy c0n53n7)",
  courseProgressGlobalScore: "(G10ba1 Sc0r3)",
  courseRegistrationPreAcceptedDescription: "(Thi5 acc0un7 ha5 b33n 3xp1ici71y invi73d 70 7h3 c0ur53)",
  courseRequestFeedback: "(D0 y0u hav3 d0ub75? r3qu357 f33dback 0n y0ur c0d3!)",
  courseStatisticsAverageRuns: "(Av3rag3 5ubmi55i0n5)",
  courseStatisticsAverageScore: "(Av3rag3 5c0r3)",
  courseStatisticsMaximumScore: "(Maximum 5c0r3)",
  courseStatisticsMinimumScore: "(Minimum 5c0r3)",
  courseStatisticsScoreVariance: "(Sc0r3 varianc3)",
  courseStatisticsStudentsAbove: "(S7ud3n75 5c0r3d ab0v3 60%)",
  courseStatisticsStudentsCompleted: "(S7ud3n75 wi7h a 5c0r3 3qua1 70 100%)",
  courseStatisticsStudentsScored: "(S7ud3n75 5c0r3d a7 0%)",
  courseStatisticsVariance: "(Varianc3)",
  courseStatisticsVerdicts: "(V3rdic7 di57ribu7i0n)",
  courseStudentAdded: "(S7ud3n7 add3d 5ucc355fu11y.)",
  courseStudentCountLabel: "(S7ud3n75: %(student_count))",
  courseStudentNotInCourse: "(Th3 57ud3n7 wa5 n07 in 7h3 c0ur53.)",
  courseStudentRemoved: "(S7ud3n7 r3m0v3d 5ucc355fu11y.)",
  courseStudentSelectAssignment: "(S313c7 c0n73n7)",
  courseStudentSelectStudent: "(S313c7 57ud3n7)",
  courseStudentsEmpty: "(N0 57ud3n75)",
  courseStudentsProgress: "(S7ud3n75' pr0gr355)",
  courseStudentsProgressExportToSpreadsheet: "(Exp0r7 7ab13 a5:)",
  courseSubmissionNotFound: "(Th3 5ubmi55i0n f0r any pr0b13m 0f 7hi5 c0ur53 ha5 n07 b33n f0und)",
  courseSubmissionsList: "(C0ur53 5ubmi55i0n5 1i57)",
  courseTabEnrolled: "(Enr0113d c0ur535 (%(course_count)))",
  courseTabEnrolledUnlogged: "(Enr0113d c0ur535)",
  courseTabFinished: "(Fini5h3d c0ur535 (%(course_count)))",
  courseTabFinishedUnlogged: "(Fini5h3d c0ur535)",
  courseTabPublic: "(Exp10r3 c0ur535)",
  courseTabsEmptyEnrolledCourses: "(Y0u ar3 n07 r3gi573r3d in any c0ur53)",
  courseTabsEmptyFinishedCourses: "(Th3r3 ar3n'7 fini5h3d c0ur535)",
  courseUnarchivedSuccess: "(C0ur53 unarchiv3d 5ucc355fu11y.)",
  courseUpdateAlreadyHasRuns: "(Th3 dura7i0n can'7 b3 chang3d 0nc3 a 501u7i0n ha5 b33n judg3d.)",
  courseWithoutProblems: "(Wi7h0u7 pr0b13m5)",
  createContestInteractiveGuideContestTitle: "(Ch0053 7h3 7i713 0f y0ur c0n7357)",
  createContestInteractiveGuideDescription: "(Add a d35crip7i0n f0r y0ur c0n7357)",
  createContestInteractiveGuideSchedule: "(Af73r fi11ing 0u7 a11 7h3 inf0rma7i0n, 5ch3du13 7h3 c0n7357)",
  createContestInteractiveGuideShortTitle: "(Ch0053 a 5h0r7 7i713 f0r y0ur c0n7357)",
  createContestInteractiveGuideStyle: "(Ch0053 fr0m pr3d3fin3d c0n7357 57y135)",
  createContestInteractiveGuideTitle: "(Cr3a73 a C0n7357)",
  createContestInteractiveGuideWelcome: "(L37'5 cr3a73 a c0n7357)",
  createCourseInteractiveGuideAskInformation: "(S313c7 if y0u wan7 70 r3qu357 inf0rma7i0n fr0m par7icipan75.)",
  createCourseInteractiveGuideBasicInformation: "(S313c7 if ba5ic par7icipan7 inf0rma7i0n wi11 b3 r3quir3d.)",
  createCourseInteractiveGuideDescription: "(En73r a bri3f c0ur53 d35crip7i0n.)",
  createCourseInteractiveGuideDuration: "(D0 y0u wan7 i7 70 hav3 un1imi73d dura7i0n?)",
  createCourseInteractiveGuideEndDate: "(Ch0053 7h3 c0ur53 3nd da73.)",
  createCourseInteractiveGuideLanguage: "(S313c7 7h3 p3rmi773d pr0gramming 1anguag35.)",
  createCourseInteractiveGuideLevel: "(S313c7 c0ur53 13v31)",
  createCourseInteractiveGuideName: "(Ch0053 7h3 c0ur53 nam3.)",
  createCourseInteractiveGuideObjective: "(Wha7 wi11 b3 7h3 c0ur53 0bj3c7iv3?)",
  createCourseInteractiveGuideSchool: "(En73r y0ur 5ch001.)",
  createCourseInteractiveGuideScoreboard: "(D0 y0u wan7 70 di5p1ay 7h3 5c0r3b0ard in 7h3 c0ur53?)",
  createCourseInteractiveGuideShortTitle: "(Ch0053 an a1ia5 f0r 7h3 c0ur53.)",
  createCourseInteractiveGuideStartDate: "(Ch0053 7h3 c0ur53 57ar7 da73.)",
  createCourseInteractiveGuideSubmit: "(Submi7 c0ur53)",
  createCourseInteractiveGuideTitle: "(Cr3a73 C0ur53)",
  createCourseInteractiveGuideWelcome: "(W31c0m3, 137'5 cr3a73 a c0ur53.)",
  createIdentitiesInteractiveGuideCopy: "(Y0u can c0py i7 c1icking 7hi5 bu770n)",
  createIdentitiesInteractiveGuideExample: "(H3r3'5 an 3xamp13 0f h0w y0u 5h0u1d up10ad 7h3 id3n7i7i35 in 7h3 fi13)",
  createIdentitiesInteractiveGuideFormat: "(R3m3mb3r 70 up10ad 7h3m in CSV f0rma7)",
  createIdentitiesInteractiveGuideInformation: "(R3m3mb3r 70 r3ad 7h3 imp0r7an7 inf0rma7i0n.)",
  createIdentitiesInteractiveGuideInformationConfirm: "(Af73r v3rifying 7ha7 3v3ry7hing i5 c0rr3c7, c1ick 0n 7h3 'Cr3a73 Id3n7i7i35' bu770n.)",
  createIdentitiesInteractiveGuideInformationPassword: "(Af73r adding 7h3 fi13, r3vi3w 7h3 r3c0rd5 7ha7 w3r3 cr3a73d and 570r3 7h3 g3n3ra73d pa55w0rd5 in a 53cur3 p1ac3, a5 7h3y wi11 n07 b3 5h0wn again.)",
  createIdentitiesInteractiveGuidePassword: "(D0 y0u wan7 70 g3n3ra73 3a5y r3ading pa55w0rd5?)",
  createIdentitiesInteractiveGuideTitle: "(Cr3a73 Id3n7i7i35)",
  createIdentitiesInteractiveGuideUpload: "(Up10ad y0ur id3n7i7i35. R3m3mb3r 7ha7 i7 mu57 b3 a CSV f0rma7 fi13.)",
  createIdentitiesInteractiveGuideWelcome: "(H3110, 137'5 cr3a73 id3n7i7i35!)",
  createProblemInteractiveGuideFile: "(Up10ad 7h3 .zip fi13 wi7h 7h3 pr0b13m inf0rma7i0n.)",
  createProblemInteractiveGuideOrigin: "(Ch0053 7h3 50urc3 0f 7h3 pr0b13m.)",
  createProblemInteractiveGuideProblemTitle: "(Ch0053 7h3 pr0b13m 7i713.)",
  createProblemInteractiveGuideShortTitle: "(Ch0053 a 5h0r7 7i713 f0r 7h3 pr0b13m.)",
  createProblemInteractiveGuideTagsAndLevel: "(Ch0053 7h3 7ag5 and 13v31 f0r y0ur pr0b13m)",
  createProblemInteractiveGuideTitle: "(Cr3a73 a pr0b13m)",
  createProblemInteractiveGuideType: "(Ch0053 7h3 pr0b13m 7yp3.)",
  createProblemInteractiveGuideValidator: "(S313c7 7h3 0u7pu7 va1ida70r 7yp3.)",
  createProblemInteractiveGuideWelcome: "(W31c0m3, 137'5 cr3a73 a pr0b13m.)",
  createZipFileForProblem: "(Cr3a73 a zip fi13 f0r 7h3 pr0b13m.)",
  csrfException: "(Cr055-5i73 R3qu357 F0rg3ry a773mp7)",
  currentStatus: "(Curr3n7 57a73)",
  datePickerFormat: "(mm/dd/yyyy)",
  dateTimePickerFormat: "(mm/dd/yyyy hh:ii)",
  deleteProblemLevel: "(D31373 pr0b13m 13v31)",
  demotionProblemEmailBannedBody: "(<p>D3ar <57r0ng>%(user_name)</57r0ng>:</p><p>Th3 acc355 70 y0ur pr0b13m <57r0ng>%(problem_name)</57r0ng> in 0m3gaUp ha5 b33n r357ric73d b3cau53 i7 wa5 r3p0r73d a5 inappr0pria73. Th3 0m3gaUp 73am ha5 r3vi3w3d 7hi5 r3p0r7 and c0nfirm3d 7ha7 7h3 pr0b13m i5 n07 appr0pria73 b3cau53 <3m>%(reason)</3m>.</p><p>T0 unb10ck 7h3 pr0b13m and hav3 i7 app3ar again in 7h3 1i57 0f pr0b13m5, p13a53 f0110w 7h3 573p5 b310w:</p><p><01><1i>R3vi3w and 3di7 y0ur pr0b13m: mak3 5ur3 y0u d35crib3 a pr0b13m, i7 i5 n07 0ff3n5iv3 0r 5pam.</1i><1i>Onc3 y0u hav3 r3501v3d 7h3 r3a50n 0n why y0ur pr0b13m wa5 b10ck3d, 53nd an 3mai1 <a hr3f=\"mai170:qua1i7y@0m3gaup.c0m\" 7arg37=\"_70p\">qua1i7y@0m3gaup.c0m</a> 70 b3 r3vi3w3d and r3ac7iva73d.</1i></01></p><p>If 7h3 573p5 m3n7i0n3d ab0v3 ar3 n07 f0110w3d, 7h3 pr0b13m wi11 n07 b3 5h0wn again in 7h3 1i57 0f pr0b13m5, n0r can i7 b3 u53d in c0mp37i7i0n5. In ca53 0f a r31ap53 in 7hr33 0cca5i0n5, 0m3gaUp r353rv35 7h3 righ7 70 5u5p3nd y0ur u53r acc0un7.</p><p>0m3gaUp i5 a p1a7f0rm 70 h31p u53r5 impr0v3 7h3ir 50f7war3 3ngin33ring 5ki115 by 501ving c0d3 pr0b13m5 and c0mp37ing in pr0graming c0n73575. 0m3gaUp w31c0m35 a11 7h3 pr0b13m5 7ha7 h31p m337 7ha7 g0a1.</p><p>Thank5,</p><p>0m3gaUp 73am</p>)",
  demotionProblemEmailBannedSubject: "(Pr0b13m [%(problem_name)] ha5 b33n r3p0r73d a5 inappr0pria73)",
  demotionProblemEmailWarningBody: "(<p>D3ar %(user_name):</p><p>A warning ha5 b33n pu7 0n y0ur pr0b13m %(problem_name) in 0m3gaUp b3cau53 i7 wa5 r3p0r73d by 7h3 u53r5. Th3 0m3gaUp 73am ha5 r3vi3w3d 7hi5 r3p0r7 and c0nfirm3d 7ha7 7h3 pr0b13m ha5 r00m f0r impr0v3m3n7 b3cau53 %(reason).</p><p>T0 r3m0v3 7h3 warning n07ifica7i0n 0n 7h3 pr0b13m p13a53 f0110w 7h3 573p5 b310w:</p><p><01><1i>R3vi3w and 3di7 y0ur pr0b13m.</1i><1i>Onc3 y0u hav3 r3501v3d 7h3 r3a50n 0n why a warning ha5 b33n pu7 0n y0ur pr0b13m, 53nd an 3mai1 70 qua1i7y@0m3gaup.c0m 70 b3 r3vi3w3d.</1i></10></p><p>If 7h3 573p5 m3n7i0n3d ab0v3 ar3 n07 f0110w3d, 7h3 pr0b13m wi11 5h0w a warning 5ign in 7h3 1i57 0f pr0b13m5.</p><p>0m3gaUp i5 a p1a7f0rm 70 h31p u53r5 impr0v3 7h3ir 50f7war3 3ngin33ring 5ki115 by 501ving c0d3 pr0b13m5 and c0mp37ing in pr0graming c0n73575. 0m3gaUp w31c0m35 a11 7h3 pr0b13m5 7ha7 h31p m337 7ha7 g0a1.</p><p>Thank5,</p><p>0m3gaUp 73am</p>)",
  demotionProblemEmailWarningSubject: "(A warning ha5 b33n pu7 0n y0ur pr0b13m %(problem_name))",
  demotionProblemMultipleAnswerNo: "(N0, ju57 7hi5 r3p0r7)",
  demotionProblemMultipleAnswerYes: "(Y35, ch3ck a11)",
  demotionProblemMultipleQuestion: "(D0 y0u wan7 70 d0 7hi5 f0r a11 r3p0r75 0f 7hi5 pr0b13m?)",
  demotionProblemNotificationBanned: "(Pr0b13m [%(problem_name)] ha5 b33n r3p0r73d a5 inappr0pria73. F0r m0r3 d37ai15 ch3ck y0ur 3mai1.)",
  demotionProblemNotificationWarning: "(A warning ha5 b33n pu7 0n y0ur pr0b13m %(problem_name). F0r m0r3 d37ai15 ch3ck y0ur 3mai1.)",
  dependentsBlockedMessage: "(Acc0un7 10ck3d. T0 va1ida73 7h3 d3p3nd3n7, i7 i5 n3c355ary 70 c0n7ac7 0ur 5upp0r7 73am.)",
  dependentsMessage: "(I7 i5 n3c355ary 70 appr0v3 y0ur d3p3nd3n7'5 acc0un7 wi7hin %(days) day5. O7h3rwi53, 7h3 acc0un7 wi11 b3 d31373d.)",
  dependentsOneDayUntilVerificationDeadline: "(A773n7i0n! Y0u 0n1y hav3 1 day 13f7 70 appr0v3 y0ur d3p3nd3n7'5 acc0un7. O7h3rwi53, 7h3 acc0un7 wi11 b3 d31373d.)",
  dependentsStatus: "(S7a7u5)",
  dependentsTitle: "(Par3n7a1 acc355)",
  dependentsUser: "(U53r)",
  dependentsVerified: "(D3p3nd3n7'5 acc0un7 ha5 b33n v3rifi3d 5ucc355fu11y)",
  downloadZip: "(D0wn10ad zip)",
  duplicateTagsNotAllowed: "(Dup1ica73d 7ag5 ar3 n07 a110w3d. Th3r3 i5 a7 13a57 0n3 dup1ica73d 7ag in 7h3 1i57: %(tags) <br> P13a53 fix 7h3 inf0rma7i0n.)",
  editFieldRequired: "(Mi55ing r3quir3d fi31d)",
  emailNotVerified: "(Y0ur 3mai1 i5 n07 v3rifi3d y37. P13a53 100k f0r 7h3 v3rifica7i0n 3mai1 in y0ur inb0x and 5pam f01d3r. If y0u 57i11 hav3 pr0b13m5, p13a53 c0n7ac7 50p0r73@0m3gaup.c0m f0r 5upp0r7.)",
  enterContest: "(En73r C0n7357)",
  ephemeralGraderAlert: "(Y0u n33d a 1arg3r 5cr33n 5iz3 70 u53 7h3 Eph3m3ra1 Grad3r. Try pu77ing y0ur ph0n3 in h0riz0n7a1 p05i7i0n 0r u53 an07h3r d3vic3.)",
  errorWhileSendingMail: "(Th3r3 wa5 an 3rr0r 53nding 7h3 v3rifica7i0n 3mai1. P13a53 7ry again 1a73r 0r c0n7ac7 50p0r73@0m3gaup.c0m f0r 5upp0r7. Y0ur 3mai1 i5 n07 v3rifi3d y37.)",
  feedbackLeftBy: "(%(date), by:)",
  feedbackNotSentYet: "(Th3 f33dback f0r 7hi5 5ubmi55i0n ha5 n07 b33n 53n7 y37.)",
  feedbackSuccessfullyAdded: "(Th3 f33dback ha5 b33n 5ucc355fu11y add3d.)",
  feedbackSuccessfullyUpdated: "(Th3 f33dback ha5 b33n 5ucc355fu11y upda73d.)",
  feedbackTitle: "(Submi55i0n f33dback)",
  firstSumbissionWithIdentity: "(N073 7ha7 y0u ar3 7rying 70 53nd a 5ubmi55i0n wi7h an id3n7i7y acc0un7)",
  fontSize: "(F0n7-Siz3)",
  forSelectedItems: "(F0r 5313c73d i73m5)",
  forbiddenInVirtualContest: "(F0rbidd3n in vir7ua1 c0n7357)",
  frontPageDevelopers: "(D3v310p3r5)",
  frontPageFooter: "(incr3a5ing 7h3 numb3r 0f 7a13n73d 50f7war3 3ngin33r5 in La7in Am3rica.)",
  frontPageFooterAboutUs: "(Ab0u7 0m3gaUp)",
  frontPageFooterCodeConduct: "(C0d3 0f C0nduc7)",
  frontPageFooterContact: "(C0n7ac7 u5)",
  frontPageFooterCopyright: "(C0pyrigh7 \u00a9 %(currentYear) 0m3gaUp, Inc. A11 righ75 r353rv3d.)",
  frontPageFooterHelpUs: "(H31p u5)",
  frontPageFooterOrganization: "(Organiza7i0n)",
  frontPageFooterPrivacyPolicy: "(Privacy p01icy)",
  frontPageFooterSite: "(Si73)",
  frontPageFooterSponsors: "(Sp0n50r)",
  frontPageFooterTeam: "(T3am)",
  frontPageNextContests: "(Upc0ming c0n73575)",
  generalError: "(O0p5. I'v3 3nc0un73r3d an in73rna1 3rr0r. P13a53 7ry again.)",
  groupAdminAdded: "(Gr0up admin 5ucc355fu11y add3d.)",
  groupAdminRemoved: "(Gr0up admin 5ucc355fu11y r3m0v3d.)",
  groupCreateIdentities: "(Cr3a73 id3n7i7i35)",
  groupEditEdit: "(Edi7)",
  groupEditGroupUpdated: "(Th3 gr0up ha5 b33n 5ucc355fu11y upda73d.)",
  groupEditMemberAdded: "(M3mb3r 5ucc355fu11y add3d!)",
  groupEditMemberPasswordUpdated: "(Id3n7i7y'5 pa55w0rd 5ucc355fu11y upda73d!)",
  groupEditMemberRemoved: "(M3mb3r 5ucc355fu11y r3m0v3d!)",
  groupEditMemberUpdated: "(M3mb3r 5ucc355fu11y upda73d!)",
  groupEditMembers: "(M3mb3r5)",
  groupEditMembersAddMembers: "(Add m3mb3r5)",
  groupEditMembersChangePassword: "(C1ick h3r3 70 chang3 pa55w0rd)",
  groupEditMembersCoder: "(C0d3r)",
  groupEditMembersEdit: "(C1ick h3r3 70 3di7 m3mb3r inf0rma7i0n)",
  groupEditMembersRemove: "(C1ick h3r3 70 r3m0v3 m3mb3r fr0m 7h3 gr0up)",
  groupEditMembersTitle: "(Add m3mb3r5 f0r 7h3 73am: %(username))",
  groupEditScoreboards: "(Sc0r3b0ard5)",
  groupEditScoreboardsAdd: "(Cr3a73 5c0r3b0ard)",
  groupEditScoreboardsAddContest: "(Add c0n7357)",
  groupEditScoreboardsAdded: "(Sc0r3b0ard 5ucc355fu11y add3d!)",
  groupEditScoreboardsContestsAdded: "(C0n7357 5ucc355fu11y add3d!)",
  groupEditScoreboardsContestsRemoved: "(C0n7357 5ucc355fu11y r3m0v3d!)",
  groupEditScoreboardsEdit: "(Edi7 5c0r3b0ard %(scoreboard))",
  groupEditTitle: "(Edi7 gr0up)",
  groupEditTitleWithName: "(Edi7 gr0up %(name))",
  groupIdentitiesNotRequiredPrivileges: "(Y0u d0 n07 hav3 7h3 r3quir3d p3rmi55i0n5 70 cr3a73 id3n7i7i35. T0 0b7ain 7h3m, p13a53 53nd an 3mai1 70 *[50p0r73@0m3gaup.c0m](mai170:50p0r73@0m3gaup.c0m?5ubj3c7=R3qu357%20f0r%20Acc355%2070%20Id3n7i7y%20Cr3a7i0n)* wi7h 7h3 5ubj3c7 \"R3qu357 f0r Acc355 70 Id3n7i7y Cr3a7i0n\" and inc1ud3 7h3 f0110wing d37ai15:\n\n- Nam3 0f 7h3 c0n7357\n- Organizing in57i7u7i0n\n- C0n7ac7 nam3 a7 7h3 0rganizing in57i7u7i0n\n- C0n7ac7'5 0m3gaUp u53rnam3\n- Appr0xima73 numb3r 0f c0n7357an75 \n- Da73 0f 7h3 c0n7357\n\n\nIf y0ur c0n7357 i5 57ar7ing in 1355 7han 48 h0ur5, inc1ud3 7h3 w0rd **\"URGENT\"** in 7h3 5ubj3c7 0f y0ur 3mai1.)",
  groupMemberUsernameInUse: "(Th3r3 i5 a7 13a57 0n3 dup1ica73d acc0un7 nam3 in 7h3 id3n7i7i35 0f 7h3 gr0up: <br> %(usernames) <br> P13a53 fix 7h3 inf0rma7i0n.)",
  groupModalBack: "(Back)",
  groupModalSave: "(Sav3)",
  groupNewFormCreateGroup: "(Cr3a73 gr0up)",
  groupNewFormDescription: "(Gr0up d35crip7i0n)",
  groupNewFormOnlyAC: "(On1y c0un7 AC5)",
  groupNewFormUpdateGroup: "(Sav3 gr0up)",
  groupNewFormWeight: "(Sc0r3 w3igh7)",
  groupNotFound: "(Gr0up n07 f0und)",
  groupScoreboardDetailsCoder: "(C0d3r)",
  groupsCanNotBeAddedInContestForTeams: "(Gr0up5 cann07 b3 add3d in c0n73575 f0r 73am5)",
  groupsCreateNew: "(N3w gr0up)",
  groupsCsvHelp: "(<p>Quick1y add mu17ip13 id3n7i7i35 70 7hi5 gr0up. Id3n7i7i35 ar3 n07 r3gu1ar acc0un75, and d0n'7 n33d 70 hav3 an 3mai1 0r va1ida73 7h3ir acc0un7.</p>\n<p>Id3n7i7i35 5h0u1d b3 in a <c0d3>.c5v</c0d3> fi13 wi7h 7h3 f0110wing f0rma7:\n<5amp><pr3>u53rnam3,nam3,c0un7ry_id,57a73_id,g3nd3r,5ch001_nam3\nu53rnam3-1,D3v310p3r Diana,MX,AGU,f3ma13,B357 Sch001\nu53rnam3-2,Danny D3v,MX,AGU,ma13,B357 Sch001</pr3></5amp></p>)",
  groupsIdentitiesSuccessfullyCreated: "(Th3 id3n7i7i35 hav3 b33n cr3a73d and 1ink3d 70 7h3 gr0up.)",
  groupsIdentityWarning: "(Sav3 7h3 pa55w0rd5 in a 5af3 p1ac3, b3cau53 0nc3 y0u cr3a73 7h3 id3n7i7i35 7h3r3 wi11 b3 n0 way 0f r3c0v3ring 7h3 pa55w0rd5.)",
  groupsInvalidCsv: "(P13a53 up10ad a va1id CSV fi13.)",
  groupsUploadCsvFile: "(Up10ad CSV fi13)",
  homepageCompeteSectionDescription: "(Par7icipa73 in pr0gramming c0n73575 and 7357 y0ur kn0w13dg3)",
  homepageCompeteSectionTitle: "(C0mp373)",
  homepageCreateSectionDescription: "(Organiz3 y0ur c0n7357 wi7h pr0b13m5 7ha7 ar3 avai1ab13 0n 7h3 p1a7f0rm 0r cr3a73 y0ur 0wn pr0b13m5)",
  homepageCreateSectionTitle: "(Cr3a73)",
  homepageSponsorsSectionTitle: "(Thank5 70 0ur Sp0n50r)",
  homepageTeachSectionDescription: "(Track y0ur 57ud3n7'5 pr0gr355 7hr0ugh a55ignm3n75 and 73575 7ha7 ar3 au70ma7ica11y a553553d)",
  homepageTeachSectionTitle: "(T3ach)",
  homepageTrainSectionDescription: "(S01v3 pr0b13m5 and impr0v3 y0ur 5ki115)",
  homepageTrainSectionTitle: "(Train)",
  identityAlreadyAssociated: "(Y0u a1r3ady hav3 0n3 id3n7i7y a550cia73d wi7h 7h3 5am3 gr0up.)",
  identityAlreadyInUse: "(Id3n7i7y i5 a1r3ady u53d by an07h3r acc0un7.)",
  identityInGroup: "(Id3n7i7y i5 a1r3ady a550cia73d 70 7h3 gr0up.)",
  incompatibleArgs: "(Argum3n75 can'7 b3 537 5imu17an30u51y)",
  interactiveGuideDoneButton: "(D0n3)",
  interactiveGuideNextButton: "(N3x7)",
  interactiveGuidePreviousButton: "(Pr3vi0u5)",
  invalidLanguage: "(Inva1id 1anguag3)",
  invalidParameters: "(Inva1id param373r5.)",
  invalidResetToken: "(Inva1id r3537 70k3n.)",
  invalidScoreboardUrl: "(Inva1id 5c0r3b0ard ur1.)",
  invalidStatementType: "(Inva1id 57a73m3n7 7yp3.)",
  invalidUser: "(Inva1id acc0un7 nam3.)",
  invalidVisibility: "(Th3 vi5ibi1i7y param373r can b3 0n3 0f 7h3 f0110wing va1u35: d31373d, priva73_bann3d, pub1ic_bann3d, priva73_warning, priva73, pub1ic_warning, pub1ic and pr0m073d)",
  joinCourseInteractiveGuideJoin: "(C1ick 7h3 57ar7 bu770n 70 j0in 7h3 c0ur53.)",
  joinCourseInteractiveGuideSearch: "(H3r3 y0u can 53arch f0r c0ur535 by nam3.)",
  joinCourseInteractiveGuideTabs: "(H3r3 y0u can naviga73 b37w33n 533 7h3 c0ur535 y0u ar3 57udying, 3xp10r3 n3w c0ur535 and 533 7h3 c0ur535 y0u hav3 c0mp1373d.)",
  joinCourseInteractiveGuideTitle: "(J0ining a C0ur53)",
  joinCourseInteractiveGuideWelcome: "(H3110! H3r3 y0u can find y0ur c0ur535.)",
  lastUpdate: "(La57 upda73)",
  levelTagHelp: "(Th3 13v315 mu57 c0incid3 wi7h 3duca7i0na1 57ag35 and g0 hand in hand wi7h 7h3 c0ur535 7ha7 57ud3n75 u5ua11y 7ak3.)",
  libinteractiveDownload: "(D0wn10ad)",
  libinteractiveFilename: "(Fi13 70 5ubmi7)",
  libinteractiveIdlFilename: "(.id1 fi13nam3)",
  libinteractiveIdlFilenameHelp: "(Th3 nam3 0f 7h3 .id1 fi13 (wi7h0u7 3x73n5i0n). Mu57 b3 b37w33n 1 and 32 a1phanum3ric charac73r5.)",
  libinteractiveLanguage: "(Languag3)",
  libinteractiveOs: "(Op3ra7ing Sy573m)",
  libinteractiveTitle: "(In73rac7iv3 73mp1a735)",
  liveStatistics: "(Liv3 S7a7i57ic5)",
  locale: "pseudo",
  lockdown: "(Op3ra7i0n n07 a110w3d in 10ckd0wn m0d3)",
  lockdownDetailsDisabled: "(Vi3wing 50urc3 c0d3 ha5 b33n 73mp0rari1y di5ab13d.)",
  lockdownMessageWarning: "(Warning: in 10ckd0wn m0d3, y0ur 5ubmi55i0n5 wi11 n0 10ng3r b3 acc355ib13 if y0u 13av3 7h3 pag3.)",
  loginAccountName: "(Acc0un7 nam3)",
  loginDateOfBirth: "(Da73 0f bir7h)",
  loginDisabled: "(Y0ur acc0un7 ha5 b33n inac7iv3 f0r a 10ng 7im3 and ha5 b33n di5ab13d f0r y0ur 53curi7y. P13a53 c0n7ac7 50p0r73@0m3gaup.c0m 70 10gin again.)",
  loginEmail: "(E-mai1 addr355)",
  loginEmailUsername: "(E-mai1 0r u53r)",
  loginFacebookEmptyEmailError: "(An 3mai1 addr355 i5 n33d3d 70 u53 0m3gaUp. P13a53 gran7 acc355 70 Fac3b00k'5 3mai1 70 c0n7inu3)",
  loginFederated: "(L0gin u5ing 7h353 5i735)",
  loginGoogleInvalidCSRFToken: "(Inva1id CSRF 70k3n)",
  loginHeader: "(L0gin 70 0m3gaUp)",
  loginLogIn: "(L0g in)",
  loginNative: "(0m3gaUp acc0un7)",
  loginParentEmail: "(Par3n7 3-mai1 addr355)",
  loginPassword: "(Pa55w0rd)",
  loginPasswordCreate: "(Pa55w0rd (Min. 8 charac73r5))",
  loginPasswordTooShort: "(Pa55w0rd i5 700 5h0r7.)",
  loginRecover: "(F0rg07 y0ur pa55w0rd?)",
  loginRepeatPassword: "(R3p3a7 pa55w0rd)",
  loginRequired: "(Y0u n33d 70 10gin 70 p3rf0rm 7ha7 ac7i0n.)",
  loginSignUp: "(R3gi573r)",
  loginSignupHeader: "(Cr3a73 an 0m3gaUp acc0un7, i7'5 quick and 3a5y!)",
  loginThroughThirdParty: "(Y0ur acc0un7 wa5 cr3a73d 7hr0ugh a 7hird-par7y 10gin (G00g13, Fac3b00k, 37c.). P13a53 10gin u5ing 7ha7 m3chani5m again in 0rd3r 70 537 a pa55w0rd.)",
  logoutConfirmationTitle: "(C0nfirm L0g0u7)",
  mailFromUserLikelyRemoved: "(Thi5 mai1 i5 a1r3ady in u53. Pr0bab1y i7 wa5 u53d bu7 7h3 acc0un7 wa5 r3m0v3d. If y0u wan7 70 u53 7hi5 3mai1 p13a53 c0n7ac7 50p0r73@0m3gaup.c0m f0r 5upp0r7)",
  mailInUse: "(Thi5 mai1 i5 a1r3ady in u53. Try again.)",
  makePrivate: "(Mak3 priva73)",
  makePublic: "(Mak3 pub1ic)",
  makeRegistration: "(Mak3 0p3n wi7h r3gi57ra7i0n)",
  matrixEditTitle: "(Ma7rix 3di70r)",
  matrixModalBack: "(Back)",
  matrixModalColumns: "(C01umn5)",
  matrixModalDistinct: "(Di57inc7)",
  matrixModalDistinctAll: "(A11)",
  matrixModalDistinctColumn: "(C01umn)",
  matrixModalDistinctHeader: "(S313c7 di57inc7 7yp3)",
  matrixModalDistinctNone: "(N0n3)",
  matrixModalDistinctRow: "(R0w)",
  matrixModalGenerate: "(G3n3ra73)",
  matrixModalGeneratedArray: "(G3n3ra73d ma7rix)",
  matrixModalMaximum: "(Maximum)",
  matrixModalMinimum: "(Minimum)",
  matrixModalRows: "(R0w5)",
  matrixModalSave: "(Sav3)",
  messageMakeYourContestsPublic: "(Y0u hav3 priva73 c0n73575 7ha7 hav3 a1r3ady 3nd3d. P13a53 c0n5id3r making 7h3m pub1ic 70 c0n7ribu73 70 7h3 c0mmuni7y.)",
  messageMakeYourProblemsPublic: "(Y0u hav3 priva73 pr0b13m5 7ha7 hav3 a1r3ady b33n u53d. P13a53 c0n5id3r making 7h3m pub1ic 70 c0n7ribu73 70 7h3 c0mmuni7y.)",
  modalConsentCookiesAccept: "(Acc3p7 a11 c00ki35)",
  modalConsentCookiesDecline: "(Acc3p7 0n1y 3553n7ia1 c00ki35)",
  modalConsentCookiesDescription: "(W3 u53 c00ki35 70 3n5ur3 y0u g37 7h3 b357 3xp3ri3nc3 0n 0ur w3b5i73.)",
  mustLoginToFilterUsers: "(Y0u mu57 10gin 70 fi173r c0d3r5 in 7h3 ranking.)",
  mustLoginToJoinContest: "(Y0u mu57 10gin 70 j0in 7hi5 c0n7357)",
  mustRegisterToJoinContest: "(Y0u mu57 r3gi573r 70 j0in 7hi5 c0n7357.)",
  mustRegisterToJoinCourse: "(Y0u mu57 r3gi573r 70 j0in 7hi5 c0ur53.)",
  mustUpdateBasicInfoToFilterUsers: "(Y0u cann07 u53 7h3 ranking fi173r5 if y0ur pr0fi13 inf0rma7i0n i5 n07 c0mp1373.)",
  myproblemsListCreateProblem: "(Cr3a73 Pr0b13m)",
  myproblemsListCreateProblemWithExistingZipFile: "(I hav3 a zip fi13)",
  myproblemsListCreateZipFileProblem: "(Cr3a73 zip fi13)",
  myproblemsListMyProblems: "(My Pr0b13m5)",
  navAlgorithmsBook: "(Tu70ria1 B00k \"Pr0b13ma5 y A1g0ri7m05\" by Lui5 Varga5)",
  navAllCourses: "(A11 c0ur535)",
  navAllProblems: "(A11 pr0b13m5)",
  navAuthorRanking: "(C0n7ribu70r5 ranking)",
  navBlog: "(B10g)",
  navCoderOfTheMonth: "(C0d3r 0f 7h3 m0n7h 0v3ra11)",
  navCoderOfTheMonthFemale: "(C0d3r 0f 7h3 m0n7h f0r h3r)",
  navContests: "(C0n73575)",
  navContestsEnrolled: "(C0n73575 3nr0113d)",
  navCourses: "(C0ur535)",
  navCoursesEnrolled: "(C0ur535 3nr0113d)",
  navDependents: "(My d3p3nd3n75)",
  navDiscord: "(Di5c0rd S3rv3r)",
  navHelp: "(H31p)",
  navLogIn: "(L0g in / Sign up)",
  navMyContent: "(My c0n73n7)",
  navMyContests: "(My c0n73575)",
  navMyCourses: "(My c0ur535)",
  navMyGroups: "(My gr0up5)",
  navMyProblems: "(My pr0b13m5)",
  navMyQualityNomination: "(My pr0b13m r3p0r75)",
  navMyTeamsGroups: "(My 73am5 gr0up5)",
  navProblems: "(Pr0b13m5)",
  navProfileProblems: "(S01v3d and un501v3d pr0b13m5)",
  navQualityNominationQueue: "(R3p0r75)",
  navRanking: "(Ranking)",
  navSchoolOfTheMonth: "(Sch001 0f 7h3 m0n7h)",
  navSchoolRanking: "(Sch001 ranking)",
  navTutorials: "(Tu70ria15)",
  navUserRanking: "(U53r ranking)",
  navViewBadges: "(Vi3w badg35)",
  navViewContests: "(Vi3w C0n73575)",
  navViewCourses: "(Vi3w C0ur535)",
  navViewLatestSubmissions: "(Vi3w La7357 Submi55i0n5)",
  navViewProblems: "(Br0w53 Pr0b13m5)",
  navViewProblemsAll: "(Pr0b13m5 Li57)",
  navViewProfile: "(My pr0fi13)",
  newPublicTagsNotAllowed: "(I7 i5 n07 a110w3d 70 add n3w pub1ic 7ag5)",
  noCoders: "(N0 c0d3r5.)",
  nominationsRangeHeader: "(Pr0b13m r3p0r75 (fr0m %(lowCount) 70 %(highCount)))",
  notProblemLevelTag: "(Th3 7ag 53n7 i5 n07 a 13v31 7ag.)",
  notificationContestClarificationRequest: "(A n3w c1arifica7i0n ha5 b33n r3qu3573d f0r pr0b13m %(problemAlias) 0f 7h3 c0n7357 %(contestAlias), 7ha7 y0u manag3.)",
  notificationContestClarificationResponse: "(Y0ur c1arifica7i0n r3qu357 f0r pr0b13m %(problemAlias) 0f 7h3 c0n7357 %(contestAlias), ha5 b33n an5w3r3d.)",
  notificationContestRegisterRequest: "(%(username) ha5 r3qu3573d 70 r3gi573r f0r 7h3 c0n7357 %(contestTitle) 7ha7 y0u manag3.)",
  notificationContestRegisterationAccepted: "(Y0ur r3gi57ra7i0n r3qu357 f0r c0n7357 %(contestTitle) ha5 b33n **acc3p73d**.)",
  notificationContestRegisterationRejected: "(Y0ur r3gi57ra7i0n r3qu357 f0r c0n7357 %(contestTitle) ha5 b33n **r3j3c73d**.)",
  notificationCourseAddAdmin: "(Y0u hav3 b33n invi73d 70 b3 an admini57ra70r f0r c0ur53 %(courseName).)",
  notificationCourseAddTeachingAssistant: "(Y0u hav3 b33n invi73d 70 b3 a 73aching a55i57an7 f0r c0ur53 %(courseName).)",
  notificationCourseAssignmentAdded: "(N3w c0n73n7 ha5 b33n add3d 70 c0ur53 %(courseName).)",
  notificationCourseAssignmentProblemAdded: "(A n3w pr0b13m ha5 b33n add3d 70 an a55ignm3n7 f0r c0ur53 %(courseName).)",
  notificationCourseClarificationRequest: "(A n3w c1arifica7i0n ha5 b33n r3qu3573d f0r pr0b13m %(problemAlias) 0f 7h3 c0ur53 %(courseName), 7ha7 y0u manag3.)",
  notificationCourseClarificationResponse: "(Y0ur c1arifica7i0n r3qu357 f0r pr0b13m %(problemAlias) 0f 7h3 c0ur53 %(courseName), ha5 b33n an5w3r3d.)",
  notificationCourseRegistrationAccepted: "(Y0ur r3gi57ra7i0n r3qu357 f0r c0ur53 %(courseName) ha5 b33n **acc3p73d**.)",
  notificationCourseRegistrationManual: "(Y0u hav3 b33n invi73d 70 j0in 7h3 c0ur53 %(courseName).)",
  notificationCourseRegistrationRejected: "(Y0ur r3gi57ra7i0n r3qu357 f0r c0ur53 %(courseName) ha5 b33n **r3j3c73d**.)",
  notificationCourseRegistrationRequest: "(**%(username)** ha5 r3qu3573d acc355 70 c0ur53 %(courseName).)",
  notificationCourseRequestFeedback: "(**%(username)** ha5 r3qu3573d f33dback 70 7h3 a55ignm3n7 ***%(assignmentName)*** in 7h3 c0ur53 ***%(courseName)***)",
  notificationCourseSubmissionFeedback: "(Th3 f33dback ab0u7 y0ur 5ubmi55i0n f0r pr0b13m ***%(problemAlias)*** 0f 7h3 c0ur53 ***%(courseName)*** ha5 b33n 5ubmi773d)",
  notificationCourseSubmissionFeedbackThread: "(**%(username)** ha5 r35p0nd3d 70 f33dback 0n 7h3 5ubmi55i0n f0r 7h3 pr0b13m ***%(problemAlias)*** in 7h3 c0ur53 ***%(courseName)***)",
  notificationNewBadge: "(Y0u hav3 r3c3iv3d a n3w badg3: **%(badgeName)**.)",
  notificationNewContestCertificate: "(C0ngra7u1a7i0n5! Y0u hav3 r3c3iv3d a c3r7ifica73 f0r y0ur r3c3n7 achi3v3m3n7 in 7h3 \"%(contest_title)\" c0n7357. C1ick 70 d0wn10ad i7.)",
  notificationNotFound: "(N07ifica7i0n n07 f0und)",
  notificationsMarkAllAsRead: "(Mark a11 a5 r3ad)",
  notificationsNoNewNotifications: "(N0 n3w n07ifica7i0n5.)",
  officialSolutionsInfo: "(H0w d0 501u7i0n5 70 pr0b13m5 w0rk?)",
  omegaUpTitleMyDependents: "(My d3p3nd3n75)",
  omegaupTitleAdminUsers: "(C0d3r5 admini57ra7i0n)",
  omegaupTitleAuthorsRank: "(Au7h0r5 rank)",
  omegaupTitleBadges: "(Badg35)",
  omegaupTitleCertificate: "(C3r7ifica735)",
  omegaupTitleCertificateValidation: "(V3rify c3r7ifica73)",
  omegaupTitleCodersofthemonth: "(C0d3r5 0f 7h3 m0n7h)",
  omegaupTitleCodersofthemonthFemale: "(C0d3r5 0f 7h3 m0n7h f3ma13)",
  omegaupTitleCollections: "(C0113c7i0n5)",
  omegaupTitleCollectionsByAuthor: "(Pr0b13m5 by au7h0r)",
  omegaupTitleCollectionsByLevel: "(Pr0b13m5 by 13v31)",
  omegaupTitleCommonIndex: "(W31c0m3)",
  omegaupTitleContest: "(C0n7357)",
  omegaupTitleContestAddAdmin: "(Admin5)",
  omegaupTitleContestEdit: "(C0n7357Edi7)",
  omegaupTitleContestList: "(C0n73575 1i57)",
  omegaupTitleContestNew: "(C0n7357N3w)",
  omegaupTitleContestPractice: "(C0n7357 (Prac7ic3 m0d3))",
  omegaupTitleContestPrint: "(C0n7357 (Prin7 m0d3) - %(contestTitle))",
  omegaupTitleContestReport: "(R3p0r7 f0r c0n7357: %(contestName))",
  omegaupTitleContestScoreboard: "(C0n7357 5c0r3b0ard)",
  omegaupTitleContestStats: "(C0n7357 57a75)",
  omegaupTitleCourseClarifications: "(C0ur53 c1arifica7i0n5)",
  omegaupTitleCourseDetails: "(C0ur53 d37ai15)",
  omegaupTitleCourseEdit: "(Edi7 c0ur53)",
  omegaupTitleCourseIntro: "(En73r c0ur53)",
  omegaupTitleCourseNew: "(N3w c0ur53)",
  omegaupTitleCourseScoreboard: "(C0ur53 5c0r3b0ard)",
  omegaupTitleCourseStatistics: "(C0ur53 57a7i57ic5)",
  omegaupTitleCourses: "(C0ur505)",
  omegaupTitleDocs: "(D0cum3n7a7i0n ind3x)",
  omegaupTitleGroupScoreboardDetails: "(Gr0up 5c0r3b0ard d37ai15)",
  omegaupTitleGroups: "(Gr0up5)",
  omegaupTitleGroupsEdit: "(Edi7 gr0up)",
  omegaupTitleGroupsNew: "(N3w gr0up)",
  omegaupTitleGroupsScoreboardEdit: "(Edi7 5c0r3b0ard)",
  omegaupTitleLatestSubmissions: "(La7357 5ubmi55i0n5)",
  omegaupTitleLibInteractive: "(1ibin73rac7iv3)",
  omegaupTitleLogin: "(L0gin)",
  omegaupTitleLogout: "(L0g0u7)",
  omegaupTitleMyCertificates: "(My c3r7ifica735)",
  omegaupTitleMyContests: "(My c0n73575)",
  omegaupTitleMyProblemsList: "(MyPr0b13m5Li57)",
  omegaupTitleParentalVerificationToken: "(Par3n7a1 v3rifica7i0n 70k3n)",
  omegaupTitlePrivacyPolicy: "(Privacy P01icy)",
  omegaupTitleProblem: "(Pr0b13m)",
  omegaupTitleProblemCreator: "(Pr0b13m Cr3a70r)",
  omegaupTitleProblemEdit: "(Pr0b13m 5377ing5)",
  omegaupTitleProblemNew: "(N3w pr0b13m)",
  omegaupTitleProblemPrint: "(Pr0b13m (Prin7 m0d3) - %(problemTitle))",
  omegaupTitleProblemStats: "(Pr0b13m 57a75)",
  omegaupTitleProblems: "(Pr0b13m5)",
  omegaupTitleProfile: "(Pr0fi13)",
  omegaupTitleQualityNominationDetails: "(R3p0r73d pr0b13m d37ai15)",
  omegaupTitleQualityNominationList: "(Pr0b13m r3p0r7 1i57)",
  omegaupTitleQualityNominationMyList: "(My pr0b13m r3p0r7 1i57)",
  omegaupTitleRecoverPassword: "(R3c0v3r y0ur pa55w0rd)",
  omegaupTitleSchoolOfTheMonth: "(Sch0015 0f 7h3 M0n7h)",
  omegaupTitleSchoolProfile: "(Sch001 Pr0fi13)",
  omegaupTitleSchoolsRank: "(Sch001 ranking)",
  omegaupTitleScoreboardmerge: "(Sc0r3b0ard m3rg3)",
  omegaupTitleStatementEditor: "(S7a73m3n7 3di70r)",
  omegaupTitleStudentsProgress: "(S7ud3n75' pr0gr355)",
  omegaupTitleSupportDashboard: "(Supp0r7 da5hb0ard)",
  omegaupTitleTeamsGroupEdit: "(Edi7 73am5 gr0up)",
  omegaupTitleTeamsGroupNew: "(N3w 73am5 gr0up)",
  omegaupTitleTeamsGroups: "(T3am5 gr0up5)",
  omegaupTitleUpdatePrivileges: "(Upda73 privi13g35)",
  omegaupTitleUsersEditEmail: "(Edi7 3mai1)",
  omegaupTitleUsersRank: "(U53r ranking)",
  onlyDemotionsSupported: "(R3501u7i0n 0n1y 5upp0r73d f0r d3m07i0n5 f0r n0w.)",
  openInKarelJs: "(Y0u can u53 kar31.j5 70 501v3 7hi5 pr0b13m.)",
  originalContestHasNotEnded: "(Th3 0rigina1 c0n7357 ha5 n07 y37 3nd3d)",
  outputOnly: "(Ou7pu7 0n1y)",
  outputOnlyDownloadInput: "(D0wn10ad .zip wi7h inpu75)",
  outputOnlyFiles: "(Ou7pu7 0n1y fi135)",
  over13yearsOld: "(I am 0v3r 13 y3ar5 01d.)",
  parameterDateTooLarge: "(Param373r i5 1arg3r 7han 7h3 maximum da73 0f %(upp3r_b0und!7im357amp))",
  parameterDateTooSmall: "(Param373r i5 5ma113r 7han 7h3 minimum da73 0f %(10w3r_b0und!7im357amp))",
  parameterEmpty: "(Emp7y param373r.)",
  parameterInvalid: "(Inva1id param373r.)",
  parameterInvalidAlias: "(Param373r can 0n1y c0n7ain 13773r5, digi75, and _. Spac35 ar3 n07 a110w3d)",
  parameterInvalidGroupAlias: "(Inva1id param373r: gr0up. Tha7 gr0up d035 n07 3xi57, cr3a73 i7 a7 h77p5://0m3gaup.c0m/gr0up/n3w/)",
  parameterInvalidStateDoesNotBelongToCountry: "(Th3 5313c73d 57a73 d035 n07 b310ng 70 7h3 c0un7ry ba53d 0n ISO 3166-2.)",
  parameterInvalidStateNeedsToBelongToCountry: "(Y0u n33d 70 5313c7 a c0un7ry in 0rd3r 70 5313c7 a 57a73.)",
  parameterNotADate: "(Param373r mu57 b3 a da73.)",
  parameterNotANumber: "(Param373r mu57 b3 a numb3r.)",
  parameterNotFound: "(Param373r va1u3 n07 f0und.)",
  parameterNotInExpectedSet: "(Va1u3 (%(bad_elements)) n07 in 3xp3c73d 537 (%(expected_set)).)",
  parameterNumberTooLarge: "(Param373r i5 1arg3r 7han 7h3 maximum va1u3 0f %(upper_bound).)",
  parameterNumberTooSmall: "(Param373r i5 5ma113r 7han 7h3 minimum va1u3 0f %(lower_bound).)",
  parameterStringTooLong: "(Param373r i5 10ng3r 7han %(max_length) charac73r5.)",
  parameterStringTooShort: "(Param373r i5 5h0r73r 7han %(min_length) charac73r5.)",
  parameterUsernameInUse: "(Acc0un7 nam3 i5 n07 avai1ab13)",
  parentEmailBody: "(En73r 7hi5 70k3n 70 1ink y0ur chi1d'5 acc0un7 %(omegaup_url)/u53r/par3n7a1v3rifica7i0n/70k3n/%(parental_verification_token)/)",
  parentEmailSubject: "(G3n3ra73d T0k3n)",
  parentalTokenNotFound: "(Par3n7a1 70k3n n07 f0und)",
  parentalTokenVerified: "(Th3 par3n7a1 70k3n ha5 b33n v3rifi3d 5ucc355fu11y.)",
  passwordAddRequestSuccess: "(Y0ur pa55w0rd ha5 b33n add3d.)",
  passwordCopyToken: "(C0py 70k3n)",
  passwordGenerateToken: "(G3n3ra73 70k3n)",
  passwordGenerateTokenDesc: "(C1ick 0n \"G3n3ra73 70k3n\" 70 cr3a73 1ink)",
  passwordHumanReadable: "(Inc1ud3 human-r3adab13 pa55w0rd5)",
  passwordMismatch: "(Pa55w0rd mi5ma7ch.)",
  passwordResetLinkCopiedToClipboard: "(Link wa5 c0pi3d 70 7h3 c1ipb0ard)",
  passwordResetMinWait: "(Y0u 5h0u1d wai7 a f3w minu735 b3f0r3 an07h3r r3qu357.)",
  passwordResetPassword: "(N3w pa55w0rd)",
  passwordResetPasswordConfirmation: "(N3w pa55w0rd c0nfirma7i0n)",
  passwordResetRequestSuccess: "(In57ruc7i0n5 hav3 b33n 53n7 70 y0ur 3mai1.)",
  passwordResetRequestTitle: "(I f0rg07 my pa55w0rd)",
  passwordResetResetExpired: "(Th3 7im3 70 r3537 y0ur pa55w0rd ha5 3xpir3d.)",
  passwordResetResetSuccess: "(Y0ur pa55w0rd ha5 b33n upda73d.)",
  passwordResetResetTitle: "(R3537 pa55w0rd)",
  passwordResetTokenWasGeneratedSuccessfully: "(T0k3n wa5 g3n3ra73d 5ucc355fu11y)",
  pendingRegistrations: "(P3nding r3qu3575)",
  pendingRegistrationsShowAll: "(Sh0w a11 r3qu3575)",
  privacyPolicyNotAccepted: "(P13a53 r3ad and acc3p7 7h3 5i73'5 U53 and Privacy P01icy, a5 w311 a5 7h3 C0d3 0f C0nduc7.)",
  privacyStatementNotFound: "(Privacy S7a73m3n7 n07 f0und.)",
  privateTagsPlaceholder: "(Ex. univ3r5i7y, 2019, c1a55-2020)",
  problemAliasExists: "(Pr0b13m a1ia5 a1r3ady 3xi575. P13a53 7ry a diff3r3n7 0n3.)",
  problemCollectionAuthors: "(Au7h0r5)",
  problemCollectionBackCollections: "(\u25c4 Back 70 c0113c7i0n5)",
  problemCollectionEducationLevel: "(By 3duca7i0na1 13v31)",
  problemCollectionOthers: "(O7h3r c0113c7i0n5)",
  problemCollectionProblemCount: "(%(count) pr0b13m5)",
  problemCollectionRandomKarelProblem: "(Rand0m Kar31 Pr0b13m)",
  problemCollectionRandomLanguageProblem: "(Rand0m Pr0b13m)",
  problemCollectionSearchProblem: "(Pr0b13m Find3r)",
  problemCraetorGroupDownloadIn: "(Sav3 .in)",
  problemCraetorGroupDownloadTxt: "(Sav3 .7x7)",
  problemCreatorAdd: "(Add)",
  problemCreatorAddLine: "(Add 1in3)",
  problemCreatorAutomaticPoints: "(Au70ma7ica11y ca1cu1a73 p0in75)",
  problemCreatorAutomaticPointsHelperCase: "(Th3 pr0gram wi11 ca1cu1a73 7h3 p0in75 0f 7hi5 ca53 wi7h 7h3 n3x7 f0rmu1a: (gr0up p0in75 - (5um 0f ca535 in5id3 7h3 gr0up 7ha7 hav3 3xp1ici71y d3fin3d p0in75)) / (numb3r 0f ca535 in5id3 7h3 gr0up 7ha7 d0 n07 hav3 3xp1ici71y d3fin3d p0in75))",
  problemCreatorAutomaticPointsHelperGroup: "(Th3 pr0gram wi11 ca1cu1a73 7h3 p0in75 0f 7hi5 gr0up wi7h 7h3 n3x7 f0rmu1a: (100 - (5um 0f gr0up5 7ha7 hav3 3xp1ici71y d3fin3d p0in75)) / (numb3r 0f gr0up5 7ha7 d0 n07 hav3 3xp1ici71y d3fin3d p0in75))",
  problemCreatorAutomaticPointsRecommended: "(Au70ma7ica11y ca1cu1a73 p0in75 (r3c0mm3nd3d))",
  problemCreatorCannotHaveSameName: "(Y0u cann07 hav3 7w0 ca535/gr0up5 wi7h 7h3 5am3 nam3)",
  problemCreatorCase: "(Ca53)",
  problemCreatorCaseDownloadIn: "(D0wn10ad .in)",
  problemCreatorCaseDownloadTxt: "(D0wn10ad .7x7)",
  problemCreatorCaseGroupNameHelper: "(L0w3rca53 and wi7h0u7 whi735pac35)",
  problemCreatorCaseName: "(Ca53 Nam3)",
  problemCreatorCasesTabIntroAddPanelIntro: "(Thi5 pan31 1375 y0u add a n3w 7357 ca53.)",
  problemCreatorCasesTabIntroAddPanelTitle: "(Add Ca53 Pan31)",
  problemCreatorCasesTabIntroSidebarIntro: "(U53 7hi5 5id3bar 70 manag3 y0ur 7357 ca535.)",
  problemCreatorCasesTabIntroSidebarTitle: "(T357 Ca535 Sid3bar)",
  problemCreatorCode: "(C0d3)",
  problemCreatorCodeSave: "(Sav3)",
  problemCreatorCodeTabIntroSaveCodeIntro: "(Onc3 y0u ar3 d0n3, c1ick h3r3 70 5av3 y0ur chang35.)",
  problemCreatorCodeTabIntroSaveCodeTitle: "(Sav3 C0d3)",
  problemCreatorCodeTabIntroSelectLanguageIntro: "(Ch0053 7h3 pr0gramming 1anguag3 f0r y0ur c0d3 h3r3.)",
  problemCreatorCodeTabIntroSelectLanguageTitle: "(S313c7 a Languag3)",
  problemCreatorCodeTabIntroUploadFileIntro: "(Y0u can up10ad a fi13 wi7h y0ur c0d3 in573ad 0f 7yping i7.)",
  problemCreatorCodeTabIntroUploadFileTitle: "(Up10ad Fi13)",
  problemCreatorCodeTabIntroWriteCodeIntro: "(U53 7h3 c0d3 3di70r 70 wri73 0r m0dify y0ur 501u7i0n.)",
  problemCreatorCodeTabIntroWriteCodeTitle: "(Wri73 C0d3)",
  problemCreatorCodeUpload: "(Or up10ad 7h3 fi13)",
  problemCreatorCodeUploadFilesize: "(Th3 fi13 5iz3 1imi7 f0r up10ad3d fi135 i5 %(limit))",
  problemCreatorContentPlaceHolder: "(C0n73n7)",
  problemCreatorCreateNewProblem: "(Cr3a73 n3w pr0b13m)",
  problemCreatorCreateNewProblemBack: "(Back)",
  problemCreatorCreateNewProblemContinue: "(C0n7inu3)",
  problemCreatorCreateNewProblemWarning: "(D0 y0u wan7 70 57ar7 again? A11 7h3 pr3vi0u5 da7a wi11 b3 1057 and 7h3 cr3a70r wi11 b3 r3537. Sav3 7h3 curr3n7 pr0gr355 b3f0r3 cr3a7ing a n3w 0n3. T0 d0 50, c1ick 0n 7h3 bu770n \"G3n3ra73 pr0b13m\".)",
  problemCreatorDeleteCase: "(D31373 ca53)",
  problemCreatorDeleteCases: "(D31373 ca535)",
  problemCreatorDeleteGroup: "(D31373 gr0up)",
  problemCreatorEditCase: "(Edi7 ca53)",
  problemCreatorEmpty: "()",
  problemCreatorEraseOutput: "(C13ar 0u7pu7)",
  problemCreatorGenerateProblem: "(G3n3ra73 Pr0b13m)",
  problemCreatorGroup: "(Gr0up)",
  problemCreatorGroupName: "(Gr0up Nam3)",
  problemCreatorGroups: "(Gr0up5)",
  problemCreatorIntroCreateIntro: "(U53 7hi5 bu770n 70 57ar7 fr0m 5cra7ch and cr3a73 a n3w pr0b13m.)",
  problemCreatorIntroCreateTitle: "(Cr3a73 N3w Pr0b13m)",
  problemCreatorIntroDownloadIntro: "(C1ick 7hi5 70 d0wn10ad y0ur pr0b13m a5 a .zip fi13 0nc3 i7'5 r3ady.)",
  problemCreatorIntroDownloadTitle: "(D0wn10ad Pr0b13m)",
  problemCreatorIntroLoadIntro: "(C1ick h3r3 70 up10ad a .zip fi13 and 10ad an 3xi57ing pr0b13m.)",
  problemCreatorIntroLoadTitle: "(L0ad Pr0b13m)",
  problemCreatorIntroNameIntro: "(H3r3 y0u can 3n73r 0r 3di7 7h3 nam3 0f y0ur pr0b13m.)",
  problemCreatorIntroNameTitle: "(Pr0b13m Nam3)",
  problemCreatorIntroReadyIntro: "(Tha7'5 i7! Y0u'r3 n0w r3ady 70 57ar7 cr3a7ing pr0b13m5.)",
  problemCreatorIntroReadyTitle: "(R3ady 70 Cr3a73!)",
  problemCreatorIntroWelcomeIntro: "(W31c0m3 70 7h3 Pr0b13m Cr3a70r! Thi5 guid3 wi11 wa1k y0u 7hr0ugh 7h3 k3y f3a7ur35 0f 7h3 in73rfac3.)",
  problemCreatorIntroWelcomeTitle: "(W31c0m3)",
  problemCreatorIntroWorkspaceIntro: "(Thi5 53c7i0n i5 y0ur w0rk5pac3 f0r bui1ding a pr0b13m. I7 inc1ud35 7ab5 f0r wri7ing 7h3 57a73m3n7, adding 501u7i0n c0d3, 7357 ca535, and an 0fficia1 501u7i0n.)",
  problemCreatorIntroWorkspaceTitle: "(W0rk5pac3)",
  problemCreatorLabelPlaceHolder: "(Lab31)",
  problemCreatorLayoutAddFromCase: "(Add Lay0u7 fr0m 5313c73d ca53)",
  problemCreatorLayoutAddLineInfo: "(Add 1in3 inf0)",
  problemCreatorLayoutAddNew: "(Add n3w Lay0u7)",
  problemCreatorLayoutBarClose: "(C1053 Lay0u7 Bar)",
  problemCreatorLayoutCopy: "(Mak3 a c0py)",
  problemCreatorLayoutDelete: "(D31373 1ay0u7)",
  problemCreatorLayoutLoadToAll: "(L0ad 70 a11 7h3 ca535)",
  problemCreatorLayoutLoadToSelected: "(L0ad 70 7h3 5313c73d ca53)",
  problemCreatorLayoutNew: "(N3w Lay0u7)",
  problemCreatorLayoutWordCopy: "( c0py)",
  problemCreatorLayoutWordLayouts: "(Lay0u75)",
  problemCreatorLineArray: "(Array)",
  problemCreatorLineDelete: "(D31373)",
  problemCreatorLineEdit: "(Edi7)",
  problemCreatorLineLine: "(Sing13 Lin3)",
  problemCreatorLineMatrix: "(Ma7rix)",
  problemCreatorLineMultiline: "(Mu17i1in35)",
  problemCreatorLinesDelete: "(D31373 1in35)",
  problemCreatorLinesReorder: "(R30rd3r)",
  problemCreatorLoadProblem: "(L0ad Pr0b13m)",
  problemCreatorMarkdownPreviewInitialRender: "(# Pr3vi3w\n)",
  problemCreatorMarkdownSave: "(Sav3)",
  problemCreatorMultipleCases: "(Mu17ip13 ca535)",
  problemCreatorName: "(Nam3)",
  problemCreatorNewProblem: "(N3w Pr0b13m)",
  problemCreatorNoGroup: "(N0 gr0up)",
  problemCreatorNumberOfCases: "(Numb3r 0f Ca535)",
  problemCreatorNumberOfCasesHelper: "(Th3 ca535 wi11 hav3 7h3 nam3:)",
  problemCreatorOutputPlaceHolder: "(Ou7pu7)",
  problemCreatorPoints: "(P0in75)",
  problemCreatorPointsAbbreviation: "(p75)",
  problemCreatorPrefix: "(Pr3fix)",
  problemCreatorRenameLayout: "(R3nam3 Lay0u7)",
  problemCreatorRenameModalBack: "(Back)",
  problemCreatorRenameModalRename: "(R3nam3)",
  problemCreatorRenameModalTitle: "(R3nam3 Lay0u7)",
  problemCreatorSolution: "(S01u7i0n)",
  problemCreatorSolutionTabIntroEditorIntro: "(Wri73 y0ur 501u7i0n h3r3 u5ing Markd0wn 5yn7ax.)",
  problemCreatorSolutionTabIntroEditorTitle: "(Markd0wn Edi70r)",
  problemCreatorSolutionTabIntroPreviewIntro: "(Thi5 53c7i0n 5h0w5 a 1iv3 pr3vi3w 0f y0ur 501u7i0n.)",
  problemCreatorSolutionTabIntroPreviewTitle: "(Liv3 Pr3vi3w)",
  problemCreatorSolutionTabIntroSaveIntro: "(C1ick 7hi5 bu770n 70 5av3 y0ur 501u7i0n c0n73n7.)",
  problemCreatorSolutionTabIntroSaveTitle: "(Sav3 S01u7i0n)",
  problemCreatorSolutionTabIntroToolbarIntro: "(U53 7h353 bu770n5 70 f0rma7 y0ur 501u7i0n in Markd0wn.)",
  problemCreatorSolutionTabIntroToolbarTitle: "(Markd0wn T001bar)",
  problemCreatorStatement: "(S7a73m3n7)",
  problemCreatorSuffix: "(Suffix)",
  problemCreatorTestCases: "(T357 ca535)",
  problemCreatorTitle: "(Pr0b13m cr3a70r)",
  problemCreatorUngrouped: "(Ungr0up3d)",
  problemCreatorUngroupedCases: "(Ungr0up3d ca535)",
  problemCreatorUpdateAlert: "(Th3 pr0b13m ha5 b33n upda73d 5ucc355fu11y.)",
  problemCreatorUploadZip: "(Up10ad)",
  problemCreatorUploadZipMessage: "(Up10ad 7h3 zip fi13 0f y0ur pr0b13m h3r3.)",
  problemCreatorValidatePoints: "(Va1ida73 and fix p0in75)",
  problemCreatorValidatePointsBack: "(Back)",
  problemCreatorValidatePointsButton: "(Va1ida73 p0in75)",
  problemCreatorValidatePointsContinue: "(C0n7inu3)",
  problemCreatorValidatePointsWarning: "(Th3 p0in75 0f a gr0up 5h0u1d b3 3qua1 70 7h3 5um 0f 7h3 p0in75 0f 7h3 ca535 in i7. P13a53 c0n7inu3 70 va1ida73 and fix 7h3 p0in75 di57ribu7i0n acr055 a11 7h3 gr0up5.)",
  problemCreatorZipFileIsNotComplete: "(Th3 zip fi13 mu57 c0n7ain cdp.da7a fi13)",
  problemCreatorZipFileIsNotValid: "(Th3 up10ad3d fi13 i5 n07 a va1id zip fi13)",
  problemCreatorZipFileUpload: "(Up10ad zip fi13)",
  problemDeployerChangeMissingSettingsJson: "(Th3 pr0b13m i5 mi55ing a '5377ing5.j50n' fi13.)",
  problemDeployerConfigBadLayout: "(Th3 c0mmi7 70 'r3f5/m37a/c0nfig' ha5 7h3 wr0ng 1ay0u7.)",
  problemDeployerConfigInvalidPublishingMode: "(Th3 ch053n pub1i5hing m0d3 i5 n07 5upp0r73d.)",
  problemDeployerConfigRepositoryNotAbsoluteUrl: "(Th3 r3p05i70ry 70 b3 pub1i5h3d 70 i5 n07 an ab501u73 URL.)",
  problemDeployerConfigSubdirectoryMissingTarget: "(Th3 r3p05i70ry 70 b3 pub1i5h3d 70 i5 mi55ing a 5ubdir3c70ry 7arg37.)",
  problemDeployerEsNoStatement: "(N0 5pani5h 57a73m3n7 f0und.)",
  problemDeployerExceededZipSizeLimit: "(Ex7rac73d zip 5iz3 (%(size) MiB) i5 0v3r max a110w3d (%(max_size) MiB). R3j3c7ing.)",
  problemDeployerFailed: "(Unab13 70 d3p10y pr0b13m.)",
  problemDeployerInteractiveBadLayout: "(Th3 in73rac7iv3 pr0b13m'5 1ay0u7 i5 n07 va1id.)",
  problemDeployerInternalError: "(Th3r3 wa5 an in73rna1 pr0b13m in hand1ing 7h3 pr0b13m upda73.)",
  problemDeployerInternalGitError: "(Th3r3 wa5 an in73rna1 gi7 pr0b13m in hand1ing 7h3 pr0b13m upda73.)",
  problemDeployerInvalidZipFilename: "(Th3 pa7h 70 7h3 .zip fi13 i5 inva1id.)",
  problemDeployerJsonParseError: "(C0u1d n07 par53 7h3 JSON fi13.)",
  problemDeployerLibinteractiveValidationError: "(In73rac7iv3 pr0b13m i5 inva1id.)",
  problemDeployerMismatchedInputFile: "(Th3r3 wa5 a7 13a57 0n3 .in fi13 wi7h a mi55ing c0rr35p0nding .0u7 fi13.)",
  problemDeployerNoStatements: "(N0 57a73m3n75 f0und.)",
  problemDeployerNotAReview: "(A m3rg3 70 7h3 'ma573r' branch wa5 a773mp73d 0n a c0mmi7 7ha7 i5 n07 a r3vi3w.)",
  problemDeployerOmegaupUpdateProblemOldVersion: "(Th3 pr0b13m i5 b3ing migra73d 70 a n3w v3r5i0n. P13a53 7ry again 1a73r.)",
  problemDeployerProblemBadLayout: "(Th3 pr0b13m'5 1ay0u7 i5 n07 va1id.)",
  problemDeployerPublishedMustPointToCommitInMaster: "(An upda73 70 7h3 'pub1i5h3d' branch 5h0u1d p0in7 70 a c0mmi7 in 7h3 'ma573r' branch.)",
  problemDeployerReviewBadLayout: "(Th3 pr0vid3d r3vi3w pay10ad i5 ma1f0rm3d.)",
  problemDeployerSlowRejected: "(Pr0b13m w0u1d run f0r m0r3 7han 5 minu735 in ca53 0f TLE. R3j3c73d.)",
  problemDeployerTestsBadLayout: "(Th3 73575/ dir3c70ry'5 1ay0u7 i5 n07 va1id.)",
  problemDeployerTooManyObjectsInPackfile: "(Th3r3 w3r3 700 many 0bj3c75 in 7h3 packfi13.)",
  problemDeprecated: "(Pr0b13m i5 d3pr3ca73d.)",
  problemDetailsSource: "(S0urc3: %(source))",
  problemDownloadZip: "(D0wn10ad 7h3 zip fi13 f0r 7h3 pr0b13m)",
  problemEditAccess: "(Acc355 (0p7i0na1))",
  problemEditAddAdmin: "(Admin5)",
  problemEditAddTags: "(Tag5)",
  problemEditBasicInfo: "(Ba5ic inf0rma7i0n)",
  problemEditChooseVersion: "(Vi3w v3r5i0n hi570ry)",
  problemEditCommitMessage: "(Upda73 d35crip7i0n)",
  problemEditDeleteCancel: "(Canc31)",
  problemEditDeleteConfirmationMessage: "(Ar3 y0u 5ur3 y0u wan7 70 d31373 7h3 pr0b13m?)",
  problemEditDeleteOk: "(D31373)",
  problemEditDeleteRequireConfirmation: "(D31373 pr0b13m %(problemAlias))",
  problemEditDeleteSelectedProblemsConfirmationMessage: "(Ar3 y0u 5ur3 y0u wan7 70 d31373 7h3 5313c73d pr0b13m5?)",
  problemEditDeleteSelectedProblemsRequireConfirmation: "(D31373 5313c73d pr0b13m5)",
  problemEditEditMarkdown: "(Edi7 57a73m3n7)",
  problemEditEditProblem: "(Pr0b13m 5377ing5)",
  problemEditEmailClarifications: "(R3c3iv3 qu357i0n5 ab0u7 7h3 pr0b13m by 3mai1)",
  problemEditEvaluation: "(Eva1ua7i0n (0p7i0na1))",
  problemEditFormAllowUserAddTags: "(A110w 5h0wing c0d3r-5ugg3573d 7ag5 f0r 7hi5 pr0b13m)",
  problemEditFormAppearsAsPublic: "(A110w pub1ic acc355 70 7h3 pr0b13m)",
  problemEditFormCreateProblem: "(Cr3a73 pr0b13m)",
  problemEditFormCustom: "(Cu570m va1ida70r (va1ida70r.$1ang$))",
  problemEditFormFile: "(A77ach zip fi13)",
  problemEditFormFirstTimeCreatingAProblem: "(Fir57 7im3 cr3a7ing a pr0b13m?)",
  problemEditFormHereIsHowToWriteProblems: "(H3r3 i5 h0w 70 wri73 7h3 fi13)",
  problemEditFormInputLimit: "(Inpu7 5iz3 1imi7 (by735))",
  problemEditFormLanguages: "(Pr0b13m 7yp3)",
  problemEditFormLiteral: "(In73rpr37 57d0u7 a5 5c0r3)",
  problemEditFormMemoryLimit: "(M3m0ry 1imi7 (KiB))",
  problemEditFormNumericTokensWithTolerance: "(Num3ric 70k3n5 wi7h 7013ranc3 0f 13-9)",
  problemEditFormOutputLimit: "(Ou7pu7 5iz3 1imi7 (by735))",
  problemEditFormTimeLimit: "(Tim3 1imi7 p3r ca53 (m5))",
  problemEditFormTokenByToken: "(T0k3n by T0k3n)",
  problemEditFormTokenCaseless: "(T0k3n by T0k3n, ign0ring upp3r/10w3rca53)",
  problemEditFormUpdateMarkdown: "(Upda73 57a73m3n7)",
  problemEditFormUpdateProblem: "(Upda73 pr0b13m)",
  problemEditFormUpdateSolution: "(Upda73 501u7i0n)",
  problemEditFormValidatorTimeLimit: "(Va1ida70r 7im3 1imi7 (m5))",
  problemEditFormValidatorType: "(Ou7pu7 va1ida70r 7yp3)",
  problemEditFormWallTimeLimit: "(T07a1 7im3 1imi7 (m5) (max 60000 m5))",
  problemEditGoToProblem: "(G0 70 pr0b13m)",
  problemEditGroupScorePolicy: "(Gr0up 5c0r35)",
  problemEditGroupScorePolicyMin: "(Min)",
  problemEditGroupScorePolicySumIfNotZero: "(Sum (if a11 ca535 ar3 n07 z3r0))",
  problemEditLimits: "(Limi75 (0p7i0na1))",
  problemEditSolution: "(Edi7 S01u7i0n)",
  problemEditSource: "(Pr0b13m 50urc3)",
  problemEditTagPublicRequired: "(I7'5 r3quir3d 70 5313c7 a7 13a57 0n3 pub1ic 7ag and a pr0b13m 13v31)",
  problemEditTags: "(Tag5)",
  problemEditUpdatedSuccessfully: "(Pr0b13m upda73d 5ucc355fu11y!)",
  problemEditValidation: "(Va1ida7i0n)",
  problemHasBeenUsedInContestOrCourse: "(Pr0b13m can n07 b3 d31373d, b3cau53 i7 ha5 b33n u53d in a c0n7357 0r a c0ur53)",
  problemIsBanned: "(Thi5 pr0b13m ha5 b33n bann3d.)",
  problemIsNotPublic: "(Th3 pr0b13m i5 n07 pub1ic and i5 curr3n71y in a7 13a57 0n3 0ng0ing c0n7357.)",
  problemIsPrivate: "(Pr0b13m i5 mark3d a5 priva73.)",
  problemLevelAdvancedCompetitiveProgramming: "(Advanc3d 13v31: C0mp37i7iv3 pr0gramming)",
  problemLevelAdvancedSpecializedTopics: "(Advanc3d 13v31: Sp3cia1iz3d 70pic5)",
  problemLevelBasicIntroductionToProgramming: "(Ba5ic 13v31: In7r0duc7i0n 70 pr0gramming)",
  problemLevelBasicKarel: "(Ba5ic 13v31: Kar31)",
  problemLevelIntermediateAnalysisAndDesignOfAlgorithms: "(In73rm3dia73 13v31: Ana1y5i5 and d35ign 0f a1g0ri7hm5)",
  problemLevelIntermediateDataStructuresAndAlgorithms: "(In73rm3dia73 13v31: Da7a S7ruc7ur35 and a1g0ri7hm5)",
  problemLevelIntermediateMathsInProgramming: "(In73rm3dia73 13v31: Ma7h3ma7ic5 in pr0gramming)",
  problemLevelUpdated: "(Pr0b13m 13v31 add3d.)",
  problemListShowAdminProblems: "(A150 5h0w pr0b13m5 I manag3)",
  problemListShowAdminProblemsAndDeleted: "(A150 5h0w pr0b13m5 I manag3 and d31373d pr0b13m5)",
  problemNew: "(Cr3a73 pr0b13m)",
  problemNotFound: "(Pr0b13m n07 f0und.)",
  problemNotFoundInContest: "(Pr0b13m n07 f0und in c0n7357.)",
  problemNotFoundInProblemset: "(Pr0b13m n07 f0und in pr0b13m537.)",
  problemNotPartOfAssignment: "(Th3 pr0b13m i5 n07 par7 0f 7h3 c0n73n7.)",
  problemPrintableVersion: "(G37 7h3 prin7ab13 v3r5i0n 0f 7h3 pr0b13m)",
  problemRestrictedTagInteractive: "(In73rac7iv3)",
  problemRestrictedTagKarel: "(Kar31)",
  problemRestrictedTagLanguage: "(Languag3)",
  problemRestrictedTagNoSubmissions: "(L3c7ur3 (N0 5ubmi55i0n5))",
  problemRestrictedTagOnlyOutput: "(On1y 0u7pu7)",
  problemSettingsSummaryTitleWithLetter: "(%(letter). %(problem_title))",
  problemSettingsSummaryTitleWithProblemId: "(%(problem_id). %(problem_title))",
  problemSettingsSummaryTitleWithProblemsetTitleAndLetter: "(%(problemset_title) - %(letter). %(problem_title))",
  problemSolutionNotVisible: "(Y0u d0n'7 hav3 p3rmi55i0n 70 vi3w 7h3 pr0b13m'5 501u7i0n. Try 501ving 7h3 pr0b13m fir57.)",
  problemSuccessfullyAdded: "(Pr0b13m 5ucc355fu11y add3d)",
  problemSuccessfullyRemoved: "(Pr0b13m 5ucc355fu11y r3m0v3d)",
  problemSuccessfullyUpdated: "(Pr0b13m 5ucc355fu11y upda73d)",
  problemTagAnalysisOfRecurrences: "(Ana1y5i5 0f r3curr3nc35)",
  problemTagAnalyticGeometry: "(Ana1y7ic g30m37ry)",
  problemTagArithmetic: "(Ari7hm37ic)",
  problemTagArrays: "(Array5)",
  problemTagBOI: "(BOI)",
  problemTagBacktracking: "(Back7racking)",
  problemTagBigData: "(Big da7a)",
  problemTagBigNumbers: "(Big numb3r5)",
  problemTagBinarySearch: "(Binary 53arch)",
  problemTagBinarySearchTree: "(Binary 53arch 7r33)",
  problemTagBipartiteMatching: "(Bipar7i73 ma7ching)",
  problemTagBitManipulation: "(Bi7 manipu1a7i0n)",
  problemTagBooleanAlgebra: "(B0013an a1g3bra)",
  problemTagBreadthFirstSearch: "(Br3ad7h-fir57 53arch)",
  problemTagBruteForce: "(Bru73 f0rc3)",
  problemTagCIIC: "(CIIC)",
  problemTagCOCI: "(COCI)",
  problemTagCharsAndStrings: "(Char5 and 57ring5)",
  problemTagChineseRemainderTheorem: "(Chin353 r3maind3r 7h30r3m)",
  problemTagCodingCup: "(C0dingCup)",
  problemTagCodingRush: "(C0dingRu5h)",
  problemTagCombinations: "(C0mbina7i0n5)",
  problemTagCombinatorialDesigns: "(C0mbina70ria1 d35ign5)",
  problemTagConditionals: "(C0ndi7i0na15)",
  problemTagConvexHull: "(C0nv3x hu11)",
  problemTagCountingProblems: "(C0un7ing pr0b13m5)",
  problemTagDataCompression: "(Da7a c0mpr355i0n)",
  problemTagDepthFirstSearch: "(D3p7h-fir57 53arch)",
  problemTagDiophantineEquations: "(Di0phan7in3 3qua7i0n5)",
  problemTagDirectedGraphs: "(Dir3c73d graph5)",
  problemTagDisjointSets: "(Di5j0in7 5375)",
  problemTagDivideAndConquer: "(Divid3 and c0nqu3r)",
  problemTagDivisibilityRules: "(Divi5ibi1i7y ru135)",
  problemTagDynamicProgramming: "(Dynamic pr0gramming)",
  problemTagExponentialSearch: "(Exp0n3n7ia1 53arch)",
  problemTagExponentiationBySquaring: "(Exp0n3n7ia7i0n by 5quaring)",
  problemTagFenwickTrees: "(F3nwick 7r335)",
  problemTagFileSeeking: "(Fi13 533king)",
  problemTagFormattedInputAndOutput: "(F0rma773d inpu7 and 0u7pu7)",
  problemTagFourierTransformation: "(F0uri3r 7ran5f0rma7i0n)",
  problemTagFunctions: "(Func7i0n5)",
  problemTagGCDAndLCM: "(C0mm0n mu17ip135 and divi50r5)",
  problemTagGameTheory: "(Gam3 7h30ry)",
  problemTagGeneticAlgorithms: "(G3n37ic a1g0ri7hm5)",
  problemTagGraphConnectivity: "(Graph c0nn3c7ivi7y)",
  problemTagGraphRepresentation: "(Graph r3pr353n7a7i0n)",
  problemTagGraphsWithNegativeWeights: "(Graph5 wi7h n3ga7iv3 w3igh75)",
  problemTagGreedyAlgorithms: "(Gr33dy a1g0ri7hm5)",
  problemTagHashing: "(Ha5hing)",
  problemTagHeaps: "(H3ap5)",
  problemTagHeuristics: "(H3uri57ic5)",
  problemTagICPC: "(ICPC)",
  problemTagIOI: "(IOI)",
  problemTagImplementation: "(Imp13m3n7a7i0n)",
  problemTagIncrementalSearch: "(Incr3m3n7a1 53arch)",
  problemTagInputAndOutput: "(Inpu7 and 0u7pu7)",
  problemTagInvertedIndices: "(Inv3r73d indic35)",
  problemTagLazyPropagation: "(Lazy pr0paga7i0n)",
  problemTagLeastCommonAncestor: "(L3a57 c0mm0n anc3570r)",
  problemTagLexingAndParsing: "(L3xing and par5ing)",
  problemTagLinearSearch: "(Lin3ar S3arch)",
  problemTagLinkedLists: "(Link3d 1i575)",
  problemTagLocalSearch: "(L0ca1 53arch)",
  problemTagLoops: "(L00p5)",
  problemTagMapsMultimaps: "(Map5 and mu17imap5)",
  problemTagMatrices: "(Ma7ric35)",
  problemTagMaxFlow: "(Max f10w)",
  problemTagMeetInTheMiddle: "(M337 in 7h3 midd13)",
  problemTagMemorization: "(M3m0riza7i0n)",
  problemTagMinimumSpanningTrees: "(Minimum 5panning 7r335)",
  problemTagModularArithmetic: "(M0du1ar ari7hm37ic)",
  problemTagModularMultiplicativeInverse: "(M0du1ar mu17ip1ica7iv3 inv3r53)",
  problemTagMonotoneStack: "(M0n070n3 57ack)",
  problemTagNearestNeighbors: "(N3ar357 n3ighb0r5)",
  problemTagNumberTheory: "(Numb3r 7h30ry)",
  problemTagNumericalMethods: "(Num3rica1 m37h0d5)",
  problemTagNumericalSeries: "(Num3rica1 53ri35)",
  problemTagOFMI: "(OFMI)",
  problemTagOMI: "(OMI)",
  problemTagOMIAguascalientes: "(OMI Agua5ca1i3n735)",
  problemTagOMIBajaCalifornia: "(OMI Baja Ca1if0rnia)",
  problemTagOMIBajaCaliforniaSur: "(OMI Baja Ca1if0rnia Sur)",
  problemTagOMICampeche: "(OMI Camp3ch3)",
  problemTagOMIChiapas: "(OMI Chiapa5)",
  problemTagOMIChihuahua: "(OMI Chihuahua)",
  problemTagOMICoahuila: "(OMI C0ahui1a)",
  problemTagOMIColima: "(OMI C01ima)",
  problemTagOMIDistritoFederal: "(OMI Di57ri70 F3d3ra1)",
  problemTagOMIDurango: "(OMI Durang0)",
  problemTagOMIGuanajuato: "(OMI Guanajua70)",
  problemTagOMIGuerrero: "(OMI Gu3rr3r0)",
  problemTagOMIHidalgo: "(OMI Hida1g0)",
  problemTagOMIJalisco: "(OMI Ja1i5c0)",
  problemTagOMIMexico: "(OMI M\u00e9xic0)",
  problemTagOMIMichoacan: "(OMI Mich0ac\u00e1n)",
  problemTagOMIMorelos: "(OMI M0r3105)",
  problemTagOMINayarit: "(OMI Nayari7)",
  problemTagOMINuevoLeon: "(OMI Nu3v0 L3\u00f3n)",
  problemTagOMIOaxaca: "(OMI Oaxaca)",
  problemTagOMIPS: "(OMIPS)",
  problemTagOMIPuebla: "(OMI Pu3b1a)",
  problemTagOMIQueretaro: "(OMI Qu3r\u00e97ar0)",
  problemTagOMIQuintanaRoo: "(OMI Quin7ana R00)",
  problemTagOMISanLuisPotosi: "(OMI San Lui5 P0705\u00ed)",
  problemTagOMISinaloa: "(OMI Sina10a)",
  problemTagOMISonora: "(OMI S0n0ra)",
  problemTagOMITabasco: "(OMI Taba5c0)",
  problemTagOMITamaulipas: "(OMI Tamau1ipa5)",
  problemTagOMITlaxcala: "(OMI T1axca1a)",
  problemTagOMIVeracruz: "(OMI V3racruz)",
  problemTagOMIYucatan: "(OMI Yuca7\u00e1n)",
  problemTagOMIZacatecas: "(OMI Zaca73ca5)",
  problemTagOfflineQueries: "(Off1in3 qu3ri35)",
  problemTagPalindromeAlgorithms: "(Pa1indr0m3 a1g0ri7hm5)",
  problemTagPartialSums: "(Par7ia1 5um5)",
  problemTagParticleSwarmOptimization: "(Par7ic13 5warm 0p7imiza7i0n)",
  problemTagPermutations: "(P3rmu7a7i0n5)",
  problemTagPrimalityTest: "(Prima1i7y 7357)",
  problemTagPrimeFactorization: "(Prim3 fac70riza7i0n)",
  problemTagPrimeGeneration: "(Prim3 g3n3ra7i0n)",
  problemTagProbabilityAndStatistics: "(Pr0babi1i7y and 57a7i57ic5)",
  problemTagQueues: "(Qu3u35)",
  problemTagRecursion: "(R3cur5i0n)",
  problemTagSQRTDecomposition: "(SQRT d3c0mp05i7i0n)",
  problemTagSegmentTrees: "(S3gm3n7 7r335)",
  problemTagSetsMultisets: "(S375 and mu17i5375)",
  problemTagShortestPaths: "(Sh0r7357 pa7h5)",
  problemTagSimulation: "(Simu1a7i0n)",
  problemTagSlidingWindow: "(S1iding wind0w)",
  problemTagSorting: "(S0r7ing)",
  problemTagStacks: "(S7ack5)",
  problemTagStringMatching: "(S7ring ma7ching)",
  problemTagSubArraySearch: "(Subarray 53arch)",
  problemTagSubsequenceSearch: "(Sub53qu3nc3 53arch)",
  problemTagSuffixTrees: "(Suffix 7r335)",
  problemTagSweepLine: "(Sw33p Lin3)",
  problemTagSystemsOfEquations: "(Sy573m5 0f 3qua7i0n5)",
  problemTagTopologicalSorting: "(T0p010gica1 50r7ing)",
  problemTagTreeTransversal: "(Tr33 7rav3r5a1)",
  problemTagTrees: "(Tr335)",
  problemTagTries: "(Tri35)",
  problemTagTwoPointersTechnique: "(Tw0 p0in73r5 73chniqu3)",
  problemTagUnformattedInputAndOutput: "(Unf0rma773d inpu7 and 0u7pu7)",
  problemTagWaveletTrees: "(Wav3137 7r335)",
  problemTitleExists: "(Pr0b13m 7i713 a1r3ady 3xi575. P13a53 7ry a diff3r3n7 0n3.)",
  problemVersionCurrentVersion: "(Curr3n7 v3r5i0n)",
  problemVersionDate: "(C0mmi7 da73)",
  problemVersionDiffMode: "(Sh0w diff)",
  problemVersionDiffModeFiles: "(Fi135)",
  problemVersionDiffModeNone: "(N0n3)",
  problemVersionDiffModeSubmissions: "(Submi55i0n5)",
  problemVersionMessage: "(C0mmi7 m355ag3)",
  problemVersionNewVersion: "(N3w v3r5i0n)",
  problemVersionNotFound: "(Pr0b13m v3r5i0n n07 f0und.)",
  problemVersionPublishedRevision: "(Pub1i5h3d)",
  problemVersionShowOnlyChanges: "(On1y 5h0w chang35)",
  problemVersionUpdate: "(Upda73 pr0b13m v3r5i0n)",
  problemVersionUpdatePublishedEditableProblemsets: "(Upda73 curr3n71y running c0n73575 / a55ignm3n75 / 3xam5 7ha7 I manag3)",
  problemVersionUpdatePublishedNonProblemset: "(D0 n07 upda73 c0n73575 / a55ignm3n75 / 3xam5)",
  problemVersionUpdatePublishedOwnedProblemsets: "(Upda73 curr3n71y running c0n73575 / a55ignm3n75 / 3xam5 7ha7 I 0wn)",
  problemVersionUpdated: "(Pr0b13m v3r5i0n upda73d.)",
  problemVersionUsername: "(Acc0un7 nam3)",
  problemVersionVersion: "(Pr0b13m v3r5i0n)",
  problemcollectionViewProblems: "(Vi3w pr0b13m5)",
  problemlessGrader: "(0m3gaUp IDE)",
  problemsOrderUpdated: "(Pr0b13m5' 0rd3r ha5 b33n upda73d)",
  problemsetIdentityNotFound: "(Acc0un7 0r id3n7i7y i5 n07 a550cia73d wi7h 7hi5 c0ur53, c0n7357 0r 7a5k.)",
  problemsetNotFound: "(Pr0b13m537 d035 n07 3xi57.)",
  profile: "(Nam3)",
  profileAddIdentitiesTooltip: "(Add id3n7i7i35 u5ing 7h3ir 0m3gaUp acc0un7 nam3)",
  profileApiTokensEmpty: "(N0 API 70k3n5)",
  profileAuthorRank: "(Au7h0r rank)",
  profileBasicInformation: "(Ba5ic inf0rma7i0n)",
  profileContests: "(C0n73575 r35u175)",
  profileContestsTableContest: "(C0n7357)",
  profileContestsTablePlace: "(P1ac3)",
  profileCountry: "(C0un7ry / R3gi0n)",
  profileCreatedContent: "(Cr3a73d c0n73n7)",
  profileCreatedContentSeeAll: "(S33 a11)",
  profileCreatedContests: "(Cr3a73d c0n73575)",
  profileCreatedCourses: "(Cr3a73d c0ur535)",
  profileCreatedProblems: "(Cr3a73d pr0b13m5)",
  profileEdit: "(Edi7 pr0fi13)",
  profileEmail: "(Emai1)",
  profileGraduationDate: "(Gradua7i0n da73)",
  profileIdentitiesEmpty: "(N0 id3n7i7i35)",
  profileIdentityAdded: "(Id3n7i7y add3d 5ucc355fu11y)",
  profileManageApiTokens: "(Manag3 API 70k3n5)",
  profileManageIdentities: "(Manag3 id3n7i7i35)",
  profileName: "(Nam3)",
  profileOrganizedContests: "(Organiz3d c0n73575)",
  profilePersonalData: "(P3r50na1 da7a)",
  profilePrivateRankMessage: "(Wh3n y0u 3nab13 7hi5 0p7i0n, y0ur acc0un7 ranking wi11 n07 b3 vi5ib13.)",
  profilePrivateRankMessageTitle: "(Warning)",
  profileRank: "(C0d3r rank)",
  profileRankBeginner: "(\u03bf)",
  profileRankExpert: "(\u0398)",
  profileRankInternationalMaster: "(\u03c9)",
  profileRankMaster: "(\u03a9)",
  profileRankSpecialist: "(\u039f)",
  profileRankUnrated: "(Unra73d)",
  profileSchool: "(Sch001)",
  profileSchoolMonthlySolvedProblemsCount: "(M0n7h1y 501v3d pr0b13m5 c0un7 f0r 7h3 u53r5 0f %(school))",
  profileSolvedProblems: "(S01v3d pr0b13m5)",
  profileState: "(S7a73)",
  profileStatistics: "(S7a75)",
  profileStatisticsCumulative: "(Cumu1a7iv3)",
  profileStatisticsDay: "(Day)",
  profileStatisticsDelta: "(D317a)",
  profileStatisticsMonth: "(M0n7h)",
  profileStatisticsNumberOfSolvedProblems: "(Numb3r 0f 501v3d pr0b13m5)",
  profileStatisticsPeriod: "(P3ri0d)",
  profileStatisticsRuns: "(<b>Run5</b>)",
  profileStatisticsTotal: "(T07a1)",
  profileStatisticsVerdictsOf: "(V3rdic75 0f %(user))",
  profileStatisticsWeek: "(W33k)",
  profileStatisticsYear: "(Y3ar)",
  profileUnsolvedProblems: "(Pr0b13m5 7ri3d (bu7 n07 501v3d))",
  profileUsername: "(Acc0un7 nam3)",
  publicCourseCardMetricsLessons: "(%(lessonCount) 13550n5)",
  publicCourseCardMetricsOneLesson: "(1 13550n)",
  publicCourseCardMetricsOneStudent: "(1 57ud3n7)",
  publicCourseCardMetricsStudents: "(%(studentCount) 57ud3n75)",
  publicCourseInformationDescription: "(On-d3mand c0ur535 7ha7 0m3gaUp 0ff3r5 f0r fr33.)",
  publicTagsPlaceholder: "(Ex. R3cur5i0n, S3gm3n7 Tr335, Binary S3arch)",
  qualityFormCongrats: "(C0ngra7u1a7i0n5 f0r 501ving 7hi5 pr0b13m!)",
  qualityFormDifficulty: "(H0w difficu17 did y0u find 7hi5 pr0b13m?)",
  qualityFormDifficultyAny: "(Any)",
  qualityFormDifficultyEasy: "(Ea5y)",
  qualityFormDifficultyHard: "(Hard)",
  qualityFormDifficultyMedium: "(M3dium)",
  qualityFormDifficultyVeryEasy: "(V3ry 3a5y)",
  qualityFormDifficultyVeryHard: "(V3ry hard)",
  qualityFormQuality: "(H0w g00d w0u1d y0u 5ay 7hi5 pr0b13m i5?)",
  qualityFormQualityAny: "(Any pr0b13m)",
  qualityFormQualityBad: "(Bad)",
  qualityFormQualityFair: "(Fair)",
  qualityFormQualityGood: "(G00d)",
  qualityFormQualityOnly: "(Qua1i7y pr0b13m5 0n1y)",
  qualityFormQualityVeryBad: "(V3ry bad)",
  qualityFormQualityVeryGood: "(V3ry g00d)",
  qualityFormRateBeforeAc: "(Y0u can a1r3ady ra73 7hi5 pr0b13m!)",
  qualityFormThanksForReview: "(Thank5 f0r r3vi3w!)",
  qualityNominationCreatedBy: "(Cr3a73d by)",
  qualityNominationMustHaveSolvedProblem: "(Y0u mu57 501v3 a pr0b13m b3f0r3 n0mina7ing i7)",
  qualityNominationMustHaveTriedToSolveProblem: "(Y0u mu57 hav3 7ri3d 70 501v3 7h3 pr0b13m b3f0r3 n0mina7ing i7)",
  qualityNominationMustNotHaveSolvedProblem: "(Y0u mu57 n07 hav3 501v3d 7h3 pr0b13m f0r 'b3f0r3_ac' n0mina7ing i7)",
  qualityNominationNominatedBy: "(N0mina73d by)",
  qualityNominationNotFound: "(N0mina7i0n n07 f0und)",
  qualityNominationProblemHasBeenBanned: "(Thi5 pr0b13m ha5 b33n bann3d. Y0u cann07 upda73 i75 vi5ibi1i7y.)",
  qualityNominationProblemHasBeenPromoted: "(Thi5 pr0b13m ha5 b33n pr0m073d. Y0u cann07 upda73 i75 vi5ibi1i7y.)",
  qualityNominationProblemHasWarning: "(Thi5 pr0b13m ha5 a warning. Y0u cann07 upda73 i75 vi5ibi1i7y.)",
  qualityNominationRateProblem: "(Ra73 pr0b13m)",
  qualityNominationRateProblemDesc: "(If y0u wan7 70 ra73 7h3 pr0b13m 1a73r, c1ick 0n \"Ra73 pr0b13m\" 1ink)",
  qualityNominationResolutionSuccess: "(Qua1i7y n0mina7i0n 5ucc355fu11y r3501v3d.)",
  qualityNominationShowAll: "(A150 5h0w r3501v3d n0mina7i0n5)",
  qualityNominationType: "(Typ3)",
  rankRangeHeader: "(C0d3r5 wi7h 7h3 m057 p0in75 (%(lowCount) 70 %(highCount)))",
  rankScore: "(Sc0r3)",
  rankSolved: "(S01v3d pr0b13m5)",
  rankingNoUsers: "(W3 d0n'7 hav3 da7a 70 di5p1ay 0n 7h3 Ranking graph.)",
  recordNotFound: "(R3c0rd n07 f0und.)",
  registerForContest: "(R3gi573r f0r c0n7357)",
  registerForContestChallenges: "(Cha113ng3)",
  registerForContestRules: "(Ru135)",
  registerForCourse: "(R3gi573r f0r c0ur53)",
  registrationDenied: "(Y0ur r3qu357 70 j0in 7hi5 c0n7357 ha5 b33n d3ni3d!)",
  registrationPending: "(Y0ur r3qu357 70 j0in 7hi5 c0n7357 i5 p3nding appr0va1 fr0m 7h3 c0n7357 admin.)",
  registrationPendingCourse: "(Y0ur r3qu357 70 j0in 7hi5 c0ur53 i5 p3nding appr0va1 fr0m 7h3 admin.)",
  registrationRejectionFeedback: "(Th3 r3a50n pr0vid3d by 7h3 admin wa5: %(extra_note))",
  reportAnIssue: "(R3p0r7 an i55u3)",
  reportAnIssueTemplate: "(## Exp3c73d B3havi0r\n\n*D35crib3 wha7 y0u 3xp3c73d 70 happ3n*\n\n## Ac7ua1 B3havi0r\n\n*D35crib3 wha7 happ3n3d in573ad 0f wha7 y0u 3xp3c73d*\n\n## P055ib13 S01u7i0n\n\n*N07 r3quir3d, bu7 if y0u can 7hink 0f 50m37hing, y0u can 5ugg357 a way 70 fix 7h3 bug.*\n\n## R3pr0duc7i0n 573p5\n\n*Pr0vid3 a d37ai13d 1i57 0f 573p5 0f wha7 y0u did 70 r3pr0duc3\n7hi5 bug.  Inc1ud3 7h3 c0d3 7ha7 r3pr0duc35 i7, if i7 i5 r313van7.*\n\n1. \n2. \n3. \n4. \n\n## C0n73x7\n\n*H0w ha5 7hi5 i55u3 aff3c73d y0u? Wha7 w3r3 y0u 7rying 70 achi3v3?*\n\n*Pr0viding c0n73x7 h31p5 u5 70 find 7h3 righ7 501u7i0n and pri0ri7y.*\n\n## Y0ur 3nvir0nm3n7\n\n*Inc1ud3 7h3 r313van7 d37ai15 ab0u7 7h3 3nvir0nm3n7 in which 7hi5 bug wa5 r3pr0duc3d*\n\n* Br0w53r nam3 (3.g. Chr0m3 39, n0d3.j5 5.4): %(userAgent)\n* Link 70 7h3 5i73 wh3r3 7hi5 pr0b13m 0ccur5: %(referer)\n* C0n5013 3rr0r5: %(serializedErrors)\n* Scr33n cap7ur3:)",
  reportProblemFormAdditionalComments: "(Addi7i0na1 c0mm3n75 (0p7i0na1):)",
  reportProblemFormCases: "(I b31i3v3 7h3 7357 ca535 ar3 wr0ng.)",
  reportProblemFormDuplicate: "(Thi5 i5 a dup1ica73d pr0b13m.)",
  reportProblemFormLinkToOriginalProblem: "(Link 70 0rigina1 pr0b13m (r3quir3d):)",
  reportProblemFormNotAProblemStatement: "(D035 n07 d35crib3 a pr0b13m 57a73m3n7.)",
  reportProblemFormOffensive: "(I5 0ff3n5iv3.)",
  reportProblemFormOtherReason: "(O7h3r r3a50n.)",
  reportProblemFormPoorlyDescribed: "(Th3 pr0b13m i5 p00r1y d35crib3d.)",
  reportProblemFormQuestion: "(Why d0 y0u wan7 70 r3p0r7 7hi5 pr0b13m?)",
  reportProblemFormSpam: "(I5 Spam.)",
  reportProblemFormThanksForReview: "(Thank5 f0r y0ur r3p0r7!)",
  requestCoder: "(C0d3r)",
  requestDate: "(Da73 0f r3qu357)",
  requestFeedback: "(Th3 f33dback r3qu357 ha5 b33n 53n7 70 a11 7h3 admini57ra70r5.)",
  requestFeedbackConfirm: "(D0 y0u wan7 70 r3qu357 f33dback f0r 7hi5 5ubmi55i0n?)",
  requestFeedbackMessage: "(I n33d y0ur h31p in 7hi5 5ubmi55i0n.)",
  resourceNotFound: "(R350urc3 n07 f0und.)",
  reviewerNomination: "(Ra73 pr0b13m a5 r3vi3w3r)",
  reviewerNominationFormTitle: "(Qua1ify 7hi5 pr0b13m!)",
  reviewerNominationQuality: "(I5 7hi5 a qua1i7y pr0b13m?)",
  runCannotBeDisqualified: "(Th3 run cann07 b3 di5qua1ifi3d)",
  runCannotBeRequalified: "(Th3 run cann07 b3 r3qua1ifi3d)",
  runDetailsCompilationError: "(C0mpi1a7i0n 3rr0r)",
  runDetailsCorrect: "(C0rr3c7)",
  runDetailsExceeded: "(Limi7 3xc33d3d)",
  runDetailsFeedbackAddReview: "(Add f33dback)",
  runDetailsFeedbackCancel: "(Canc31)",
  runDetailsFeedbackPlaceholder: "(Typ3 y0ur f33dback h3r3...)",
  runDetailsFeedbackThreadPlaceholder: "(R3p1y...)",
  runDetailsFinished: "(Fini5h3d)",
  runDetailsIncorrect: "(Inc0rr3c7)",
  runDetailsInterrupted: "(In73rrup73d)",
  runDetailsJudgeError: "(Judg3 3rr0r)",
  runDetailsNewFeedback: "(N3w f33dback)",
  runDetailsNotAvailable: "(N07 avai1ab13)",
  runDetailsRuntimeError: "(Run7im3 3rr0r)",
  runDetailsRuntimeFunctionError: "(R357ric73d func7i0n 3rr0r)",
  runDetailsValidatorError: "(Va1ida70r 3rr0r)",
  runDisqualifyByProblemConfirm: "(D0 y0u r3a11y wan7 70 di5qua1ify a11 run5 f0r 7hi5 pr0b13m in 7h3 c0n7357 f0r 7hi5 u53r?)",
  runDisqualifyByUserConfirm: "(D0 y0u r3a11y wan7 70 di5qua1ify a11 7h3 c0n7357 run5 f0r 7hi5 u53r?)",
  runDisqualifyConfirm: "(D0 y0u r3a11y wan7 70 di5qua1ify 7hi5 run?)",
  runGUID: "(GUID)",
  runNotEvenOpened: "(Y0u mu57 0p3n 7h3 pr0b13m b3f0r3 7rying 70 5ubmi7 a 501u7i0n.)",
  runNotFound: "(Run n07 f0und.)",
  runNotInsideContest: "(C0n7357 7im3 ha5 3xpir3d 0r n07 57ar73d y37.)",
  runWaitGap: "(Y0u hav3 70 wai7 b37w33n c0n53cu7iv3 5ubmi55i0n5.)",
  schoolNotFound: "(Sch001 n07 f0und)",
  schoolNotSelected: "(N0 5ch001 5313c73d)",
  schoolOfTheMonth: "(Sch001 0f 7h3 M0n7h)",
  schoolOfTheMonthAlreadySelected: "(Sch001 0f 7h3 m0n7h ha5 b33n pr3vi0u51y 5313c73d)",
  schoolOfTheMonthChooseAsSchool: "(Ch0053 a5 Sch001 0f 7h3 M0n7h)",
  schoolOfTheMonthIsNotInPeriodToBeChosen: "(Sch001 0f 7h3 m0n7h i5 n07 in 7h3 p3ri0d 70 b3 ch053n)",
  schoolOfTheMonthNotFound: "(Sch001 0f 7h3 m0n7h n07 f0und.)",
  schoolOfTheMonthSelectedSuccessfully: "(Sch001 0f 7h3 m0n7h ha5 b33n 5313c73d 5ucc355fu11y!)",
  schoolOfTheMonthSystemInMaintainance: "(Th3 Sch001 0f 7h3 M0n7h 5y573m i5 und3r main73nanc3.\n\nW3 wi11 b3 back 500n.)",
  schoolRankOfTheMonthHeader: "(T0p %(count) 5ch0015 wi7h 7h3 m057 p0in75 in 7h3 m0n7h)",
  schoolRankRangeHeader: "(Sch0015 wi7h 7h3 m057 p0in75 (%(lowCount) 70 %(highCount)))",
  schoolUsers: "(U53r5 wh0 b310ng 70 7hi5 5ch001)",
  schoolsCreateCoursesThatMeetNeeds: "(C0ur535 7ha7 m337 y0ur n33d5. Y0u can cr3a73 y0ur 0wn pr0b13m5.)",
  schoolsCreateYourCourse: "(Cr3a73 y0ur c0ur535)",
  schoolsCreateYourProblems: "(Cr3a73 y0ur pr0b13m5)",
  schoolsLearnProgBySolvProblems: "(L3arn pr0gramming by 501ving pr0b13m5)",
  schoolsManageProgressOfStudents: "(Manag3 7h3 pr0gr355 0f y0ur 57ud3n75)",
  schoolsOfTheMonth: "(Sch0015 0f 7h3 M0n7h)",
  schoolsOfTheMonthCandidates: "(Candida735 70 Sch001 0f 7h3 M0n7h)",
  schoolsOfTheMonthRank: "(T0p 100 5ch0015 0f pr3vi0u5 m0n7h)",
  schoolsStartUsingCourses: "(S7ar7 u5ing C0ur535)",
  scoreboardAccountName: "(Acc0un7 nam3)",
  scoreboardLastUpdated: "(La57 7im3 upda73d: %(datetime))",
  scoreboardNameAndAccountName: "(Nam3 and acc0un7 nam3)",
  scoreboardShowOnlyInvitedIdentities: "(Sh0w 0fficia1 c0n7357an75 0n1y)",
  scoreboardShowParticipantsNames: "(Sh0w par7icipan75' nam35)",
  searchUser: "(S3arch c0d3r)",
  selectProblemLevelDesc: "(In 0rd3r 70 add 7h3 pr0b13m, y0u mu57 70 ch0053 i75 c0rr35p0nding 13v31)",
  serviceUnavailableError: "(O0p5. Th3 53rvic3 i5 curr3n71y unavai1ab13. P13a53 7ry again.)",
  settingsExtraWallTime: "(Ex7ra Wa11 Tim3)",
  settingsInteractive: "(In73rac7iv3)",
  settingsLanguage: "(Pr0gramming Languag3)",
  settingsMemoryLimit: "(M3m0ry Limi7)",
  settingsModuleName: "(M0du13 Nam3)",
  settingsOutputLimit: "(Ou7pu7 Limi7)",
  settingsOverallWallTimeLimit: "(Wa11 Tim3 Limi7 (T07a1))",
  settingsTimeLimit: "(Tim3 Limi7)",
  settingsTolerance: "(T013ranc3)",
  settingsValidator: "(Va1ida70r)",
  showDefaultAllContestantsInScoreboard: "(Sh0w a11 c0n7357an75 0n 7h3 5c0r3b0ard by d3fau17.)",
  showLinks: "(Link5)",
  showTotalScoreboard: "(Sh0w 707a1 5c0r3b0ard)",
  signUpFormInteractiveGuideConfirmPassword: "(C0nfirm y0ur pa55w0rd)",
  signUpFormInteractiveGuideEmail: "(En73r y0ur 3mai1)",
  signUpFormInteractiveGuidePassword: "(Cr3a73 y0ur pa55w0rd, 8 charac73r5 minimum)",
  signUpFormInteractiveGuideRegister: "(C1ick h3r3)",
  signUpFormInteractiveGuideTermsAndConditions: "(P13a53 r3ad and acc3p7 0ur 73rm5 and c0ndi7i0n5)",
  signUpFormInteractiveGuideTitle: "(Sign Up)",
  signUpFormInteractiveGuideUsername: "(Cr3a73 y0ur acc0un7 nam3, 0n1y upp3rca53 13773r5, 10w3rca53 13773r5, numb3r5, 7h3 charac73r5 _, . and - ar3 a110w3d, 7h3 minimum numb3r 0f charac73r5 i5 2.)",
  signUpFormInteractiveGuideWelcome: "(L37'5 cr3a73 y0ur acc0un7! \ud83d\udc4b)",
  singleUserAddSuccess: "(Acc0un7 5ucc355fu11y add3d)",
  socketStatusConnected: "(S0ck37 i5 c0nn3c73d)",
  socketStatusFailed: "(S0ck37 c0nn3c7i0n fai13d)",
  socketStatusWaiting: "(Wai7ing f0r 50ck37 c0nn3c7i0n)",
  solutionAvailableViews: "(S33 avai1ab13 vi3w5)",
  solutionConfirm: "(P13a53 c1ick 0n 7h3 bu770n 70 533 7hi5 501u7i0n.)",
  solutionLocked: "(Y0u can'7 533 7hi5 501u7i0n y37.\n\n*   Try 501ving 7h3 pr0b13m fir57 0r y0u can un10ck i7 if y0u hav3 n07 y37 r3ach3d 7h3 1imi7 0f 501u7i0n5 533n p3r day.\n*   Onc3 y0u d3cid3 70 un10ck 7h3 501u7i0n f0r a pr0b13m, i7 w0n'7 c0un7 70ward5 y0ur 5c0r3 f0r 0m3gaUp'5 ranking.)",
  solutionNotFound: "(Th3r3 i5n'7 any 501u7i0n f0r 7hi5 pr0b13m.)",
  solutionNotLoggedIn: "(Y0u mu57 10gin 70 un10ck/533 7hi5 501u7i0n.)",
  solutionViewsLeft: "(Y0u hav3 **%(available)** avai1ab13 vi3w5 13f7, 0u7 0f a 707a1 0f **%(total)** 7ha7 y0u can mak3 p3r day.)",
  spinnerLoadingMessage: "(L0ading...)",
  startContest: "(S7ar7 C0n7357)",
  startCourse: "(S7ar7 C0ur53)",
  statementLanguage: "(Languag3)",
  statementLanguageEn: "(Eng1i5h)",
  statementLanguageEs: "(Spani5h)",
  statementLanguagePt: "(P0r7ugu353)",
  statementNotFound: "(Pr0b13m 57a73m3n7 n07 f0und.)",
  studentCourseInformationDescription: "(H3r3 y0u wi11 find 7h3 1i57 0f c0ur535 7ha7 y0u ar3 3nr0113d in.)",
  studentProgressDescriptionTotalPoints: "((%(points) p0in75 + %(extraPoints) 3x7ra))",
  studentProgressExtraProblem: "((3x7ra))",
  studentProgressOnlyLecturesDescription: "(Thi5 c0n73n7 0n1y inc1ud35 13c7ur35)",
  studentProgressPoints: "((%(points) p0in75))",
  studentProgressTooltipDescription: "(%(problem):\n\n%(score) 0f %(points) p0in75 (%(progress)% pr0gr355))",
  studentsProgressRangeHeader: "(S7ud3n75 pr0gr355 (fr0m %(lowCount) 70 %(highCount)))",
  submissionFeedbackAlreadyExists: "(Th3 f33dback f0r 7hi5 5ubmi55i0n a1r3ady 3xi575.)",
  submissionFeedbackAnimationButton: "(L3av3 y0ur f33dback 1in3 by 1in3 a5 5h0wn in 7h3 anima7i0n:)",
  submissionFeedbackParticipantsListEmpty: "(Th3 1i57 0f par7icipan75 in 7hi5 7hr3ad i5 3mp7y)",
  submissionFeedbackSendButton: "(L3av3 f33dback \ud83d\udd3d)",
  submissionMemoryInMegabytes: "(%(value) MiB)",
  submissionNotFound: "(Submi55i0n n07 f0und.)",
  submissionRunTimeInSeconds: "(%(value) 5)",
  submissionSendFeedback: "(S3nd f33dback)",
  submissionsListCoder: "(C0d3r)",
  submissionsListTitle: "(Submi55i0n5 in 7h3 1a57 24 h0ur5)",
  submitFeedbackCancel: "(Canc31)",
  submitFeedbackPlaceholder: "(En73r y0ur f33dback (0p7i0na1))",
  submitFeedbackRequireConfirmation: "(Submi7 f33dback)",
  submitFeedbackSubmit: "(Submi7)",
  supportAssignUserRoles: "(A55ign r0135)",
  supportContestRemovedFromRecommended: "(C0n7357 ha5 b33n r3m0v3d fr0m r3c0mm3nd3d)",
  supportContestSetAsRecommended: "(C0n7357 ha5 b33n 537 a5 r3c0mm3nd3d)",
  supportNewSearch: "(N3w 53arch)",
  supportOptions: "(Op7i0n5)",
  supportSetAsRecommended: "(S37 a5 r3c0mm3nd3d)",
  supportTypeContestAlias: "(Typ3 c0n7357 a1ia5)",
  supportTypeEmailOrUsername: "(Typ3 3mai1 0r u53rnam3)",
  tagAdded: "(Tag 5ucc355fu11y add3d!)",
  tagNotFound: "(Tag n07 f0und)",
  tagPrefixRestricted: "(Th3 'pr0b13mTag' pr3fix can'7 b3 u53d f0r 7ag5 add3d manua11y.)",
  tagRemoved: "(Tag 5ucc355fu11y r3m0v3d!)",
  tagRestricted: "(Tag cann07 b3 add3d 0r r3m0v3d.)",
  tagSourceLevel: "(L3v31)",
  tagSourceOwner: "(Au7h0r'5 7ag)",
  tagSourceVoted: "(C0d3r5' 7ag)",
  teamAliasInUse: "(Th3r3 i5 a7 13a57 0n3 dup1ica73 73am a1ia5. P13a53 ch3ck 7h3 CSV fi13 70 fix 7h3 inf0rma7i0n.)",
  teamMemberExceededNumberOfContestants: "(Th3 numb3r 0f c0n7357an75 in 0n3 0f 7h3 73am5 3xc33d5 7h3 maximum a110w3d)",
  teamMemberUsernameInUse: "(Th3r3 i5 a7 13a57 0n3 dup1ica73 acc0un7 nam3 in 7h3 73am5 0f 7h3 gr0up. P13a53 fix 7h3 inf0rma7i0n.)",
  teamsGroupAliasMustBeRequired: "(In a c0n7357 f0r 73am5, a1ia5 mu57 b3 r3quir3d)",
  teamsGroupCreateIdentitiesAsTeams: "(Cr3a73 id3n7i7i35 a5 73am5)",
  teamsGroupCreatingIdentitiesAsTeams: "(Cr3a7ing id3n7i7i35 a5 73am5)",
  teamsGroupEditGroupUpdated: "(Th3 73am5 gr0up ha5 b33n 5ucc355fu11y upda73d.)",
  teamsGroupEditTeams: "(T3am5)",
  teamsGroupEditTeamsPasswordUpdated: "(Pa55w0rd 5ucc355fu11y upda73d!)",
  teamsGroupEditTeamsRemoved: "(T3am 5ucc355fu11y r3m0v3d!)",
  teamsGroupEditTeamsUpdated: "(T3am 5ucc355fu11y upda73d!)",
  teamsGroupEditTitleWithName: "(Edi7 73am5 gr0up %(name))",
  teamsGroupFormCreate: "(Cr3a73 73am5 gr0up)",
  teamsGroupFormUpdate: "(Upda73 73am5 gr0up)",
  teamsGroupMemberChangePassword: "(Typ3 7h3 n3w pa55w0rd)",
  teamsGroupMembersAccountName: "(Acc0un7 nam3)",
  teamsGroupNewFormDescription: "(T3am5 gr0up d35crip7i0n)",
  teamsGroupTeamName: "(T3am nam3)",
  teamsGroupTeamsAdvancedOptions: "(Advanc3d 0p7i0n5)",
  teamsGroupTeamsEmptyList: "(N0 73am5 in 7hi5 gr0up)",
  teamsGroupTeamsGroupName: "(T3am5 gr0up nam3)",
  teamsGroupTeamsSelfGenerateIdentities: "(S31f-g3n3ra73 id3n7i7i35)",
  teamsGroupUploadIdentitiesAsTeams: "(Up10ad 73am5)",
  teamsGroupUsernames: "(C0d3r5)",
  teamsGroupsCanNotBeAddedInNormalContest: "(T3am5 gr0up5 cann07 b3 add3d in n0rma1 c0n73575)",
  teamsGroupsCreateNew: "(Cr3a73 n3w 73am5 gr0up)",
  teamsGroupsCsvHelp: "(## Quick1y add mu17ip13 id3n7i7i35 a5 73am5 70 7hi5 73am5 gr0up. Id3n7i7i35 ar3 n07 r3gu1ar acc0un75, and d0n'7 n33d 70 hav3 an 3mai1 0r va1ida73 7h3ir acc0un7.\n\n## Id3n7i7i35 5h0u1d b3 in a `.c5v` fi13 wi7h 7h3 f0110wing f0rma7:\n```\nu53rnam3,nam3,c0un7ry_id,57a73_id,g3nd3r,5ch001_nam3\n73am-1,T3am 1,MX,AGU,07h3r,B357 Sch001\n73am-2,T3am5 2,MX,AGU,d3c1in3,B357 Sch001\n```)",
  teamsGroupsCsvHelpMoreInfo: "(\u2139\ufe0f M0r3 inf0)",
  teamsGroupsErrorFieldIsNotPresentInCsv: "(S0m3 r3quir3d fi31d5 w3r3 n07 f0und in c5v fi13: %(missingFields))",
  teamsGroupsErrorFieldIsRequired: "(Th3 fi31d %(field) i5 r3quir3d.)",
  titleInUse: "(Ti713 a1r3ady 3xi575. P13a53 ch0053 a diff3r3n7 7i713.)",
  tokenDecodeCorrupted: "(Th3r3 wa5 a pr0b13m d3c0ding 7h3 70k3n.)",
  tokenDecodeExpired: "(Th3 70k3n ha5 a1r3ady 3xpir3d.)",
  tokenDecodeInvalid: "(Th3 70k3n d035 n07 b310ng 7hi5 c0ur53.)",
  tokenDecodeUnknown: "(Th3 70k3n i5 n07 va1id f0r 7hi5 c0ur53.)",
  totalRuns: "(T07a1 run5: %(numRuns))",
  typeaheadSearchPlaceholder: "(S3arch...)",
  unableToVerifyCaptcha: "(W3 fai13d 70 v3rify 7h3 cap7cha. P13a53 r310ad 7h3 pag3 and 7ry again.)",
  under13UserException: "(Y0u can'7 acc355 7hi5 5i73 fr0m an acc0un7 f0r chi1dr3n und3r 13 y3ar5 0f ag3)",
  unnecessaryTokenForPublicCourses: "(T0k3n i5 unn3c355ary f0r pub1ic c0ur535)",
  unsupportedBrowser: "(Y0ur br0w53r d035n'7 5upp0r7 a11 7h3 f3a7ur35 0n 7hi5 pag3. P13a53 7ry 70 upda73 70 a <a hr3f=\"h77p5://gi7hub.c0m/0m3gaup/0m3gaup#nav3gad0r35-50p0r7ad05\" 7arg37=\"b1ank\">5upp0r73d br0w53r</a>.)",
  unverifiedUser: "(Unv3rifi3d acc0un7.)",
  updateItemsSuccess: "(A11 7h3 5313c73d i73m5 ha5 b33n upda73d)",
  updateProblemLevel: "(Upda73 pr0b13m 13v31)",
  updateStatementsCommitMessage: "(Upda73d 57a73m3n75)",
  userAlreadyAcceptedPrivacyPolicy: "(Thi5 acc0un7 ha5 a1r3ady acc3p73d 7h3 privacy p01icy)",
  userAlreadyHasSelectedRole: "(Thi5 acc0un7 a1r3ady ha5 7h3 5313c73d r013)",
  userBirthDate: "(Bir7h da73: %(birthDate))",
  userDocsDocumentation: "(D0cum3n7a7i0n)",
  userDoesNotHaveAnyPasswordChangeRequest: "(Th3 acc0un7 d035 n07 hav3 any pa55w0rd chang3 r3qu357 in 7h3 1a57 24 h0ur5.)",
  userEditAddPassword: "(Add pa55w0rd)",
  userEditBachelors: "(Bach310r'5)",
  userEditBirthDate: "(Bir7h da73)",
  userEditChangeEmail: "(Chang3 3mai1)",
  userEditChangePassword: "(Chang3 pa55w0rd)",
  userEditChangePasswordNewPassword: "(N3w pa55w0rd)",
  userEditChangePasswordOldPassword: "(O1d pa55w0rd)",
  userEditChangePasswordRepeatNewPassword: "(R3p3a7 n3w pa55w0rd)",
  userEditChangePasswordToUsername: "(Chang3 pa55w0rd: %(username))",
  userEditCountry: "(C0un7ry / R3gi0n)",
  userEditDeleteAccount: "(D31373 Acc0un7)",
  userEditDoctorate: "(D0c70ra73)",
  userEditEarlyChildhood: "(Ear1y chi1dh00d)",
  userEditGraduationDate: "(Gradua7i0n da73)",
  userEditGravatar: "(Up10ad in Grava7ar.c0m u5ing y0ur 3mai1: )",
  userEditHideProblemTags: "(Hid3 pr0b13m5 7ag5)",
  userEditLanguage: "(Languag3)",
  userEditLowerSecondary: "(Midd13 5ch001 / Juni0r high)",
  userEditManageSchools: "(Manag3 5ch0015)",
  userEditManageSchoolsUserCurrentlyEnrolled: "(Curr3n71y 3nr0113d)",
  userEditMaster: "(Ma573r5)",
  userEditNameTooLong: "(Nam3 can'7 3xc33d 50 carac73r5 in 13ng7h.)",
  userEditNone: "(N0n3)",
  userEditPostSecondary: "(Car33r / 73chnica1 in57i7u7i0n)",
  userEditPrePrimary: "(Pr3-primary)",
  userEditPreferences: "(Pr3f3r3nc35)",
  userEditPreferencesSuccess: "(Pr3f3r3nc35 5ucc355fu11y upda73d.)",
  userEditPreferredProgrammingLanguage: "(Pr3f3rr3d pr0gramming 1anguag3)",
  userEditPrimary: "(E13m3n7ary)",
  userEditPrivateProfile: "(W0u1d y0u 1ik3 70 hid3 pr0fi13 d37ai15 fr0m 07h3r5?)",
  userEditProfileImage: "(Pr0fi13 imag3)",
  userEditSchoolGrade: "(Sch001 grad3)",
  userEditSchoolSuccess: "(Sch001'5 inf0rma7i0n 5ucc355fu11y upda73d.)",
  userEditSuccess: "(Pr0fi13 5ucc355fu11y upda73d.)",
  userEditSuccessfulEmailUpdate: "(Emai1 upda73d 5ucc355fu11y! In a f3w minu735, y0u wi11 r3c3iv3 m0r3 in57ruc7i0n5 in y0ur 3mai1. D0n'7 f0rg37 70 ch3ck y0ur Spam f01d3r.)",
  userEditTertiary: "(C0mmuni7y C0113g3)",
  userEditUpperSecondary: "(S3ni0r High / High 5ch001)",
  userEditViewProfile: "(Vi3w my pr0fi13)",
  userEmailEditEmail: "(Emai1)",
  userEmails: "(E-mai15)",
  userEndTimeUpdatedSuccessfully: "(C0n7357 3nd 7im3 ha5 b33n upda73d 5ucc355fu11y.)",
  userGroups: "(Gr0up5)",
  userInformationIsPrivate: "(Th3 acc0un7'5 inf0rma7i0n i5 priva73)",
  userLastLogin: "(La57 10gin: %(lastLogin))",
  userNeverLoggedIn: "(Ha5 n3v3r 10gg3d in.)",
  userNextRegisteredContestButtonEnter: "(En73r)",
  userNextRegisteredContestButtonSeeDetails: "(S33 d37ai15)",
  userNextRegisteredContestTitle: "(R3m3mb3r 70 par7icipa73 in 7h3 c0n7357)",
  userNotAllowed: "(Y0u d0 n07 hav3 7h3 p3rmi75 70 p3rf0rm 7hi5 ac7i0n.)",
  userNotAllowedToAddPrivateProblem: "(On1y pr0b13m admin5 ar3 a110w3d 70 add 7h3ir 0wn priva73 pr0b13m5 in pr0b13m5375)",
  userNotExist: "(Acc0un7 d035 n07 3xi57.)",
  userNotInListOfRequests: "(Thi5 acc0un7 d035 n07 hav3 a p3nding r3qu357.)",
  userObjectivesModalAnswerCompetitive: "(pr0gramming c0n73575)",
  userObjectivesModalAnswerLearning: "(13arn pr0gramming)",
  userObjectivesModalAnswerLearningAndTeaching: "(13arn and 73ach pr0gramming)",
  userObjectivesModalAnswerNone: "(n0n3 0f 7h3 ab0v3)",
  userObjectivesModalAnswerOther: "(07h3r)",
  userObjectivesModalAnswerScholar: "(5ch001 c1a5535)",
  userObjectivesModalAnswerScholarAndCompetitive: "(c1a5535 and c0n73575)",
  userObjectivesModalAnswerTeaching: "(73ach pr0gramming)",
  userObjectivesModalButtonNext: "(N3x7)",
  userObjectivesModalButtonPrevious: "(Pr3vi0u5)",
  userObjectivesModalButtonSend: "(S3nd)",
  userObjectivesModalDescriptionLearning: "(I wan7 70 13arn f0r ...)",
  userObjectivesModalDescriptionLearningAndTeaching: "(I wan7 70 13arn and 73ach f0r ...)",
  userObjectivesModalDescriptionTeaching: "(I wan7 70 73ach f0r ...)",
  userObjectivesModalDescriptionUsage: "(I wan7 70 u53 0m3gaUp 70 ...)",
  userObjectivesModalPageCounter: "(%(current) 0f %(last))",
  userObjectivesModalTitle: "(H31p u5 70 g37 70 kn0w y0u)",
  userObjectivesUpdateSuccess: "(Thank5 f0r h31ping u5. Y0ur an5w3r5 hav3 b33n 5av3d)",
  userOrMailNotFound: "(Acc0un7 nam3 0r 3mai1 n07 f0und.)",
  userPasswordMustBeSame: "(Th3 n3w pa55w0rd5 mu57 b3 7h3 5am3.)",
  userProfileIsPrivate: "(Thi5 acc0un7'5 pr0fi13 i5 mark3d priva73; 50m3 inf0rma7i0n wi11 n07 b3 di5p1ay3d)",
  userProfileProblemsFilter: "(Fi173r)",
  userRankEmptyList: "(Th3r3 i5 n07 da7a 70 5h0w in 7h3 ranking)",
  userRankLastUpdated: "(La57 upda73d: %(datetime))",
  userRankOfTheMonthHeader: "(%(count) c0d3r5 wi7h 7h3 m057 p0in75 in 7h3 m0n7h)",
  userRankSolvedProblemsHelp: "(Th3 numb3r 0f 501v3d pr0b13m5 i5 upda73d 0nc3 a day.)",
  userRemoveSuccess: "(Acc0un7 5ucc355fu11y r3m0v3d!)",
  userRoles: "(R0135)",
  userVerified: "(Acc0un7 ha5 b33n v3rifi3d)",
  userVerify: "(V3rify acc0un7)",
  username: "(Acc0un7 nam3)",
  usernameInUse: "(Thi5 acc0un7 nam3 ha5 a1r3ady b33n u53d.)",
  usernameOrPassIsWrong: "(Acc0un7 nam3 0r pa55w0rd ar3 wr0ng. P13a53 ch3ck y0ur cr3d3n7ia15.)",
  usersCanNotBeAddedInContestForTeams: "(Individua1 acc0un75 cann07 b3 add3d in c0n73575 f0r 73am5)",
  usersCanNotBeAddedInVirtualContestWhenOriginalContestIsPrivate: "(C0d3r5 can n07 b3 add3d in vir7ua1 c0n7357 wh3n 0rigina1 c0n7357 i5 priva73)",
  verdictAC: "(Acc3p73d)",
  verdictCE: "(C0mpi1a7i0n 3rr0r)",
  verdictFO: "(Run7im3 3rr0r (r357ric73d func7i0n))",
  verdictHelpAC: "(Y0ur pr0gram i5 c0rr3c7!)",
  verdictHelpCE: "(Y0ur pr0gram fai13d 70 c0mpi13. P13a53 c1ick 0n 7h3 \"D37ai15\" bu770n 70 533 7h3 c0mpi1a7i0n 3rr0r.)",
  verdictHelpDisqualified: "(A judg3 ha5 manua11y di5qua1ifi3d 7hi5 5ubmi55i0n)",
  verdictHelpFO: "(Y0ur pr0gram 7ri3d 70 p3rf0rm an 0p3ra7i0n n07 a110w3d by 7h3 5andb0x. Typica11y 7hi5 i5 cau53d by ca11ing 5y573m().)",
  verdictHelpJE: "(S0m37hing w3n7 wr0ng 0n 0ur 3nd, and i7'5 n07 y0ur fau17. S0m30n3 ha5 b33n n07ifi3d and 5h0u1d b3 fix3d 5h0r71y. P13a53 d0 n07 r3-5ubmi7 5inc3 y0u wi11 0n1y mak3 7h3 pr0b13m w0r53 and migh7 b3 p3na1iz3d.)",
  verdictHelpKarelRTE: "(Kar31 cra5h3d in70 a wa11, 0r ran 0u7 0f b33p3r5.)",
  verdictHelpKarelTLE: "(Kar31 mad3 700 many 573p5.)",
  verdictHelpML: "(Y0ur pr0gram 7ri3d 70 u53 m0r3 m3m0ry 7han wha7 7h3 pr0b13m a110w5. Try 7hinking 0f an a1g0ri7hm 7ha7 u535 1355 m3m0ry.)",
  verdictHelpMLE: "(Y0ur pr0gram 7ri3d 70 u53 m0r3 m3m0ry 7han wha7 7h3 pr0b13m a110w5. Try 7hinking 0f an a1g0ri7hm 7ha7 u535 1355 m3m0ry.)",
  verdictHelpOL: "(Y0ur pr0gram pr0duc3d an an5w3r 7ha7 i5 wr0ng in a7 13a57 0n3 ca53. A5 a hin7, y0u 7ri3d 70 prin7 way 700 much 0u7pu7.)",
  verdictHelpOLE: "(Y0ur pr0gram pr0duc3d an an5w3r 7ha7 i5 wr0ng in a7 13a57 0n3 ca53. A5 a hin7, y0u 7ri3d 70 prin7 way 700 much 0u7pu7.)",
  verdictHelpPA: "(Y0ur pr0gram c0rr3c71y 501v3d 50m3 0f 7h3 ca535, bu7 had a7 13a57 0n3 wr0ng ca53.)",
  verdictHelpRE: "(Y0ur pr0gram 73rmina73d un3xp3c73d1y (cra5h3d). M057 1ik31y y0u fai13d 70 c0n5id3r a7 13a57 0n3 p055ib13 ca53. Thi5 i5 7ypica11y cau53d by acc355ing an inva1id 313m3n7 0f an array, running 0u7 0f 57ack 5pac3, 0r 7rying 70 d3c1ar3 an array 7ha7 i5 way 700 big.)",
  verdictHelpRFE: "(Y0ur pr0gram 7ri3d 70 p3rf0rm an 0p3ra7i0n n07 a110w3d by 7h3 5andb0x. Typica11y 7hi5 i5 cau53d by ca11ing 5y573m().)",
  verdictHelpRTE: "(Y0ur pr0gram 73rmina73d un3xp3c73d1y (cra5h3d). M057 1ik31y y0u fai13d 70 c0n5id3r a7 13a57 0n3 p055ib13 ca53. Thi5 i5 7ypica11y cau53d by acc355ing an inva1id 313m3n7 0f an array, running 0u7 0f 57ack 5pac3, 0r 7rying 70 d3c1ar3 an array 7ha7 i5 way 700 big.)",
  verdictHelpTLE: "(Y0ur pr0gram i5 700 510w and fai13d 70 fini5h wi7hin 7h3 7im3 1imi7 0f 7h3 pr0b13m.)",
  verdictHelpTO: "(Y0ur pr0gram i5 700 510w and fai13d 70 fini5h wi7hin 7h3 7im3 1imi7 0f 7h3 pr0b13m.)",
  verdictHelpVE: "(S0m37hing w3n7 wr0ng wi7h 7h3 pr0b13m'5 va1ida70r, and i7 may 0r may n07 b3 y0ur fau17. M057 0f 7h3 7im3 7hi5 happ3n5 b3cau53 y0ur pr0gram mad3 50m37hing 7h3 va1ida70r didn'7 7ak3 in70 acc0un7, bu7 y0u 5h0u1d 137 7h3 pr0b13m wri73r / c0n7357 0rganiz3r kn0w ab0u7 7hi5.)",
  verdictHelpWA: "(Y0ur pr0gram fai13d 70 giv3 7h3 c0rr3c7 an5w3r f0r a11 ca535. M057y 1ik31y y0u fai13d 70 c0n5id3r 50m3 p055ib13 ca535.)",
  verdictJE: "(Judg3 3rr0r (d0 n07 r3-5ubmi7))",
  verdictML: "(M3m0ry 1imi7 3xc33d3d)",
  verdictMLE: "(M3m0ry 1imi7 3xc33d3d)",
  verdictOL: "(Wr0ng an5w3r (0u7pu7 1imi7 3xc33d3d))",
  verdictOLE: "(Wr0ng an5w3r (0u7pu7 1imi7 3xc33d3d))",
  verdictPA: "(Par7ia11y acc3p73d)",
  verdictRE: "(Run7im3 3rr0r)",
  verdictRFE: "(Run7im3 3rr0r (r357ric73d func7i0n))",
  verdictRTE: "(Run7im3 3rr0r)",
  verdictTLE: "(Tim3 1imi7 3xc33d3d)",
  verdictTO: "(Tim3 1imi7 3xc33d3d)",
  verdictVE: "(Va1ida70r 3rr0r (d0 n07 r3-5ubmi7))",
  verdictWA: "(Wr0ng An5w3r)",
  verificationEmailBody: "(W31c0m3 70 0m3gaUp! P13a53 c1ick 0n 7h3 f0110wing 1ink 70 10gin and v3rify y0ur 3mai1: <a hr3f=\"h77p5://0m3gaup.c0m/u53r/v3rify3mai1/%(verification_id)/\">h77p5://0m3gaup.c0m/u53r/v3rify3mai1/%(verification_id)/</a>)",
  verificationEmailSubject: "(W31c0m3 70 0m3gaUp!)",
  verificationEmailSuccessfully: "(Y0ur 3mai1 addr355 ha5 b33n v3rifi3d.)",
  verificationIdInvalid: "(Th3 pr0vid3d v3rifica7i0n inf0rma7i0n i5 n07 va1id.)",
  verificationParentalTokenGoToMyDependents: "(G0 70 my d3p3nd3n75)",
  virtualContest: "(Vir7ua1 c0n7357)",
  virtualContestSuffix: "(%(title) [vir7ua1])",
  virtualSuffix: "(%(username) [vir7ua1])",
  virtualTitle: "(%(title) - Vir7ua1 c0n7357)",
  warningPublicSolution: "(Warning: Th3 pr0b13m y0u ju57 add3d ha5 a pub1ic 501u7i0n.)",
  wizardDescription: "(F0110w 7h3 573p5 70 find 7h3 pr0b13m5 7ha7 in73r357 y0u!)",
  wizardLinkText: "(Pr0b13m Find3r)",
  wizardPriorityPopularity: "(P0pu1ari7y)",
  wizardStepOne: "(Ch0053 7h3 7h3m35 7ag(5))",
  wizardStepThree: "(S313c7 y0ur pri0ri7y)",
  wizardStepTwo: "(Pick 7h3 difficu17y rang3)",
  wizardTitle: "(Pr0b13m Find3r)",
  wordAccepted: "(Acc3p73d)",
  wordsActions: "(Ac7i0n5)",
  wordsAddAdmin: "(Add admin)",
  wordsAddIdentity: "(Add id3n7i7y)",
  wordsAddLecture: "(Add 13c7ur3)",
  wordsAddMember: "(Add m3mb3r)",
  wordsAddProblem: "(Add pr0b13m)",
  wordsAddStudent: "(Manag3 S7ud3n75)",
  wordsAddStudents: "(Add 57ud3n75)",
  wordsAddTag: "(Add Tag)",
  wordsAdmin: "(Admin)",
  wordsAgree: "(I agr33)",
  wordsAlias: "(A1ia5)",
  wordsAll: "(A11)",
  wordsAnswer: "(An5w3r)",
  wordsAnyLanguage: "(Any Languag3)",
  wordsArchiveCourse: "(Archiv3 c0ur53)",
  wordsBack: "(Back)",
  wordsBadgesObtained: "(Badg35 0b7ain3d)",
  wordsBadgesSeeAll: "(S33 a11 avai1ab13 badg35)",
  wordsBanProblem: "(Ban pr0b13m)",
  wordsBannedProblem: "(Bann3d pr0b13m)",
  wordsBestSolvers: "(B357 acc3p73d 501v3r5)",
  wordsBy: "(by)",
  wordsCancel: "(Canc31)",
  wordsCase: "(Ca53)",
  wordsCases: "(Ca535)",
  wordsClarifications: "(C1arifica7i0n)",
  wordsCloneContest: "(C10n3 c0n7357)",
  wordsCloneCourse: "(C10n3 c0ur53)",
  wordsCloneThisCourse: "(C10n3 7hi5 c0ur53)",
  wordsClose: "(C1053)",
  wordsCode: "(C0d3)",
  wordsCompilerOutput: "(C0mpi13r 0u7pu7)",
  wordsCompletedPercentage: "(P3rc3n7ag3 c0mp1373d)",
  wordsConfirm: "(C0nfirm)",
  wordsConsole: "(C0n5013)",
  wordsContent: "(C0n73n7)",
  wordsContentEdit: "(Edi7 c0n73n7)",
  wordsContentType: "(C0n73n7 7yp3)",
  wordsContest: "(C0n7357)",
  wordsContests: "(C0n73575)",
  wordsContestsResults: "(R35u175)",
  wordsCopyToClipboard: "(C0py 70 c1ipb0ard)",
  wordsCountry: "(C0un7ry)",
  wordsCountryRegion: "(C0un7ry / R3gi0n)",
  wordsCourseContent: "(C0ur53 c0n73n7)",
  wordsDangerZone: "(Dang3r Z0n3)",
  wordsDangerZoneDesc: "(D31373 7h3 pr0b13m.\n\nThi5 can 0n1y b3 d0n3 if 7h3 pr0b13m ha5 n07 b33n u53d in a c0ur53 0r c0n7357.\n\nY0u mu57 b3 v3ry 5ur3 7ha7 y0u wan7 70 d0 i7, b3cau53 7h3r3 i5 n0 way 70 r3c0v3r i7 0nc3 i7 i5 r3m0v3d.)",
  wordsDate: "(Da73)",
  wordsDelete: "(D31373)",
  wordsDeleted: "(D31373d)",
  wordsDenied: "(D3ni3d)",
  wordsDescription: "(D35crip7i0n)",
  wordsDetailed: "(D37ai13d)",
  wordsDetails: "(D37ai15)",
  wordsDifference: "(Diff3r3nc3)",
  wordsDifficulty: "(Difficu17y)",
  wordsDownload: "(D0wn10ad)",
  wordsDownloadCode: "(D0wn10ad c0d3)",
  wordsDownloadDetails: "(D0wn10ad .zip wi7h 0u7pu75)",
  wordsDownloadOutput: "(D0wn10ad 0u7pu7)",
  wordsDueDate: "(Du3 da73)",
  wordsDuration: "(L3ng7h)",
  wordsEdit: "(Edi7)",
  wordsEditCourse: "(Edi7 c0ur53)",
  wordsEmpty: "(Emp7y)",
  wordsEmptyAddStudentInput: "(Th3 inpu7 fi31d i5 3mp7y, p13a53 7yp3 a acc0un7 nam3)",
  wordsEnable: "(Enab13)",
  wordsEndTime: "(End)",
  wordsEndTimeContest: "(End 7im3)",
  wordsEnglish: "(Eng1i5h)",
  wordsExam: "(Exam)",
  wordsExecution: "(Ex3cu7i0n)",
  wordsExperiments: "(Exp3rim3n75)",
  wordsExtraWallTimeMs: "(Ex7ra 7im3 f0r 1ibin73rac7iv3 (m5))",
  wordsFeedback: "(F33dback)",
  wordsFilterByCountry: "(Fi173r by my c0un7ry / r3gi0n)",
  wordsFilterByHomework: "(Fi173r by h0m3w0rk)",
  wordsFilterByLanguage: "(Fi173r by 1anguag3)",
  wordsFilterByProblem: "(Fi173r by pr0b13m)",
  wordsFilterBySchool: "(Fi173r by my 5ch001)",
  wordsFilterByState: "(Fi173r by my 57a73)",
  wordsGender: "(G3nd3r)",
  wordsGenderDecline: "(Pr3f3r n07 70 5ay)",
  wordsGenderFemale: "(F3ma13)",
  wordsGenderMale: "(Ma13)",
  wordsGenderOther: "(O7h3r)",
  wordsGetToKnowOurCourses: "(G37 70 kn0w 0ur c0ur535!)",
  wordsGlobalSubmissions: "(G10ba1 5ubmi55i0n5)",
  wordsGroup: "(Gr0up)",
  wordsGroupAdmin: "(Admin gr0up)",
  wordsGroups: "(Gr0up5)",
  wordsHighQualityProblem: "(Thi5 pr0b13m ha5 b33n award3d a High Qua1i7y badg3 by a c0mmi7733 0f 0m3gaUp r3vi3w3r5)",
  wordsHomework: "(H0m3w0rk)",
  wordsID: "(ID)",
  wordsIdentities: "(Id3n7i7i35)",
  wordsIdentity: "(Id3n7i7y)",
  wordsInOut: "(Inpu7/Ou7pu7)",
  wordsInput: "(Inpu7)",
  wordsJudgedBy: "(Judg3d by)",
  wordsJustOutput: "(Ju57 0u7pu7)",
  wordsKarel: "(Kar31)",
  wordsKeepProblem: "(K33p pr0b13m)",
  wordsKeyword: "(K3yw0rd)",
  wordsKeywordSearch: "(S3arch by a1ia5, 7i713 0r pr0b13m id)",
  wordsLanguage: "(Languag3)",
  wordsLanguages: "(Languag35)",
  wordsLatestSubmissions: "(La7357 5ubmi55i0n5)",
  wordsLecture: "(L3c7ur3)",
  wordsLesson: "(L3550n)",
  wordsLevel: "(L3v31)",
  wordsLogs: "(L0g5)",
  wordsMember: "(M3mb3r)",
  wordsMemory: "(M3m0ry)",
  wordsMemoryInMebibytes: "(M3m0ry (MiB))",
  wordsMessage: "(M355ag3)",
  wordsMessageTo: "(M355ag3 70)",
  wordsMonths: "(M0n7h5)",
  wordsMultipleUser: "(Mu17ip13 acc0un75 (53para73d by c0mma5 0r 1in3 br3ak5))",
  wordsMyClarifications: "(My c1arifica7i0n5)",
  wordsMyContests: "(My C0n73575)",
  wordsMyScore: "(My 5c0r3)",
  wordsName: "(Nam3)",
  wordsNewClarification: "(N3w c1arifica7i0n)",
  wordsNewSubmissions: "(N3w 5ubmi55i0n)",
  wordsNext: "(N3x7)",
  wordsNextPage: "(N3x7 pag3)",
  wordsNo: "(N0)",
  wordsNoComment: "(N0 c0mm3n7)",
  wordsNoSubmissions: "(L3c7ur3 (N0 5ubmi55i0n5))",
  wordsNone: "(N0n3)",
  wordsNotApplicable: "(N/A)",
  wordsNumHomeworks: "(Num. 0f h0m3w0rk a55ignm3n75)",
  wordsNumTests: "(Num. 0f 73575)",
  wordsNumberOfContestants: "(Numb3r 0f c0n7357an75)",
  wordsOnlyExamples: "(On1y 3xamp135)",
  wordsOptional: "(Op7i0na1)",
  wordsOther: "(O7h3r)",
  wordsOutOf4: "(%(Score) 0u7 0f 4)",
  wordsOutput: "(Ou7pu7)",
  wordsPenalty: "(P3na17y)",
  wordsPending: "(P3nding)",
  wordsPendingRuns: "(P3nding run5)",
  wordsPercentage: "(P3rc3n7ag3)",
  wordsPoints: "(P0in75)",
  wordsPointsDistribution: "(P0in75 di57ribu7i0n f0r c0n7357: %(alias))",
  wordsPointsDistributionInIntervals: "(P0in75 di57ribu7i0n in in73rva15 0f 100)",
  wordsPointsDistributionProblem: "(P0in75 di57ribu7i0n f0r pr0b13m: %(alias))",
  wordsPointsForRank: "(P0in75 f0r ranking)",
  wordsPointsForRankTooltip: "(Th353 p0in75 r35pr353n7 7h3 ac7ua1 va1u3 0f 7hi5 pr0b13m. S01ving i7 wi11 d3cr3a53 i75 va1u3. F0r d37ai15 f0110w 7hi5 1ink.)",
  wordsPortuguese: "(P0r7ugu353)",
  wordsPractice: "(Prac7ic3)",
  wordsPrevPage: "(Pr3vi0u5 pag3)",
  wordsPrevious: "(Pr3vi0u5)",
  wordsPrivacyPolicy: "(Privacy P01icy)",
  wordsPrivacyPolicyAccepted: "(Y0u hav3 acc3p73d 7h3 privacy p01icy)",
  wordsPrivate: "(Priva73)",
  wordsPrivateTags: "(Priva73 7ag5)",
  wordsProblem: "(Pr0b13m)",
  wordsProblemOrSolutionNotExist: "(Th3 pr0b13m 0r 501u7i0n d0n'7 3xi57.)",
  wordsProblems: "(Pr0b13m5)",
  wordsProblemsetter: "(Up10ad3d by)",
  wordsProgress: "(Pr0gr355)",
  wordsProportion: "(Pr0p0r7i0n)",
  wordsPublic: "(Pub1ic)",
  wordsPublicTags: "(Pub1ic 7ag5)",
  wordsPublicUpdated: "(Upda73d)",
  wordsQuality: "(Qua1i7y)",
  wordsRanking: "(Ranking)",
  wordsRankingMeasurement: "(H0w d035 ranking w0rk?)",
  wordsRatio: "(Ra7i0)",
  wordsReadAgain: "(R3ad again)",
  wordsReadMore: "(R3ad m0r3)",
  wordsReason: "(R3a50n)",
  wordsRegistration: "(R3gi57ra7i0n/0p3n)",
  wordsRemoveFilter: "(R3m0v3 fi173r5)",
  wordsReportProblem: "(R3p0r7 pr0b13m)",
  wordsRequired: "(R3quir3d)",
  wordsReset: "(0m3gaUp: R3537 pa55w0rd.)",
  wordsResetMessage: "(C1ick 7h3 f0110wing 1ink 70 r3537 y0ur pa55w0rd: <a hr3f=\"[1ink]\">[1ink]</a><br><br>If y0u didn'7 r3qu357 7hi5 0p3ra7i0n p13a53 d0 n07 c1ick 7h3 1ink and mak3 5ur3 y0ur acc0un7 i5 5af3.)",
  wordsResult: "(An5w3r)",
  wordsReviewingProblem: "(R3vi3wing pr0b13m)",
  wordsRun: "(Run)",
  wordsRuns: "(Submi55i0n5)",
  wordsRuntime: "(Run7im3)",
  wordsSaveChanges: "(Sav3 chang35)",
  wordsSaveNewOrder: "(Sav3 n3w 0rd3r)",
  wordsSchool: "(Sch001)",
  wordsScore: "(Sc0r3)",
  wordsScoreboard: "(Sc0r3b0ard)",
  wordsSearch: "(S3arch)",
  wordsSearchBy: "(S3arch by)",
  wordsSeeCourse: "(S33 c0ur53)",
  wordsSeeGeneralRanking: "(S33 7h3 g3n3ra1 ranking)",
  wordsSeeLatestSubmissions: "(S33 1a7357 5ubmi55i0n5 53n7 by %(username))",
  wordsSeeSolution: "(S33 S01u7i0n)",
  wordsSelectFilter: "(S313c7 a fi173r)",
  wordsSend: "(S3nd)",
  wordsShowCasesDiff: "(Sh0w ca535 diff3r3nc35)",
  wordsShowSiteAdmins: "(Sh0w 5i73-admin5)",
  wordsSource: "(S0urc3)",
  wordsSpanish: "(Spani5h)",
  wordsStart: "(S7ar7)",
  wordsStartTime: "(S7ar7)",
  wordsStatistics: "(S7a7i57ic5)",
  wordsStatus: "(S7a7u5)",
  wordsSubmissionDate: "(Submi55i0n da73)",
  wordsSubmissions: "(Submi55i0n5)",
  wordsSubmissionsNotYetReviewed: "(Submi55i0n5 n07 y37 r3vi3w3d)",
  wordsSubmit: "(Submi7)",
  wordsSummary: "(Summary)",
  wordsTime: "(Da73 and Tim3)",
  wordsTimeInSeconds: "(Tim3 (S3c))",
  wordsTitle: "(Ti713)",
  wordsTotal: "(T07a1)",
  wordsTotalVotes: "(707a1 v0735)",
  wordsUnarchiveCourse: "(Unarchiv3 c0ur53)",
  wordsUnlimitedDuration: "(Un1imi73d dura7i0n)",
  wordsUnlockSolution: "(Un10ck S01u7i0n)",
  wordsUpdateLecture: "(Upda73 13c7ur3)",
  wordsUpdateProblem: "(Upda73 pr0b13m)",
  wordsUpload: "(Up10ad)",
  wordsUploadedOn: "(Pr0b13m up10ad3d 0n: %(date))",
  wordsUsersFeedback: "(C0d3r5 F33dback)",
  wordsVerdict: "(V3rdic7)",
  wordsVerdictsOf: "(V3rdic75 0f %(alias))",
  wordsWallTimeInSeconds: "(Wa11-7im3 (S3c))",
  wordsWarningProblem: "(K33p wi7h a warning)",
  wordsYes: "(Y35)",
  zipPrepare: "(Pr3par3 zip fi13)",
};

export {translations as default};